webpackJsonp([1],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module$exports;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

module.exports = (_module$exports = {
    ok: '確定',
    wky: '玩客雲',
    cancel: '取消',
    close: '關閉',
    yuan: '元',

    rule: 'Rule',
    note: 'Note',
    submit: 'Submit',
    qq: 'QQ number',
    phone: 'Cell phone number',
    delete: 'Delete',
    refresh: 'Refresh',
    netblock: 'Network is busy. Try again later.',
    view: 'View',
    more: 'More',
    less: 'Less',
    loadm: 'Load more',
    history: 'History',
    rtn: 'return',
    toofreq: 'Operation Too Frequent',
    isee: 'I see'
}, _defineProperty(_module$exports, 'cancel', 'Cancel'), _defineProperty(_module$exports, 'confirm', 'Confirm'), _defineProperty(_module$exports, 'onething_cloud', 'OneThing Cloud'), _defineProperty(_module$exports, 'open', 'Open'), _defineProperty(_module$exports, 'reload', 'Reload'), _defineProperty(_module$exports, 'lang', 'en'), _defineProperty(_module$exports, 'prompt', 'prompt'), _module$exports);

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ok: '确定',
    wky: '玩客云',
    cancel: '取消',
    close: '关闭',
    yuan: '元',

    rule: '规则',
    note: '说明',
    submit: '提交',
    qq: 'QQ号',
    delete: '删除',
    refresh: '刷新',
    view: '查看',
    more: '展开',
    less: '收起',
    loadm: '加载更多',
    history: '历史记录',
    phone: '手机号',
    rtn: '返回',
    toofreq: '操作太频繁了',
    isee: '知道了',

    confirm: '确认',
    onething_cloud: '玩客云',
    open: '打开',
    reload: '重新加载',
    lang: 'zh',
    prompt: '提示'
};

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SINGLE_ORDER_MAX_NUM = 1000; // 开放售卖 - 单笔订单最大数量
var configForbiddenAreaBySF = {
    areaId: ['652200'],
    areaName: ['哈密地区']
};

exports.SINGLE_ORDER_MAX_NUM = SINGLE_ORDER_MAX_NUM;
exports.configForbiddenAreaBySF = configForbiddenAreaBySF;

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.DiskContainer = exports.TipPop = exports.ColorSelector = exports.Countdown = exports.ColorPic = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.jumpToLogin = jumpToLogin;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

var _purchase = __webpack_require__(50);

var _purchase2 = _interopRequireDefault(_purchase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorPic = exports.ColorPic = function (_Component) {
	_inherits(ColorPic, _Component);

	function ColorPic(props) {
		_classCallCheck(this, ColorPic);

		return _possibleConstructorReturn(this, (ColorPic.__proto__ || Object.getPrototypeOf(ColorPic)).call(this, props));
	}

	_createClass(ColorPic, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			//script标签直接引入swiper文件
			var galleryTop = new Swiper('.gallery-top', {
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				}
			});
			var galleryThumbs = new Swiper('.gallery-thumbs', {
				centeredSlides: true,
				slidesPerView: 5,
				touchRatio: 0.2,
				slideToClickedSlide: true
			});
			galleryTop.controller.control = galleryThumbs;
			galleryThumbs.controller.control = galleryTop;
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    currColor = _props.currColor,
			    hasSoldout = _props.hasSoldout;

			var picListDom = function picListDom(isBigPic) {
				var listConfig = [1, 2, 3, 4, 5];
				var name = isBigPic ? '' : '_sml';
				var list = listConfig.map(function (index) {
					return _react2.default.createElement(
						'li',
						{ className: 'swiper-slide', key: index },
						_react2.default.createElement('img', { src: '../../images/purchase/products/pic_' + currColor + name + '_' + index + '.jpg', alt: '' })
					);
				});
				return _react2.default.createElement(
					'ul',
					{ className: 'swiper-wrapper' },
					list,
					'}'
				);
			};

			var soldOutDom = hasSoldout ? _react2.default.createElement(
				'div',
				{ className: 'np-feature-none' },
				_react2.default.createElement(
					'div',
					{ className: 'np-feature-none-tb' },
					_react2.default.createElement(
						'p',
						null,
						(0, _purchase2.default)('pic_soldout')
					),
					_react2.default.createElement(
						'a',
						{ href: (0, _utils.createUrl)('site/index'), target: '_blank' },
						(0, _purchase2.default)('more'),
						' >'
					)
				)
			) : null;

			return _react2.default.createElement(
				'div',
				{ className: 'np-buy-feature' },
				_react2.default.createElement(
					'div',
					{ className: 'np-feature-big' },
					_react2.default.createElement(
						'div',
						{ className: 'swiper-container gallery-top swiper-container-horizontal' },
						picListDom(true),
						_react2.default.createElement('div', { className: 'swiper-pagination swiper-pagination-clickable swiper-pagination-bullets' })
					),
					soldOutDom
				),
				_react2.default.createElement(
					'div',
					{ className: 'np-feature-bullet' },
					_react2.default.createElement(
						'div',
						{ className: 'swiper-container gallery-thumbs swiper-container-horizontal' },
						picListDom(false)
					)
				)
			);
		}
	}]);

	return ColorPic;
}(_react.Component);

ColorPic.propTypes = {
	currColor: _react.PropTypes.string.isRequired
};
ColorPic.defaultProps = {
	hasSoldout: false
};

var Countdown = exports.Countdown = function (_Component2) {
	_inherits(Countdown, _Component2);

	function Countdown() {
		_classCallCheck(this, Countdown);

		return _possibleConstructorReturn(this, (Countdown.__proto__ || Object.getPrototypeOf(Countdown)).apply(this, arguments));
	}

	_createClass(Countdown, [{
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    currTime = _props2.currTime,
			    targetTime = _props2.targetTime,
			    desc = _props2.desc;

			if (!currTime || !targetTime) return null;
			var time = (0, _utils.surplusTime)(currTime, targetTime);

			var _desc$split = desc.split('|'),
			    _desc$split2 = _slicedToArray(_desc$split, 2),
			    desc1 = _desc$split2[0],
			    desc2 = _desc$split2[1];

			return _react2.default.createElement(
				'div',
				{ className: 'np-buy-seckill' },
				desc1,
				_react2.default.createElement(
					'em',
					null,
					desc2,
					time.day > 0 ? _react2.default.createElement(
						'span',
						null,
						time.day,
						(0, _purchase2.default)('date_day')
					) : null,
					_react2.default.createElement(
						'span',
						null,
						time.hour,
						(0, _purchase2.default)('date_hour')
					),
					_react2.default.createElement(
						'span',
						null,
						time.minute,
						(0, _purchase2.default)('date_minute')
					),
					_react2.default.createElement(
						'span',
						null,
						time.second,
						(0, _purchase2.default)('date_second')
					)
				)
			);
		}
	}]);

	return Countdown;
}(_react.Component);

Countdown.propTypes = {
	currTime: _react.PropTypes.instanceOf(Date).isRequired,
	targetTime: _react.PropTypes.instanceOf(Date),
	type: _react.PropTypes.string
};
Countdown.defaultProps = {
	desc: ''
};

var ColorSelector = exports.ColorSelector = function (_Component3) {
	_inherits(ColorSelector, _Component3);

	function ColorSelector(props) {
		_classCallCheck(this, ColorSelector);

		var _this3 = _possibleConstructorReturn(this, (ColorSelector.__proto__ || Object.getPrototypeOf(ColorSelector)).call(this, props));

		_this3.switchColor = _this3.switchColor.bind(_this3);
		return _this3;
	}

	_createClass(ColorSelector, [{
		key: 'switchColor',
		value: function switchColor(e) {
			this.props.onChange($(e.currentTarget).data('color'));
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var _props3 = this.props,
			    colorConfig = _props3.colorConfig,
			    currColor = _props3.currColor,
			    showZeroColor = _props3.showZeroColor;

			var colorCls = {
				black: 'np-dot-black',
				blue: 'np-dot-blue',
				orange: 'np-dot-org'
			};
			return _react2.default.createElement(
				'div',
				{ className: 'np-buy-unit' },
				_react2.default.createElement(
					'dl',
					{ className: 'np-buy-color' },
					_react2.default.createElement(
						'dt',
						null,
						(0, _purchase2.default)('notifi_selectcolor')
					),
					colorConfig.map(function (item) {
						var ret = null;
						if (item.has) {
							ret = _react2.default.createElement(
								'dd',
								{ className: currColor == item.color ? 'np-selected' : '', key: item.color, onClick: _this4.switchColor, 'data-color': item.color },
								_react2.default.createElement('i', { className: colorCls[item.color] }),
								item.text
							);
						} else if (showZeroColor) {
							ret = _react2.default.createElement(
								'dd',
								{ className: 'np-buy-soldout', key: item.color, 'data-color': item.color },
								_react2.default.createElement('i', { className: colorCls[item.color] }),
								item.text,
								(0, _purchase2.default)('colorcom_zero')
							);
						}
						return ret;
					})
				)
			);
		}
	}]);

	return ColorSelector;
}(_react.Component);

ColorSelector.propTypes = {
	colorConfig: _react.PropTypes.array.isRequired,
	currColor: _react.PropTypes.string.isRequired,
	onChange: _react.PropTypes.func.isRequired
};
ColorSelector.defaultProps = {
	showZeroColor: true

	/**
  * 消息弹窗
  * 
  * @export
  * @class TipPop
  * @extends {Component}
  * msg——弹窗主体内容，支持html元素
  * jump—— 如果存在，并为函数，则点击执行自定义函数
  * 		  如果存在，并且为字符串，则点击跳转到自定义链接
  * 		  其他情况，默认确认按钮为关闭弹窗
  * onClose——如果为函数，则为关闭弹窗的回调函数
  * 			如果为false，则不设置确认按钮和关闭按钮
  * btnTxt——按钮文字 
  * 
  */
};
var TipPop = exports.TipPop = function (_Component4) {
	_inherits(TipPop, _Component4);

	function TipPop(props) {
		_classCallCheck(this, TipPop);

		var _this5 = _possibleConstructorReturn(this, (TipPop.__proto__ || Object.getPrototypeOf(TipPop)).call(this, props));

		_this5.btnRender = _this5.btnRender.bind(_this5);
		return _this5;
	}

	_createClass(TipPop, [{
		key: 'btnRender',
		value: function btnRender() {
			var _props4 = this.props,
			    jump = _props4.jump,
			    onClose = _props4.onClose,
			    btnTxt = _props4.btnTxt;

			var jumpType = jump && (typeof jump === 'undefined' ? 'undefined' : _typeof(jump));
			var noBtnRender = function noBtnRender() {
				return _react2.default.createElement('div', { className: 'oc-pop-btnbox' });
			};
			var btnRenderInner = function btnRenderInner() {
				var submitBtn = function submitBtn() {
					if (jumpType == 'function') {
						return _react2.default.createElement(
							'a',
							{ href: 'javascript:;', className: 'btn-oc', onClick: function onClick() {
									jump();onClose();
								} },
							btnTxt
						);
					} else if (jumpType == 'string') {
						if (jump == 'cart') return _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'a',
								{ href: 'javascript:;', className: 'btn-oc btn-oc-line', onClick: onClose },
								'\u7EE7\u7EED\u8D2D\u7269'
							),
							_react2.default.createElement(
								'a',
								{ href: '/site/cart.html', className: 'btn-oc' },
								'\u67E5\u770B\u8D2D\u7269\u8F66'
							)
						);
						return _react2.default.createElement(
							'a',
							{ href: jump, className: 'btn-oc' },
							btnTxt
						);
					} else {
						return _react2.default.createElement(
							'a',
							{ href: 'javascript:;', className: 'btn-oc', onClick: onClose },
							btnTxt
						);
					}
				};
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'oc-pop-btnbox' },
						submitBtn()
					),
					_react2.default.createElement(
						'a',
						{ href: 'javascript:;', className: 'oc-pop-close', onClick: onClose },
						(0, _purchase2.default)('close')
					)
				);
			};
			return onClose ? btnRenderInner() : noBtnRender();
		}
	}, {
		key: 'render',
		value: function render() {
			var _props5 = this.props,
			    msg = _props5.msg,
			    jump = _props5.jump,
			    onClose = _props5.onClose,
			    btnTxt = _props5.btnTxt;

			var dangerousInnerHTML = {
				__html: msg
			};
			return _react2.default.createElement(
				'div',
				{ className: 'oc-pop' },
				_react2.default.createElement(
					'div',
					{ className: 'oc-pop-wp' },
					_react2.default.createElement(
						'div',
						{ className: 'oc-pop-textbox oc-tb' },
						_react2.default.createElement('div', { className: 'oc-pop-text oc-tb-cell',
							dangerouslySetInnerHTML: dangerousInnerHTML })
					),
					this.btnRender()
				)
			);
		}
	}]);

	return TipPop;
}(_react.Component);

TipPop.defaultProps = {
	msg: 'hello breeze',
	jump: '',
	onClose: function onClose() {
		return function () {};
	},
	btnTxt: (0, _purchase2.default)('ok')
};

function jumpToLogin() {
	location.href = (0, _utils.createUrl)('html/login') + '?jumpurl=' + encodeURIComponent(location.href);
}

var DiskContainer = exports.DiskContainer = function (_Component5) {
	_inherits(DiskContainer, _Component5);

	function DiskContainer(props) {
		_classCallCheck(this, DiskContainer);

		var _this6 = _possibleConstructorReturn(this, (DiskContainer.__proto__ || Object.getPrototypeOf(DiskContainer)).call(this, props));

		_this6.handleDiskDetailClick = function () {
			_this6.setState({ showDiskDetail: !_this6.state.showDiskDetail });
		};

		_this6.handleDiskChange = function () {
			_this6.setState({ diskChecked: !_this6.state.diskChecked }, _this6.updateDiskData);
		};

		_this6.state = {
			showDiskDetail: false,
			diskChecked: false
		};
		return _this6;
	}

	_createClass(DiskContainer, [{
		key: 'updateDiskData',
		value: function updateDiskData() {
			var diskChecked = this.state.diskChecked;

			this.props.updateDiskData({ diskChecked: diskChecked });
		}
	}, {
		key: 'render',
		value: function render() {
			var _props6 = this.props,
			    diskPrice = _props6.diskPrice,
			    diskCount = _props6.diskCount,
			    updateDiskData = _props6.updateDiskData;
			var _state = this.state,
			    showDiskDetail = _state.showDiskDetail,
			    diskChecked = _state.diskChecked;

			var diskDiscountPrice = diskPrice - diskCount;
			var foldCls = showDiskDetail ? 'i-np-fold i-np-unfold' : 'i-np-fold';

			return _react2.default.createElement(
				'div',
				{ className: 'np-buy-groups' },
				_react2.default.createElement(
					'h3',
					null,
					'\u8BF7\u9009\u62E9\u642D\u914D\u79FB\u52A8\u786C\u76D8'
				),
				_react2.default.createElement(
					'div',
					{ className: 'np-buy-groups-item' },
					_react2.default.createElement(
						'div',
						{ className: 'np-buy-gibox' },
						_react2.default.createElement(
							'div',
							{ className: 'np-checkbox' },
							_react2.default.createElement('input', { type: 'checkbox', checked: diskChecked, onChange: this.handleDiskChange }),
							_react2.default.createElement('i', { className: 'i-np-check' })
						),
						_react2.default.createElement('img', { src: '../../images/purchase/disk_sml.png', alt: '', onClick: this.handleDiskChange }),
						_react2.default.createElement(
							'div',
							{ className: 'np-buy-gi-theme', onClick: this.handleDiskChange },
							_react2.default.createElement(
								'h4',
								null,
								'\u5E0C\u63772TB\u9ED1\u94BB\u79FB\u52A8\u786C\u76D8'
							),
							_react2.default.createElement(
								'div',
								{ className: 'np-buy-gi-price' },
								_react2.default.createElement(
									'em',
									null,
									diskDiscountPrice,
									'\u5143'
								),
								_react2.default.createElement(
									'del',
									null,
									diskPrice,
									'\u5143'
								)
							)
						),
						_react2.default.createElement(
							'em',
							{ className: 'np-lbl-discount' },
							_react2.default.createElement(
								'i',
								null,
								'\u7701',
								diskCount,
								'\u5143'
							)
						),
						_react2.default.createElement('i', { id: 'fold', className: foldCls, title: '\u67E5\u770B\u8BE6\u60C5', onClick: this.handleDiskDetailClick })
					),
					showDiskDetail && _react2.default.createElement(DiskDetail, null)
				)
			);
		}
	}]);

	return DiskContainer;
}(_react.Component);

var DiskDetail = function DiskDetail() {
	return _react2.default.createElement(
		'div',
		{ className: 'np-buy-groups-detail' },
		_react2.default.createElement(
			'div',
			{ className: 'np-buy-groups-detail-tb' },
			_react2.default.createElement(
				'h4',
				null,
				'\u4E3B\u4F53'
			),
			_react2.default.createElement(
				'table',
				null,
				_react2.default.createElement(
					'tbody',
					null,
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u54C1\u724C'
						),
						_react2.default.createElement(
							'td',
							null,
							'\u5E0C\u6377 Seagate'
						)
					),
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u7CFB\u5217'
						),
						_react2.default.createElement(
							'td',
							null,
							'Expansion'
						)
					),
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u578B\u53F7'
						),
						_react2.default.createElement(
							'td',
							null,
							'STEA2000400'
						)
					),
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u7C7B\u578B'
						),
						_react2.default.createElement(
							'td',
							null,
							'\u4FBF\u643A\u5F0F\u5B58\u50A8'
						)
					),
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u5916\u58F3\u989C\u8272'
						),
						_react2.default.createElement(
							'td',
							null,
							'\u9ED1\u8272'
						)
					),
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u5916\u58F3\u6750\u8D28'
						),
						_react2.default.createElement(
							'td',
							null,
							'\u5851\u6599'
						)
					)
				)
			)
		),
		_react2.default.createElement(
			'div',
			{ className: 'np-buy-groups-detail-tb' },
			_react2.default.createElement(
				'h4',
				null,
				'\u89C4\u683C'
			),
			_react2.default.createElement(
				'table',
				null,
				_react2.default.createElement(
					'tbody',
					null,
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u5BB9\u91CF'
						),
						_react2.default.createElement(
							'td',
							null,
							'2TB'
						)
					),
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u5916\u90E8\u8F93\u51FA\u63A5\u53E3'
						),
						_react2.default.createElement(
							'td',
							null,
							'USB3.0'
						)
					),
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u7CFB\u7EDF\u8981\u6C42'
						),
						_react2.default.createElement(
							'td',
							null,
							'Win10\uFF1Bwin7\uFF1Bwin8'
						)
					),
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u786C\u76D8\u5C3A\u5BF8'
						),
						_react2.default.createElement(
							'td',
							null,
							'2.5\u82F1\u5BF8'
						)
					),
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u6307\u793A\u706F'
						),
						_react2.default.createElement(
							'td',
							null,
							'\u6709'
						)
					),
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u5C3A\u5BF8\uFF08mm\uFF09'
						),
						_react2.default.createElement(
							'td',
							null,
							'117*80*14.8mm'
						)
					),
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'th',
							null,
							'\u91CD\u91CF\uFF08g\uFF09'
						),
						_react2.default.createElement(
							'td',
							null,
							'170g'
						)
					)
				)
			)
		),
		_react2.default.createElement(
			'div',
			{ className: 'np-buy-groups-detail-tb' },
			_react2.default.createElement(
				'h4',
				null,
				'\u5305\u88C5\u6E05\u5355'
			),
			_react2.default.createElement(
				'p',
				{ className: 'np-buy-groups-detail-sum' },
				'\u79FB\u52A8\u786C\u76D8x1\u3001USB 3.0\u8FDE\u63A5\u7EBF x1\u3001\u5FEB\u901F\u5165\u95E8\u6307\u5357 x1'
			)
		)
	);
};

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BlueCounterInOpensale = exports.BlackCounterInOpensale = exports.OrangeCounterInOpensale = exports.DiskCounterInOpensale = exports.BlueCounterInEnterprise = exports.BlackCounterInEnterprise = exports.OrangeCounterInEnterprise = exports.DiskCounterInEnterprise = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _saleConfig = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Addition = function Addition(_ref) {
    var value = _ref.value,
        maxValue = _ref.maxValue,
        changeValue = _ref.changeValue,
        sellout = _ref.sellout;

    var buttonForbidden = value >= maxValue;
    var clickHandler = function clickHandler() {
        !sellout && !buttonForbidden && changeValue(++value);
    };
    return _react2.default.createElement(
        'em',
        { className: buttonForbidden || sellout ? 'np-add np-num-disable' : 'np-add', onClick: clickHandler },
        '+'
    );
};
var Subtraction = function Subtraction(_ref2) {
    var value = _ref2.value,
        minValue = _ref2.minValue,
        changeValue = _ref2.changeValue,
        sellout = _ref2.sellout;

    var buttonForbidden = value <= minValue;
    var clickHandler = function clickHandler() {
        !sellout && !buttonForbidden && changeValue(--value);
    };
    return _react2.default.createElement(
        'em',
        { className: value <= minValue || sellout ? 'np-minus np-num-disable' : 'np-minus', onClick: clickHandler },
        '-'
    );
};

function createCounter(type, min, max) {
    return function (_Component) {
        _inherits(DiskCount, _Component);

        function DiskCount(props) {
            _classCallCheck(this, DiskCount);

            var _this = _possibleConstructorReturn(this, (DiskCount.__proto__ || Object.getPrototypeOf(DiskCount)).call(this, props));

            _this.state = {
                min: min,
                max: max,
                type: type
            };
            _this.changeHandler = _this.changeHandler.bind(_this);
            return _this;
        }

        _createClass(DiskCount, [{
            key: 'changeHandler',
            value: function changeHandler(e) {
                var changeShoppingList = this.props.changeShoppingList;
                var _state = this.state,
                    min = _state.min,
                    max = _state.max,
                    type = _state.type;

                var changeHandlerInDiskCount = changeShoppingList.bind(null, type);
                var newValue = e.target.value;
                if (newValue < min) {
                    changeHandlerInDiskCount(min);
                } else if (newValue > max) {
                    changeHandlerInDiskCount(max);
                } else {
                    changeHandlerInDiskCount(newValue);
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _props = this.props,
                    value = _props.value,
                    changeShoppingList = _props.changeShoppingList,
                    sellout = _props.sellout;
                var _state2 = this.state,
                    min = _state2.min,
                    max = _state2.max;

                var changeHandlerByType = changeShoppingList.bind(null, type);
                return _react2.default.createElement(
                    'div',
                    { className: 'np-select-item-num' },
                    _react2.default.createElement(Subtraction, { value: value, minValue: min, changeValue: changeHandlerByType, sellout: sellout }),
                    _react2.default.createElement('input', { type: 'number', value: value, onChange: this.changeHandler, disabled: sellout }),
                    _react2.default.createElement(Addition, { value: value, maxValue: max, changeValue: changeHandlerByType, sellout: sellout })
                );
            }
        }]);

        return DiskCount;
    }(_react.Component);
}

var DiskCounterInEnterprise = exports.DiskCounterInEnterprise = createCounter('diskCount', 0, 50000);
var OrangeCounterInEnterprise = exports.OrangeCounterInEnterprise = createCounter('orange', 0, 50000);
var BlackCounterInEnterprise = exports.BlackCounterInEnterprise = createCounter('black', 0, 50000);
var BlueCounterInEnterprise = exports.BlueCounterInEnterprise = createCounter('blue', 0, 50000);
var DiskCounterInOpensale = exports.DiskCounterInOpensale = createCounter('diskCount', 0, 150);
var OrangeCounterInOpensale = exports.OrangeCounterInOpensale = createCounter('orange', 0, _saleConfig.SINGLE_ORDER_MAX_NUM);
var BlackCounterInOpensale = exports.BlackCounterInOpensale = createCounter('black', 0, _saleConfig.SINGLE_ORDER_MAX_NUM);
var BlueCounterInOpensale = exports.BlueCounterInOpensale = createCounter('blue', 0, _saleConfig.SINGLE_ORDER_MAX_NUM);

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * SSR Window 1.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2018, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 10, 2018
 */
var d;
if (typeof document === 'undefined') {
  d = {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: ''
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {}
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        }
      };
    },
    location: { hash: '' }
  };
} else {
  // eslint-disable-next-line
  d = document;
}

var doc = d;

var w;
if (typeof window === 'undefined') {
  w = {
    document: doc,
    navigator: {
      userAgent: ''
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        }
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {}
  };
} else {
  // eslint-disable-next-line
  w = window;
}

var win = w;

exports.window = win;
exports.document = doc;

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.cartAjax = cartAjax;
exports.getConfigPrice = getConfigPrice;
exports.saveCartInfos = saveCartInfos;
exports.affirmCartInfos = affirmCartInfos;
exports.getCartDataFromBackEnd = getCartDataFromBackEnd;
exports.checklogin = checklogin;
exports.getOriginSelected = getOriginSelected;
exports.getOriginPrice = getOriginPrice;
exports.defaultCartData = defaultCartData;
exports.getOriginData = getOriginData;
exports.dataCombiner = dataCombiner;
exports.shoppingCartDelete = shoppingCartDelete;
exports.addToShoppingCart = addToShoppingCart;
exports.syncData = syncData;
exports.makeCartListInNav = makeCartListInNav;
exports.numFormat = numFormat;
exports.myStorageSteItem = myStorageSteItem;

var _utils = __webpack_require__(1);

var _saleConfig = __webpack_require__(12);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function cartAjax(opts) {
    var path = opts.path,
        _opts$type = opts.type,
        type = _opts$type === undefined ? 'POST' : _opts$type,
        data = opts.data,
        success = opts.success,
        error = opts.error,
        others = _objectWithoutProperties(opts, ['path', 'type', 'data', 'success', 'error']);

    var _data = type.toLowerCase() === 'post' ? _extends({ csrf_token: (0, _utils.getCookie)('csrf_token') }, data) : data;
    $.ajax(_extends({
        url: '//api-content.onethingcloud.com/cn/' + path,
        type: type,
        data: _data,
        success: success || function (result) {
            console.log(result);
        },
        error: error || function (err) {
            console.log(err);
        },
        crossDomain: true,
        xhrFields: { withCredentials: true },
        cache: false,
        ifModified: true
    }, others));
}
function getConfigPrice(success, fail) {
    cartAjax({
        path: 'opensale/getconfig',
        success: success,
        fail: fail
    });
}
function saveCartInfos(data, success) {
    cartAjax({
        path: 'shoppingcart/add',
        data: {
            black_num: data.black,
            orange_num: data.orange,
            blue_num: data.blue,
            hd_num: data.disk
        },
        success: success
    });
}
function affirmCartInfos(data, success) {
    cartAjax({
        path: 'shoppingcart/affirm',
        data: {
            black_num: data.black,
            orange_num: data.orange,
            blue_num: data.blue,
            hd_num: data.disk
        },
        success: success
    });
}
function getCartDataFromBackEnd(success, fail) {
    cartAjax({
        path: 'shoppingcart/list',
        success: success,
        fail: fail
    });
}
function checklogin(success) {
    cartAjax({
        path: 'user/checklogin',
        success: success
    });
}
function getOriginSelected() {
    if (!localStorage.getItem('cartSelected')) {
        return {
            black: true,
            blue: true,
            orange: true,
            disk: true
        };
    } else {
        return JSON.parse(localStorage.getItem('cartSelected')).data;
    }
}
function getOriginPrice() {
    var price = sessionStorage.getItem('wkyprice');
    return price ? JSON.parse(price) : {
        wky: 599,
        disk: 519,
        discount: 0
    };
}
function defaultCartData() {
    return {
        black: 0,
        blue: 0,
        orange: 0,
        disk: 0
    };
}
function getOriginData() {
    if (!localStorage.getItem('cartData')) {
        return {
            black: 0,
            blue: 0,
            orange: 0,
            disk: 0
        };
    } else {
        return JSON.parse(localStorage.getItem('cartData')).data;
    }
}

function dataCombiner(storage, backend) {
    var black = storage.black + backend.black_num;
    var blue = storage.blue + backend.blue_num;
    var orange = storage.orange + backend.orange_num;
    var disk = storage.disk + backend.hd_num;

    return {
        black: black,
        blue: blue,
        orange: orange,
        disk: disk
    };
}

function shoppingCartDelete(_ref) {
    var black = _ref.black,
        blue = _ref.blue,
        orange = _ref.orange;

    var numbers = getOriginData();
    var newNumbers = {
        black: black ? 0 : numbers.black,
        blue: blue ? 0 : numbers.blue,
        orange: orange ? 0 : numbers.orange,
        disk: 0
    };
    syncData(newNumbers);
}

function addToShoppingCart(data, success, pop) {
    var numbers = getOriginData();
    var newNumbers = {
        black: numbers.black + data.black,
        blue: numbers.blue + data.blue,
        orange: numbers.orange + data.orange,
        disk: numbers.disk + data.disk
    };
    if (newNumbers.black + newNumbers.blue + newNumbers.orange > _saleConfig.SINGLE_ORDER_MAX_NUM) {
        pop('\u8D85\u8FC7' + _saleConfig.SINGLE_ORDER_MAX_NUM + '\u6570\u91CF\u9650\u5236');
        return;
    }
    syncData(newNumbers, success);
}

function syncData(numbers, callback) {
    saveCartInfos(numbers, function (res) {
        callback && callback(res);
        if (res.iRet == 0 || res.iRet == -501) {
            myStorageSteItem('cartData', JSON.stringify({ data: numbers }));
        }
    });
}

function makeCartListInNav(numbers) {
    var price = getOriginPrice();
    var selected = getOriginSelected();
    var selectedblack = selected.black ? numbers.black : 0;
    var selectedblue = selected.blue ? numbers.blue : 0;
    var selectedorange = selected.orange ? numbers.orange : 0;
    var selectedNumber = selectedblack + selectedblue + selectedorange; //满减数量不包括disk

    return [{
        type: 'black',
        name: '玩客云 曜石黑',
        price: price.wky,
        image: '../../images/purchase/oc_pro_1.jpg',
        number: numbers.black
    }, {
        type: 'blue',
        name: '玩客云 科技蓝',
        price: price.wky,
        image: '../../images/purchase/oc_pro_3.jpg',
        number: numbers.blue
    }, {
        type: 'orange',
        name: '玩客云 爱马仕橙',
        price: price.wky,
        image: '../../images/purchase/oc_pro_2.jpg',
        number: numbers.orange
    }, {
        type: 'discount',
        name: '每满599元立减300元',
        // name: '每满599元立减119元',
        price: price.discount,
        number: selectedNumber
    }, {
        type: 'disk',
        name: '希捷2TB黑钻移动硬盘',
        price: price.disk,
        image: '../../images/purchase/disk_sml.png',
        number: numbers.disk
    }];
}

function numFormat(num) {
    var c = num.toString().indexOf('.') !== -1 ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    return c;
}

function myStorageSteItem(key, newValue) {
    var event = $.Event("setItemEvent");
    event.newValue = newValue;
    event.key = key;
    $(window).trigger(event);
    localStorage.setItem(key, newValue);
}

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.commonApi = exports.ONECLOUD_API_HOST = exports.ZQB_HOST = exports.GRAB_URL = exports.API_HOST = undefined;

var _utils = __webpack_require__(1);

var protocal = (0, _utils.getProtocol)();

var API_HOST = exports.API_HOST = protocal + 'wk-cgi.content.xunlei.com'; // 只有grabcode页面在用
var GRAB_URL = exports.GRAB_URL = API_HOST + '/wanke/?m=vceu0c9'; // 只有grabcode页面在用
var ZQB_HOST = exports.ZQB_HOST = 'http://zqb.red.xunlei.com'; // 只有exchange页面在用

var lang = (0, _utils.getLang)();
var apiSuffix = lang === 'cn' ? '' : '-' + lang;
var ONECLOUD_API_HOST = exports.ONECLOUD_API_HOST = protocal + 'api' + apiSuffix + '-content.onethingcloud.com/' + window.LANG;

var commonApi = exports.commonApi = {
    checklogin: ONECLOUD_API_HOST + '/user/checklogin',
    freshImgCode: ONECLOUD_API_HOST + '/captcha/refresh',
    // getconfig: `${ONECLOUD_API_HOST}/opensale/getconfig`,
    // commit: `${ONECLOUD_API_HOST}/opensale/commit`,
    usercouponlist: ONECLOUD_API_HOST + '/coupon/userCouponList',
    uploadImage: ONECLOUD_API_HOST + '/upload/imagecontent'
};

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Lang = __webpack_require__(5);

var _Lang2 = _interopRequireDefault(_Lang);

var _cn = __webpack_require__(43);

var _cn2 = _interopRequireDefault(_cn);

var _hk = __webpack_require__(44);

var _hk2 = _interopRequireDefault(_hk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var langIns = new _Lang2.default({ cn: _cn2.default, hk: _hk2.default });
module.exports = function lang(key, params) {
	return langIns.getText(key, params);
};

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(8);

var _utils = __webpack_require__(1);

var _TqcodePurchaseXLVIP = __webpack_require__(267);

var _TqcodePurchaseXLVIP2 = _interopRequireDefault(_TqcodePurchaseXLVIP);

var _OpensalePurchaseV = __webpack_require__(273);

var _OpensalePurchaseV2 = _interopRequireDefault(_OpensalePurchaseV);

var _OpensalePurchaseHK = __webpack_require__(284);

var _OpensalePurchaseHK2 = _interopRequireDefault(_OpensalePurchaseHK);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Index = function (_Component) {
	_inherits(Index, _Component);

	function Index(props) {
		_classCallCheck(this, Index);

		var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));

		_this.params = {
			type: (0, _utils.getParams)('type') || 'opensale',
			channel: +(0, _utils.getParams)('channel') || 1,
			lang: (0, _utils.getLang)()
		};
		var _this$params = _this.params,
		    type = _this$params.type,
		    channel = _this$params.channel,
		    lang = _this$params.lang;

		_this.views = {
			tqcode: channel === 2 ? _react2.default.createElement(_TqcodePurchaseXLVIP2.default, null) : _react2.default.createElement(_OpensalePurchaseV2.default, null),
			opensale: lang == 'cn' ? _react2.default.createElement(_OpensalePurchaseV2.default, null) : _react2.default.createElement(_OpensalePurchaseHK2.default, null)
		};
		_this.state = {
			view: _this.views[type] || _this.views['opensale']
		};
		return _this;
	}

	_createClass(Index, [{
		key: 'render',
		value: function render() {
			var view = this.state.view;
			var type = this.params.type;

			var npClass = ['opensale'];
			var className = npClass.indexOf(type) > -1 ? 'np' : '';
			return _react2.default.createElement(
				'div',
				{ className: className },
				view
			);
		}
	}]);

	return Index;
}(_react.Component);

(0, _reactDom.render)(_react2.default.createElement(Index, null), document.getElementById('purchase'));

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

var _components = __webpack_require__(268);

var _consts = __webpack_require__(2);

var _purchase = __webpack_require__(50);

var _purchase2 = _interopRequireDefault(_purchase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TqcodePurchase = function (_Component) {
	_inherits(TqcodePurchase, _Component);

	function TqcodePurchase(props) {
		_classCallCheck(this, TqcodePurchase);

		var _this = _possibleConstructorReturn(this, (TqcodePurchase.__proto__ || Object.getPrototypeOf(TqcodePurchase)).call(this, props));

		var channelCfg = {
			price: {
				'1': 449,
				'2': 599
			}
		};
		var channel = +(0, _utils.getParams)('channel') || 1;
		_this.params = {
			channel: channel,
			price: channelCfg.price[channel]
		};

		_this.state = {
			color: 'black',
			popShow: false,
			popMsg: '',
			popJump: '',
			popBtn: (0, _purchase2.default)('ok'),
			colorConfig: [{ color: 'black', text: (0, _purchase2.default)('color_black'), has: 0 }, { color: 'blue', text: (0, _purchase2.default)('color_blue'), has: 0 }, { color: 'orange', text: (0, _purchase2.default)('color_orange'), has: 0 }]
		};

		_this.popClose = function () {
			_this.setState({ popShow: false });
		};
		_this.switchColor = function (color) {
			_this.setState({ color: color });
		};

		_this.vcodeChangeOnParent = function (value) {
			_this.setState({
				valueOfVcode: value,
				vcodeIsEmpty: false,
				vcodeIsError: false
			});
		};
		_this.vcodeClose = function () {
			_this.setState({
				ifShowVcode: false,
				valueOfVcode: null,
				vcodeIsEmpty: false,
				vcodeIsError: false
			});
			(0, _utils.removeClassFromHtmlElement)();
		};
		_this.vcodeOpen = function () {
			_this.setState({
				ifShowVcode: true
			});
			(0, _utils.addClassToHtmlElement)();
		};

		_this.submit = _this.submit.bind(_this);
		_this.showPopHandler = _this.showPopHandler.bind(_this);
		return _this;
	}

	_createClass(TqcodePurchase, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.params.channel === 1 ? this.queryQualify() : this.getColorList();
		}
	}, {
		key: 'queryQualify',
		value: function queryQualify() {
			var _this2 = this;

			var phone = (0, _utils.getCookie)('phone');
			if (!phone) return this.jumpToLogin();

			var jumpUrl = 'html/fjupspeed';
			(0, _utils.ajaxPost)(_consts.ONECLOUD_API_HOST + '/tqcode/query', { phone: phone, channel: 1 }, // channel=1 福建电信
			function (res) {
				switch (+res.iRet) {
					case 0:
						_this2.getColorList();
						return;
					case -501:
						_this2.jumpToLogin();
						return;
					default:
						_this2.jumpToUrl(jumpUrl);
				}
			}, function () {
				_this2.jumpToUrl(jumpUrl);
			});
		}
	}, {
		key: 'getColorList',
		value: function getColorList() {
			var _this3 = this;

			(0, _utils.ajaxPost)(_consts.ONECLOUD_API_HOST + '/tqcode/colorlist', { channel: this.params.channel }, // channel=1福建电信 2迅雷会员
			function (res) {
				switch (+res.iRet) {
					case 0:
						_this3.setColorConfig(res.data);
						return;
					case -501:
						_this3.jumpToLogin();
						return;
					default:
						_this3.showPopHandler(res.sMsg);
				}
			}, function () {
				_this3.popTip('网络繁忙，请稍后再试（s）');
			});
		}
	}, {
		key: 'setColorConfig',
		value: function setColorConfig(data) {
			var colorConfig = this.state.colorConfig;
			var curColor = void 0,
			    hasColor = void 0,
			    countHas = 0;
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = colorConfig[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					curColor = item.color;
					item.has = data['has_' + curColor];
					if (+data['has_' + curColor]) {
						countHas++;
						hasColor = curColor;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			this.setState({
				colorConfig: colorConfig,
				color: countHas === 1 ? hasColor : 'black'
			});
		}
	}, {
		key: 'jumpToLogin',
		value: function jumpToLogin() {
			location.href = (0, _utils.createUrl)('html/login') + '?jumpurl=' + encodeURIComponent(location.href);
		}
	}, {
		key: 'jumpToUrl',
		value: function jumpToUrl(url) {
			location.href = (0, _utils.createUrl)(url);
		}
	}, {
		key: 'showPopHandler',
		value: function showPopHandler(msg, url, btn) {
			this.setState({
				popShow: true,
				popMsg: msg,
				popJump: url || '',
				popBtn: btn || (0, _purchase2.default)('ok')
			});
		}
	}, {
		key: 'commonErrorHandler',
		value: function commonErrorHandler(resCode, callback, res) {
			var statusList = {
				'30004': (0, _purchase2.default)('rtncode_30004'),
				'30006': (0, _purchase2.default)('rtncode_30006'),
				'30008': (0, _purchase2.default)('rtncode_30008'),
				'30009': (0, _purchase2.default)('rtncode_30009'),
				'40000': (0, _purchase2.default)('rtncode_40000'),
				'30003': (0, _purchase2.default)('rtncode_30003'),
				'30106': (0, _purchase2.default)('rtntqcode_used'),
				'30203': '您已参与过特权码购买活动',
				'30201': '您的特权码已过期',
				'-2': (0, _purchase2.default)('rtncode__2'),
				'-2004': (0, _purchase2.default)('rtncode__2004'),
				'-2000': (0, _purchase2.default)('rtncode__2000'),
				'-1003': (0, _purchase2.default)('rtntqcode_used'),
				'-5': (0, _purchase2.default)('rtncode__5'),

				"41006": (0, _purchase2.default)('rtncode_41006'),
				"41007": (0, _purchase2.default)('rtncode_41007_2'),
				"41009": (0, _purchase2.default)('rtncode_41009'),
				"41012": (0, _purchase2.default)('rtncode_41012'),
				"41013": (0, _purchase2.default)('rtncode_41013'),
				"41014": (0, _purchase2.default)('rtncode_41014'),
				'41016': (0, _purchase2.default)('rtncode_41016'),
				'41018': (0, _purchase2.default)('rtncode_41018'),
				"41022": (0, _purchase2.default)('rtncode_41022')
			};

			var specialList = {
				'1': {
					'30106': '您已使用福建电信专享版特权码',
					'-1003': '您已使用福建电信专享版特权码',
					'30203': '您已参与过福建电信专享版特权码购买活动',
					'30201': '您的福建电信专享版特权码已过期'
				}
			};

			if (this.params.channel === 1) {
				_extends(statusList, specialList[1]);
			}

			var sellOutList = {
				'30005': (0, _purchase2.default)('rtncode_30005'),
				'30016': (0, _purchase2.default)('rtncode_30016'),
				'30025': (0, _purchase2.default)('rtncode_30025'),
				'30026': (0, _purchase2.default)('rtncode_30026')
			};

			if (resCode == -501) {
				var url = window.location.href;
				location.href = (0, _utils.createUrl)('html/login') + '?jumpurl=' + encodeURIComponent(url);
			} else if (resCode == 30203) {
				this.showPopHandler(statusList[resCode], (0, _utils.createUrl)('html/usercenter'), (0, _purchase2.default)('check_order'));
			} else if (sellOutList[resCode]) {
				if (resCode == 30005) {
					this.showPopHandler(sellOutList[resCode]);
				} else {
					this.showPopHandler(sellOutList[resCode], '', (0, _purchase2.default)('tips_continue'));
					this.getColorList();
				}
			} else if (statusList[resCode]) {
				this.showPopHandler(statusList[resCode]);
			} else if (+resCode !== 0) {
				this.showPopHandler(res.sMsg);
			}
			if (callback && typeof callback == "function") {
				callback(resCode, res);
			}
		}
	}, {
		key: 'responeHandler',
		value: function responeHandler(_ref) {
			var res = _ref.res,
			    success = _ref.success;

			var resCode = res.iRet;
			this.commonErrorHandler(resCode, null, res);

			if (resCode == 0) {
				if (res.data) {
					success(res.data);
				} else {
					success();
				}
			}
		}
	}, {
		key: 'gotoLoginPage',
		value: function gotoLoginPage() {
			var url = window.location.href;
			location.href = (0, _utils.createUrl)('html/login') + '?jumpurl=' + encodeURIComponent(url);
		}
	}, {
		key: 'submit',
		value: function submit(e) {
			var _this4 = this;

			e.preventDefault();
			var postData = _defineProperty({
				channel: this.params.channel
			}, this.state.color + '_num', 1);

			var doneCb = function doneCb(res) {
				var success = function success(data) {
					var jumpUrl = (0, _utils.createUrl)('html/order', { type: 'tqcode', orderid: data.order_id });
					window.setTimeout(function () {
						window.location.href = jumpUrl;
					}, 0);
				};
				_this4.responeHandler({ res: res, success: success });
			};
			(0, _utils.postPromise)(_consts.ONECLOUD_API_HOST + '/tqcode/commit', postData).done(doneCb);
		}
	}, {
		key: 'render',
		value: function render() {
			var _state = this.state,
			    color = _state.color,
			    colorConfig = _state.colorConfig;

			var params = this.params;
			var popCont = this.state.popShow ? _react2.default.createElement(_components.TipPop, { msg: this.state.popMsg, jump: this.state.popJump, btnTxt: this.state.popBtn, onClose: this.popClose }) : null;

			return _react2.default.createElement(
				'div',
				{ className: 'oc-buy-box' },
				popCont,
				_react2.default.createElement(_components.PurchaseHeader, { hideTxt: true }),
				_react2.default.createElement(
					'div',
					{ className: 'oc-buy-main' },
					_react2.default.createElement(
						'div',
						{ className: 'oc-u-tit' },
						_react2.default.createElement(
							'h2',
							null,
							'\u4F7F\u7528\u7279\u6743\u7801\u8D2D\u4E70'
						)
					),
					_react2.default.createElement(_components.ColorSelector, { colorConfig: colorConfig, currColor: color, onChange: this.switchColor, showZeroColor: false }),
					_react2.default.createElement(
						'div',
						{ className: 'oc-bot-sum' },
						_react2.default.createElement(
							'a',
							{ href: 'javascript:;', className: 'btn-oc', onClick: this.submit },
							(0, _purchase2.default)('buy_now')
						),
						_react2.default.createElement(
							'h3',
							null,
							'\u5408\u8BA1\uFF1A',
							_react2.default.createElement(
								'strong',
								null,
								params.price
							),
							'\u5143'
						),
						_react2.default.createElement(
							'p',
							null,
							(0, _purchase2.default)('fcode_tips')
						)
					)
				)
			);
		}
	}]);

	return TqcodePurchase;
}(_react.Component);

exports.default = TqcodePurchase;

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.handlerResponeInDone = exports.ImageCode = exports.DeliverDate = exports.ColorSelector = exports.Countdown = exports.TipPop = exports.VerifyCode = exports.DepositRulesSection = exports.DepositHeaderSection = exports.SubmitSection = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.PurchaseHeader = PurchaseHeader;
exports.PurchaseFlow = PurchaseFlow;
exports.PurchaseRule = PurchaseRule;
exports.getSomeResCodeMap = getSomeResCodeMap;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _md = __webpack_require__(83);

var _md2 = _interopRequireDefault(_md);

var _utils = __webpack_require__(1);

var _consts = __webpack_require__(2);

var _reactCountup = __webpack_require__(269);

var _reactCountup2 = _interopRequireDefault(_reactCountup);

var _purchase = __webpack_require__(50);

var _purchase2 = _interopRequireDefault(_purchase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubmitSection = exports.SubmitSection = function (_Component) {
	_inherits(SubmitSection, _Component);

	function SubmitSection(props) {
		_classCallCheck(this, SubmitSection);

		return _possibleConstructorReturn(this, (SubmitSection.__proto__ || Object.getPrototypeOf(SubmitSection)).call(this, props));
	}

	_createClass(SubmitSection, [{
		key: 'btnRender',
		value: function btnRender() {
			var _props = this.props,
			    status = _props.status,
			    onSubmit = _props.onSubmit,
			    constStatus = _props.constStatus,
			    ifShowLoading = _props.ifShowLoading;

			if (status === constStatus) {
				return _react2.default.createElement(
					'a',
					{ href: 'javascript:;', className: 'btn-oc', onClick: onSubmit },
					(0, _purchase2.default)('submit_order'),
					ifShowLoading ? _react2.default.createElement('i', { className: 'i-oc-loading' }) : null
				);
			} else {
				return _react2.default.createElement(
					'a',
					{ href: 'javascript:;', className: 'btn-oc btn-oc-disable' },
					(0, _purchase2.default)('submit_order')
				);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'oc-bot-sum' },
				this.btnRender(),
				(0, _purchase2.default)('price_presalle'),
				_react2.default.createElement(
					'p',
					null,
					(0, _purchase2.default)('tips_presell_deliver')
				)
			);
		}
	}]);

	return SubmitSection;
}(_react.Component);

var DepositHeaderSection = exports.DepositHeaderSection = function (_Component2) {
	_inherits(DepositHeaderSection, _Component2);

	function DepositHeaderSection() {
		_classCallCheck(this, DepositHeaderSection);

		return _possibleConstructorReturn(this, (DepositHeaderSection.__proto__ || Object.getPrototypeOf(DepositHeaderSection)).apply(this, arguments));
	}

	_createClass(DepositHeaderSection, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'oc-buy-ban' },
				_react2.default.createElement(
					'div',
					{ className: 'oc-buy-banner' },
					_react2.default.createElement(
						'h2',
						null,
						(0, _purchase2.default)('banner_title')
					),
					_react2.default.createElement(
						'h3',
						null,
						(0, _purchase2.default)('presell_ing')
					),
					_react2.default.createElement('img', { className: 'presell-ban-img', src: '//static.onethingcloud.com/images/presell/ban.jpg', alt: (0, _purchase2.default)('wky') })
				)
			);
		}
	}]);

	return DepositHeaderSection;
}(_react.Component);

var DepositRulesSection = exports.DepositRulesSection = function (_Component3) {
	_inherits(DepositRulesSection, _Component3);

	function DepositRulesSection() {
		_classCallCheck(this, DepositRulesSection);

		return _possibleConstructorReturn(this, (DepositRulesSection.__proto__ || Object.getPrototypeOf(DepositRulesSection)).apply(this, arguments));
	}

	_createClass(DepositRulesSection, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'oc-buy-aside' },
				(0, _purchase2.default)('deposit_rules')
			);
		}
	}]);

	return DepositRulesSection;
}(_react.Component);

function PurchaseHeader(props) {
	var title = props.title,
	    isSingleBlue = props.isSingleBlue;

	return _react2.default.createElement(
		'div',
		{ className: 'oc-buy-ban' },
		_react2.default.createElement(
			'div',
			{ className: 'oc-buy-banner' },
			_react2.default.createElement(
				'h2',
				null,
				title
			),
			props.hideTxt ? null : _react2.default.createElement(
				'h3',
				null,
				(0, _purchase2.default)('banner_subtitle')
			),
			props.userTotal && window.LANG != 'hk' ? _react2.default.createElement(
				'p',
				{ className: 'oc-buy-price-num' },
				(0, _purchase2.default)('deposit_number1'),
				_react2.default.createElement(
					'em',
					null,
					' ',
					_react2.default.createElement(_reactCountup2.default, { start: 10000, end: props.userTotal, duration: 1 }),
					' '
				),
				(0, _purchase2.default)('deposit_number2')
			) : null,
			isSingleBlue ? _react2.default.createElement(
				'div',
				{ className: 'i-banbox' },
				_react2.default.createElement('i', { className: 'i-ban-wky-fj' })
			) : _react2.default.createElement(
				'div',
				{ className: 'i-banbox' },
				_react2.default.createElement('i', { className: 'i-ban-wky3' }),
				_react2.default.createElement('i', { className: 'i-ban-wky2' }),
				_react2.default.createElement('i', { className: 'i-ban-wky1' })
			)
		)
	);
}
PurchaseHeader.defaultProps = {
	title: (0, _purchase2.default)('banner_title'),
	isSingleBlue: false
};

var VerifyCode = exports.VerifyCode = function (_Component4) {
	_inherits(VerifyCode, _Component4);

	function VerifyCode(props) {
		_classCallCheck(this, VerifyCode);

		var _this4 = _possibleConstructorReturn(this, (VerifyCode.__proto__ || Object.getPrototypeOf(VerifyCode)).call(this, props));

		_this4.vcodeChangeOnComponent = _this4.vcodeChangeOnComponent.bind(_this4);
		_this4.onKeyDown = _this4.onKeyDown.bind(_this4);
		_this4.refreshVerifyCode = _this4.refreshVerifyCode.bind(_this4);
		return _this4;
	}

	_createClass(VerifyCode, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.refs.inputElm.focus();
		}
	}, {
		key: 'vcodeChangeOnComponent',
		value: function vcodeChangeOnComponent(e) {
			var value = e.target.value;
			var onChange = this.props.onChange;

			onChange(value);
		}
	}, {
		key: 'onKeyDown',
		value: function onKeyDown(e) {
			var submitVcode = this.props.submitVcode;

			var keyCode = e.keyCode;
			if (keyCode == 13) submitVcode();
		}
	}, {
		key: 'refreshVerifyCode',
		value: function refreshVerifyCode(e) {
			e.preventDefault();
			this.props.refreshVerifyCode && this.props.refreshVerifyCode();
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    onClose = _props2.onClose,
			    onChange = _props2.onChange,
			    submitVcode = _props2.submitVcode,
			    vcodeIsError = _props2.vcodeIsError,
			    vcodeIsEmpty = _props2.vcodeIsEmpty,
			    inputValue = _props2.inputValue,
			    vcodeString = _props2.vcodeString;

			var quesboxStyle = {
				height: 'auto',
				marginBottom: '10px'
			};

			return _react2.default.createElement(
				'div',
				{ className: 'oc-pop', style: { zIndex: 999, position: 'absolute' } },
				_react2.default.createElement(
					'div',
					{ className: 'oc-pop-wp' },
					_react2.default.createElement(
						'div',
						{ className: 'oc-pop-textbox oc-tb' },
						_react2.default.createElement(
							'div',
							{ className: 'oc-pop-text oc-tb-cell' },
							_react2.default.createElement(
								'h3',
								null,
								(0, _purchase2.default)('verify_input'),
								' ',
								_react2.default.createElement(
									'a',
									{ href: 'javascript:;', className: 'oc-quesbox-refresh', onClick: this.refreshVerifyCode },
									_react2.default.createElement('i', { className: 'i-oc-refresh' }),
									(0, _purchase2.default)('verify_refresh')
								)
							),
							_react2.default.createElement(
								'h4',
								null,
								(0, _purchase2.default)('verify_yellow')
							),
							_react2.default.createElement(
								'h4',
								null,
								vcodeIsError ? _react2.default.createElement(
									'span',
									{ style: { color: 'red' } },
									(0, _purchase2.default)('verify_error')
								) : null
							),
							_react2.default.createElement('div', { className: 'oc-quesbox',
								ref: 'vcodeResElem',
								dangerouslySetInnerHTML: vcodeString,
								style: quesboxStyle }),
							_react2.default.createElement(
								'div',
								{ className: 'oc-u-inpbox oc-ques-inp' },
								_react2.default.createElement('input', { ref: 'inputElm',
									className: 'oc-inptxt',
									type: 'text',
									placeholder: (0, _purchase2.default)('verify_empty'),
									value: inputValue,
									onKeyDown: this.onKeyDown,
									onChange: this.vcodeChangeOnComponent }),
								vcodeIsEmpty ? _react2.default.createElement(
									'p',
									{ className: 'oc-err' },
									(0, _purchase2.default)('verify_empty')
								) : null
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'oc-pop-btnbox' },
						_react2.default.createElement(
							'a',
							{ href: 'javascript:;', className: 'btn-oc', onClick: submitVcode },
							(0, _purchase2.default)('ok')
						)
					),
					_react2.default.createElement(
						'a',
						{ href: 'javascript:;', className: 'oc-pop-close', onClick: onClose },
						(0, _purchase2.default)('close')
					)
				)
			);
		}
	}]);

	return VerifyCode;
}(_react.Component);

/**
 * 消息弹窗
 * 
 * @export
 * @class TipPop
 * @extends {Component}
 * msg——弹窗主体内容，支持html元素
 * jump—— 如果存在，并为函数，则点击执行自定义函数
 * 		  如果存在，并且为字符串，则点击跳转到自定义链接
 * 		  其他情况，默认确认按钮为关闭弹窗
 * onClose——如果为函数，则为关闭弹窗的回调函数
 * 			如果为false，则不设置确认按钮和关闭按钮
 * btnTxt——按钮文字 
 * 
 */


var TipPop = exports.TipPop = function (_Component5) {
	_inherits(TipPop, _Component5);

	function TipPop(props) {
		_classCallCheck(this, TipPop);

		var _this5 = _possibleConstructorReturn(this, (TipPop.__proto__ || Object.getPrototypeOf(TipPop)).call(this, props));

		_this5.btnRender = _this5.btnRender.bind(_this5);
		return _this5;
	}

	_createClass(TipPop, [{
		key: 'btnRender',
		value: function btnRender() {
			var _props3 = this.props,
			    jump = _props3.jump,
			    onClose = _props3.onClose,
			    btnTxt = _props3.btnTxt;

			var jumpType = jump && (typeof jump === 'undefined' ? 'undefined' : _typeof(jump));
			var noBtnRender = function noBtnRender() {
				return _react2.default.createElement('div', { className: 'oc-pop-btnbox' });
			};
			var btnRenderInner = function btnRenderInner() {
				var submitBtn = function submitBtn() {
					if (jumpType == 'function') {
						return _react2.default.createElement(
							'a',
							{ href: 'javascript:;', className: 'btn-oc', onClick: jump },
							btnTxt
						);
					} else if (jumpType == 'string') {
						return _react2.default.createElement(
							'a',
							{ href: jump, className: 'btn-oc' },
							btnTxt
						);
					} else {
						return _react2.default.createElement(
							'a',
							{ href: 'javascript:;', className: 'btn-oc', onClick: onClose },
							btnTxt
						);
					}
				};
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'oc-pop-btnbox' },
						submitBtn()
					),
					_react2.default.createElement(
						'a',
						{ href: 'javascript:;', className: 'oc-pop-close', onClick: onClose },
						(0, _purchase2.default)('close')
					)
				);
			};
			return onClose ? btnRenderInner() : noBtnRender();
		}
	}, {
		key: 'render',
		value: function render() {
			var _props4 = this.props,
			    msg = _props4.msg,
			    jump = _props4.jump,
			    onClose = _props4.onClose,
			    btnTxt = _props4.btnTxt;

			var dangerousInnerHTML = {
				__html: msg
			};
			return _react2.default.createElement(
				'div',
				{ className: 'oc-pop' },
				_react2.default.createElement(
					'div',
					{ className: 'oc-pop-wp' },
					_react2.default.createElement(
						'div',
						{ className: 'oc-pop-textbox oc-tb' },
						_react2.default.createElement('div', { className: 'oc-pop-text oc-tb-cell',
							dangerouslySetInnerHTML: dangerousInnerHTML })
					),
					this.btnRender()
				)
			);
		}
	}]);

	return TipPop;
}(_react.Component);

TipPop.defaultProps = {
	msg: 'hello breeze',
	jump: '',
	onClose: function onClose() {
		return console.log("this is a default func (●'◡'●)ﾉ♥");
	},
	btnTxt: '确定'
};

var Countdown = exports.Countdown = function (_Component6) {
	_inherits(Countdown, _Component6);

	function Countdown() {
		_classCallCheck(this, Countdown);

		return _possibleConstructorReturn(this, (Countdown.__proto__ || Object.getPrototypeOf(Countdown)).apply(this, arguments));
	}

	_createClass(Countdown, [{
		key: 'render',
		value: function render() {
			var _props5 = this.props,
			    currTime = _props5.currTime,
			    targetTime = _props5.targetTime,
			    desc = _props5.desc;

			if (!currTime || !targetTime) return null;
			var time = (0, _utils.surplusTime)(currTime, targetTime);
			return _react2.default.createElement(
				'div',
				{ className: 'oc-u-tit oc-u-tit-buytime' },
				_react2.default.createElement(
					'div',
					{ className: 'oc-buytime' },
					_react2.default.createElement(
						'p',
						null,
						desc
					),
					time.day > 0 ? _react2.default.createElement(
						'span',
						null,
						_react2.default.createElement(
							'em',
							null,
							time.day
						),
						(0, _purchase2.default)('date_day')
					) : null,
					_react2.default.createElement(
						'span',
						null,
						_react2.default.createElement(
							'em',
							null,
							time.hour
						),
						(0, _purchase2.default)('date_hour')
					),
					_react2.default.createElement(
						'span',
						null,
						_react2.default.createElement(
							'em',
							null,
							time.minute
						),
						(0, _purchase2.default)('date_minute')
					),
					_react2.default.createElement(
						'span',
						null,
						_react2.default.createElement(
							'em',
							null,
							time.second
						),
						(0, _purchase2.default)('date_second')
					)
				)
			);
		}
	}]);

	return Countdown;
}(_react.Component);

Countdown.propTypes = {
	currTime: _react.PropTypes.instanceOf(Date).isRequired,
	targetTime: _react.PropTypes.instanceOf(Date),
	type: _react.PropTypes.string
};

function PurchaseFlow(props) {
	return (0, _purchase2.default)('buy_steps');
}

function PurchaseRule(props) {
	return null;
	/*return (
 	<dl className="oc-buy-aside-rule">
 	    <dt>活动规则</dt>
 	    <dd>1. 预付定金启动时间：9月26日10:00-12:00，2小时不限量预定开启；</dd>
 	    <dd>2. 预定成功后享受购买资格，成功支付定金与尾款后，我们将在统一时间发货；请关注预定时间及尾款支付时间，建议您开启短信提醒，以免错过购买时间；</dd>
 	    <dd>3. 预付定金在预定期间不可退，请确认后提交预定订单；</dd>
 	    <dd>4. 预付统一发货时间：2018年1月15日，预付用户我们会为您的激活码自动延期；</dd>
 	    <dd>5. 定金可直接抵扣商品总额，定金不支持优惠码抵扣，尾款可支持优惠码抵扣；</dd>
 	    <dd>6. 查看预定订单请至“我的订单”-“我的预售”进行查看。</dd>
 	</dl>
 )*/
}

var ColorSelector = exports.ColorSelector = function (_Component7) {
	_inherits(ColorSelector, _Component7);

	function ColorSelector(props) {
		_classCallCheck(this, ColorSelector);

		var _this7 = _possibleConstructorReturn(this, (ColorSelector.__proto__ || Object.getPrototypeOf(ColorSelector)).call(this, props));

		_this7.switchColor = _this7.switchColor.bind(_this7);
		return _this7;
	}

	_createClass(ColorSelector, [{
		key: 'switchColor',
		value: function switchColor(e) {
			this.props.onChange($(e.currentTarget).data('color'));
		}
	}, {
		key: 'render',
		value: function render() {
			var _this8 = this;

			var _props6 = this.props,
			    colorConfig = _props6.colorConfig,
			    currColor = _props6.currColor,
			    showZeroColor = _props6.showZeroColor;

			return _react2.default.createElement(
				'dl',
				{ className: 'oc-buy-color' },
				_react2.default.createElement(
					'dt',
					null,
					(0, _purchase2.default)('colorcom_subtitle')
				),
				colorConfig.map(function (item) {
					var ret = null;
					if (item.has) {
						ret = _react2.default.createElement(
							'dd',
							{ className: currColor == item.color ? 'oc-selected' : '', key: item.color, onClick: _this8.switchColor, 'data-color': item.color },
							_react2.default.createElement('i', { className: 'i-oc-col-' + item.color }),
							item.text
						);
					} else if (showZeroColor) {
						ret = _react2.default.createElement(
							'dd',
							{ className: 'oc-buy-soldout', key: item.color, 'data-color': item.color },
							_react2.default.createElement('i', { className: 'i-oc-col-' + item.color }),
							item.text,
							(0, _purchase2.default)('colorcom_zero')
						);
					}
					return ret;
				})
			);
		}
	}]);

	return ColorSelector;
}(_react.Component);

ColorSelector.propTypes = {
	colorConfig: _react.PropTypes.array.isRequired,
	currColor: _react.PropTypes.string.isRequired,
	onChange: _react.PropTypes.func.isRequired
};
ColorSelector.defaultProps = {
	showZeroColor: true
};

var DeliverDate = exports.DeliverDate = function (_Component8) {
	_inherits(DeliverDate, _Component8);

	function DeliverDate(props) {
		_classCallCheck(this, DeliverDate);

		var _this9 = _possibleConstructorReturn(this, (DeliverDate.__proto__ || Object.getPrototypeOf(DeliverDate)).call(this, props));

		_this9.itemRender = _this9.itemRender.bind(_this9);
		return _this9;
	}

	_createClass(DeliverDate, [{
		key: 'changeDate',
		value: function changeDate(item) {
			var dateString = item['deliver_time'];
			this.props.onChange(dateString);
		}
	}, {
		key: 'itemRender',
		value: function itemRender(item, index) {
			var _props7 = this.props,
			    currDate = _props7.currDate,
			    currColor = _props7.currColor;

			var dateString = item['deliver_time'];
			return item.hasStatus ? _react2.default.createElement(
				'dd',
				{ onClick: this.changeDate.bind(this, item), key: index, className: dateString == currDate ? 'oc-selected' : '' },
				dateString
			) : _react2.default.createElement(
				'dd',
				{ key: index, className: 'oc-buy-soldout' },
				dateString
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this10 = this;

			var _props8 = this.props,
			    dDateConfig = _props8.dDateConfig,
			    currDate = _props8.currDate,
			    currColor = _props8.currColor;

			if (!dDateConfig || dDateConfig.length == 0) return null;

			return _react2.default.createElement(
				'dl',
				{ className: 'oc-buy-color oc-buy-date' },
				_react2.default.createElement(
					'dt',
					null,
					(0, _purchase2.default)('delivercom_subtitle')
				),
				dDateConfig.map(function (item, index) {
					return _this10.itemRender(item, index);
				})
			);
		}
	}]);

	return DeliverDate;
}(_react.Component);

DeliverDate.defaultProps = {
	dDateConfig: [],
	currDate: null,
	currColor: '',
	onChange: function onChange() {
		return console.log('this is a default func');
	}
};

var ImageCode = exports.ImageCode = function (_Component9) {
	_inherits(ImageCode, _Component9);

	function ImageCode(props) {
		_classCallCheck(this, ImageCode);

		var _this11 = _possibleConstructorReturn(this, (ImageCode.__proto__ || Object.getPrototypeOf(ImageCode)).call(this, props));

		_this11.state = {
			imgCode: null,
			imgCodeUrl: '/images/purchase/loading.gif',
			errMsg: null
		};
		_this11.changeImgCode = _this11.changeImgCode.bind(_this11);
		_this11.handleImgCodeChange = _this11.handleImgCodeChange.bind(_this11);
		return _this11;
	}

	_createClass(ImageCode, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.changeImgCode();
		}
	}, {
		key: 'changeImgCode',
		value: function changeImgCode(e) {
			var _this12 = this;

			var url = '//verify-img-content.onethingcloud.com/imgcode/refresh.php?type=0&_=' + new Date().getTime() + '&uniqueKey=' + (0, _md2.default)(getCookie('phone'));
			var img = new Image();
			img.src = url;
			img.onload = function () {
				_this12.setState({ imgCodeUrl: url });
			};
		}
	}, {
		key: 'handleImgCodeChange',
		value: function handleImgCodeChange(e) {
			var value = e.target.value;
			this.setState({ imgCode: value });
			this.props.onChange(value);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props9 = this.props,
			    colorConfig = _props9.colorConfig,
			    currColor = _props9.currColor;

			return _react2.default.createElement(
				'div',
				{ className: 'oc-buy-code' },
				_react2.default.createElement(
					'span',
					{ className: 'oc-buy-code-name' },
					(0, _purchase2.default)('imagecode_title')
				),
				_react2.default.createElement(
					'div',
					{ className: 'oc-buy-code-img' },
					_react2.default.createElement('input', { className: 'oc-inptxt', type: 'text', placeholder: (0, _purchase2.default)('imagecode_input'), maxLength: '5', value: this.state.imgCode, onChange: this.handleImgCodeChange }),
					_react2.default.createElement(
						'span',
						{ className: 'oc-inp-codeimg' },
						_react2.default.createElement('img', { src: this.state.imgCodeUrl, onClick: this.changeImgCode })
					)
				),
				_react2.default.createElement(
					'p',
					{ className: 'oc-err' },
					this.state.errMsg
				)
			);
		}
	}]);

	return ImageCode;
}(_react.Component);

ImageCode.propTypes = {
	onChange: _react.PropTypes.func.isRequired

	/**
  * 	viewHandler——不同的错误码进行不同的视图操作
 	successHandler——iRet为0的处理函数
 	commonHandler——所有错误码都会执行的回调
 	otherResHandler——其他错误码的回调执行方法
 	someResCodeMap——错误码以及相对应viewHandler需要的参数
 	example:	{
 		11: {
 			content: 'xxxx',
 			link:'',
 			okBtn: '知道了'
 		},
 		4015: {
 			content: 'xxxx',
 			link: '/usercenter.html',
 			okBtn: '确定'
 		}
 	}
 	respone——接口返回的参数
  */
};
var handlerResponeInDone = exports.handlerResponeInDone = function () {
	function handlerResponeInDone(props) {
		_classCallCheck(this, handlerResponeInDone);

		var f = function f() {};
		this.viewHandler = props.viewHandler;
		this.successHandler = props.successHandler;
		this.otherResHandler = props.otherResHandler;
		this.someResCodeMap = props.someResCodeMap;
		this.commonHandler = props.commonHandler || f;
		this.respone = props.respone;
	}

	_createClass(handlerResponeInDone, [{
		key: 'render',
		value: function render() {
			var respone = this.respone;
			var resCode = respone.iRet;
			var someResCodeMap = this.someResCodeMap;
			if (resCode === 0) {
				this.successHandler(respone);
			} else if (someResCodeMap[resCode]) {
				var params = [someResCodeMap[resCode]['content'] || 'default content', someResCodeMap[resCode]['link'] || '', someResCodeMap[resCode]['okBtn'] || (0, _purchase2.default)('ok')];

				this.viewHandler.apply(this, _toConsumableArray(params));
			} else {
				this.otherResHandler(respone);
			}
			this.commonHandler(respone);
		}
	}]);

	return handlerResponeInDone;
}();

function getSomeResCodeMap() {
	var normalError = {
		'30006': (0, _purchase2.default)('rtncode_30006'),
		'30008': (0, _purchase2.default)('rtncode_30008'),
		'30009': (0, _purchase2.default)('rtncode_30009'),
		'30003': (0, _purchase2.default)('rtncode_30003'),
		'30106': (0, _purchase2.default)('rtncode_30106'),
		'-2': (0, _purchase2.default)('rtncode__2'),
		'-2004': (0, _purchase2.default)('rtncode__2004'),
		'-2000': (0, _purchase2.default)('rtncode__2000'),
		'-1003': (0, _purchase2.default)('rtncode__1003'),
		'-5': (0, _purchase2.default)('rtncode__5'),

		"41006": (0, _purchase2.default)('rtncode_41006'),
		"41007": (0, _purchase2.default)('rtncode_41007'),
		"41009": (0, _purchase2.default)('rtncode_41009'),
		"41013": (0, _purchase2.default)('rtncode_41013'),
		"41014": (0, _purchase2.default)('rtncode_41014'),
		'41016': (0, _purchase2.default)('rtncode_41016'),

		41008: (0, _purchase2.default)('rtncode_41008'),
		'-301': (0, _purchase2.default)('rtncode__301'),
		30032: (0, _purchase2.default)('rtncode_30032'),
		41011: (0, _purchase2.default)('rtncode_41011'),
		'-1': (0, _purchase2.default)('rtncode__1')
	};
	var specialError = {
		41010: {
			content: (0, _purchase2.default)('rtncode_41010'),
			link: (0, _utils.createUrl)('html/usercenter'),
			okBtn: (0, _purchase2.default)('check_order')
		},
		30005: {
			content: (0, _purchase2.default)('rtncode_30005')
		},
		30016: {
			content: (0, _purchase2.default)('rtncode_30016'),
			okBtn: (0, _purchase2.default)('tips_continue')
		},
		30025: {
			content: (0, _purchase2.default)('rtncode_30025'),
			okBtn: (0, _purchase2.default)('tips_continue')
		},
		30026: {
			content: (0, _purchase2.default)('rtncode_30026'),
			okBtn: (0, _purchase2.default)('tips_continue')
		},
		30007: {
			content: (0, _purchase2.default)('rtncode_30007'),
			link: (0, _utils.createUrl)('html/usercenter'),
			okBtn: (0, _purchase2.default)('check_order')
		}
	};
	function wrapObject(object) {
		var rtn = {};
		for (var key in object) {
			rtn[key] = {
				content: object[key]
			};
		}
		return rtn;
	}
	return $.extend({}, wrapObject(normalError), specialError);
}

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startAnimation = exports.formatNumber = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _countup = __webpack_require__(270);

var _countup2 = _interopRequireDefault(_countup);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// Adapted from the countup.js format number function
// https://github.com/inorganik/countUp.js/blob/master/countUp.js#L46-L60
var formatNumber = exports.formatNumber = function formatNumber(start, options) {
  var num = '' + start.toFixed(options.decimals);
  var x = num.split('.');
  var x1 = x[0];
  var x2 = x.length > 1 ? '' + options.decimal + x[1] : '';
  var rgx = /(\d+)(\d{3})/;

  if (options.separator) {
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + options.separator + '$2');
    }
  }
  return '' + options.prefix + x1 + x2 + options.suffix;
};

var startAnimation = exports.startAnimation = function startAnimation(component) {
  if (!(component && component.spanElement)) {
    throw new Error('You need to pass the CountUp component as an argument!\neg. this.myCountUp.startAnimation(this.myCountUp);');
  }

  var _component$props = component.props,
      decimal = _component$props.decimal,
      decimals = _component$props.decimals,
      duration = _component$props.duration,
      easingFn = _component$props.easingFn,
      end = _component$props.end,
      formattingFn = _component$props.formattingFn,
      onComplete = _component$props.onComplete,
      onStart = _component$props.onStart,
      prefix = _component$props.prefix,
      separator = _component$props.separator,
      start = _component$props.start,
      suffix = _component$props.suffix,
      useEasing = _component$props.useEasing;

  var countupInstance = new _countup2.default(component.spanElement, start, end, decimals, duration, {
    decimal: decimal,
    easingFn: easingFn,
    formattingFn: formattingFn,
    separator: separator,
    prefix: prefix,
    suffix: suffix,
    useEasing: useEasing,
    useGrouping: !!separator
  });

  if (typeof onStart === 'function') {
    onStart();
  }

  countupInstance.start(onComplete);
};

var CountUp = function (_React$Component) {
  _inherits(CountUp, _React$Component);

  function CountUp() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CountUp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountUp.__proto__ || Object.getPrototypeOf(CountUp)).call.apply(_ref, [this].concat(args))), _this), _this.spanElement = null, _this.refSpan = function (span) {
      _this.spanElement = span;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CountUp, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      startAnimation(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var hasCertainPropsChanged = this.props.duration !== nextProps.duration || this.props.end !== nextProps.end || this.props.start !== nextProps.start;

      return nextProps.redraw || hasCertainPropsChanged;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      startAnimation(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          start = _props.start,
          decimal = _props.decimal,
          decimals = _props.decimals,
          separator = _props.separator,
          prefix = _props.prefix,
          suffix = _props.suffix,
          style = _props.style;

      return _react2.default.createElement('span', { className: className, ref: this.refSpan, style: style }, formatNumber(start, {
        decimal: decimal,
        decimals: decimals,
        separator: separator,
        prefix: prefix,
        suffix: suffix
      }));
    }
  }]);

  return CountUp;
}(_react2.default.Component);

CountUp.defaultProps = {
  className: undefined,
  decimal: '.',
  decimals: 0,
  duration: 3,
  easingFn: null,
  end: 100,
  formattingFn: null,
  onComplete: undefined,
  onStart: undefined,
  prefix: '',
  separator: '',
  start: 0,
  suffix: '',
  redraw: false,
  style: undefined,
  useEasing: true
};
exports.default = CountUp;

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (a, n) {
   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = n(require, exports, module) : a.CountUp = n();
}(undefined, function (a, n, t) {
  var e = function e(a, n, t, _e, i, r) {
    function o(a) {
      var n,
          t,
          e,
          i,
          r,
          o,
          s = a < 0;if (a = Math.abs(a).toFixed(l.decimals), a += "", n = a.split("."), t = n[0], e = n.length > 1 ? l.options.decimal + n[1] : "", l.options.useGrouping) {
        for (i = "", r = 0, o = t.length; r < o; ++r) {
          0 !== r && r % 3 === 0 && (i = l.options.separator + i), i = t[o - r - 1] + i;
        }t = i;
      }return l.options.numerals.length && (t = t.replace(/[0-9]/g, function (a) {
        return l.options.numerals[+a];
      }), e = e.replace(/[0-9]/g, function (a) {
        return l.options.numerals[+a];
      })), (s ? "-" : "") + l.options.prefix + t + e + l.options.suffix;
    }function s(a, n, t, e) {
      return t * (-Math.pow(2, -10 * a / e) + 1) * 1024 / 1023 + n;
    }function u(a) {
      return "number" == typeof a && !isNaN(a);
    }var l = this;if (l.version = function () {
      return "1.9.3";
    }, l.options = { useEasing: !0, useGrouping: !0, separator: ",", decimal: ".", easingFn: s, formattingFn: o, prefix: "", suffix: "", numerals: [] }, r && "object" == (typeof r === "undefined" ? "undefined" : _typeof(r))) for (var m in l.options) {
      r.hasOwnProperty(m) && null !== r[m] && (l.options[m] = r[m]);
    }"" === l.options.separator ? l.options.useGrouping = !1 : l.options.separator = "" + l.options.separator;for (var d = 0, c = ["webkit", "moz", "ms", "o"], f = 0; f < c.length && !window.requestAnimationFrame; ++f) {
      window.requestAnimationFrame = window[c[f] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[c[f] + "CancelAnimationFrame"] || window[c[f] + "CancelRequestAnimationFrame"];
    }window.requestAnimationFrame || (window.requestAnimationFrame = function (a, n) {
      var t = new Date().getTime(),
          e = Math.max(0, 16 - (t - d)),
          i = window.setTimeout(function () {
        a(t + e);
      }, e);return d = t + e, i;
    }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (a) {
      clearTimeout(a);
    }), l.initialize = function () {
      return !!l.initialized || (l.error = "", l.d = "string" == typeof a ? document.getElementById(a) : a, l.d ? (l.startVal = Number(n), l.endVal = Number(t), u(l.startVal) && u(l.endVal) ? (l.decimals = Math.max(0, _e || 0), l.dec = Math.pow(10, l.decimals), l.duration = 1e3 * Number(i) || 2e3, l.countDown = l.startVal > l.endVal, l.frameVal = l.startVal, l.initialized = !0, !0) : (l.error = "[CountUp] startVal (" + n + ") or endVal (" + t + ") is not a number", !1)) : (l.error = "[CountUp] target is null or undefined", !1));
    }, l.printValue = function (a) {
      var n = l.options.formattingFn(a);"INPUT" === l.d.tagName ? this.d.value = n : "text" === l.d.tagName || "tspan" === l.d.tagName ? this.d.textContent = n : this.d.innerHTML = n;
    }, l.count = function (a) {
      l.startTime || (l.startTime = a), l.timestamp = a;var n = a - l.startTime;l.remaining = l.duration - n, l.options.useEasing ? l.countDown ? l.frameVal = l.startVal - l.options.easingFn(n, 0, l.startVal - l.endVal, l.duration) : l.frameVal = l.options.easingFn(n, l.startVal, l.endVal - l.startVal, l.duration) : l.countDown ? l.frameVal = l.startVal - (l.startVal - l.endVal) * (n / l.duration) : l.frameVal = l.startVal + (l.endVal - l.startVal) * (n / l.duration), l.countDown ? l.frameVal = l.frameVal < l.endVal ? l.endVal : l.frameVal : l.frameVal = l.frameVal > l.endVal ? l.endVal : l.frameVal, l.frameVal = Math.round(l.frameVal * l.dec) / l.dec, l.printValue(l.frameVal), n < l.duration ? l.rAF = requestAnimationFrame(l.count) : l.callback && l.callback();
    }, l.start = function (a) {
      l.initialize() && (l.callback = a, l.rAF = requestAnimationFrame(l.count));
    }, l.pauseResume = function () {
      l.paused ? (l.paused = !1, delete l.startTime, l.duration = l.remaining, l.startVal = l.frameVal, requestAnimationFrame(l.count)) : (l.paused = !0, cancelAnimationFrame(l.rAF));
    }, l.reset = function () {
      l.paused = !1, delete l.startTime, l.initialized = !1, l.initialize() && (cancelAnimationFrame(l.rAF), l.printValue(l.startVal));
    }, l.update = function (a) {
      if (l.initialize()) {
        if (a = Number(a), !u(a)) return void (l.error = "[CountUp] update() - new endVal is not a number: " + a);l.error = "", a !== l.frameVal && (cancelAnimationFrame(l.rAF), l.paused = !1, delete l.startTime, l.startVal = l.frameVal, l.endVal = a, l.countDown = l.startVal > l.endVal, l.rAF = requestAnimationFrame(l.count));
      }
    }, l.initialize() && l.printValue(l.startVal);
  };return e;
});

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module$exports;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

module.exports = (_module$exports = {
    color_black: '曜石黑',
    color_orange: '爱马仕橙',
    color_blue: '科技蓝',
    pay_now: '立即支付',
    check_order: '查看订单',
    notifi_tryagain: '<i class="i-oc-queue"></i><h3>正在为您排队中...</h3><p>当前抢购人数较多，正在努力为您加载，请稍后重试喔。</p>',
    notifi_yongdu: '<i class="i-oc-yongdu"></i><h3>\u62B1\u6B49\uFF0C\u7F51\u7EDC\u8D70\u4E22\u4E86</h3><p>\u5F53\u524D\u62A2\u8D2D\u4EBA\u6570\u8F83\u591A\uFF0C\u6B63\u5728\u52AA\u529B\u4E3A\u60A8\u52A0\u8F7D\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u5594\u3002</p>',
    notifi_success: '<i class="i-oc-chenggong"></i><h3>恭喜，您已经成功抢到玩客云1台</h3><p>支付有效期为45分钟，请尽快完成支付，否则订单将失效喔。</p>',
    notifi_chakan: '<i class="i-oc-chakan"></i><h3>每位玩客只能购买1台玩客云</h3><p>你已经成功抢购，不要贪心哦。</p>',
    notifi_limit1: '<h3>请您先预约</h3><p>预约成功的用户才能参与抢购玩客云哦！</p>',

    login_remind: '为了方便购买，请提前登录',
    login_now: '立即登录',
    close: '关闭',
    ok: '确定',
    pic_soldout: '已抢完',
    more: '了解更多',
    count_down1: '离抢购开始还有',
    count_down2: '正在抢购中...',
    buy_now: '立即下单',
    price_official: _react2.default.createElement(
        'span',
        { className: 'oc-buy-price-pay' },
        '\u5B98\u65B9\u6307\u5BFC\u4EF7: 599\u5143'
    ),
    price_official_v2: _react2.default.createElement(
        'div',
        { className: 'np-buy-price' },
        '\u5B98\u65B9\u6307\u5BFC\u4EF7\uFF1A',
        _react2.default.createElement(
            'em',
            null,
            _react2.default.createElement(
                'span',
                null,
                '599'
            ),
            '\u5143'
        )
    ),
    price_yuan: '元',
    price_total: _react2.default.createElement(
        'h3',
        null,
        '\u5408\u8BA1\uFF1A',
        _react2.default.createElement(
            'strong',
            null,
            '599'
        ),
        '\u5143'
    ),
    price_total_custom: function price_total_custom(props) {
        return _react2.default.createElement(
            'h3',
            null,
            '\u5408\u8BA1\uFF1A',
            _react2.default.createElement(
                'strong',
                null,
                props.price
            ),
            '\u5143'
        );
    },
    price_presell: _react2.default.createElement(
        'h3',
        null,
        '\u9884\u552E\u4EF7\uFF1A',
        _react2.default.createElement(
            'strong',
            null,
            '499'
        ),
        '\u5143'
    ),
    price_discount: function price_discount(props) {
        return _react2.default.createElement(
            'span',
            { className: 'oc-buy-price-pay' },
            '\u6D3B\u52A8\u4F18\u60E0\u4EF7: ',
            props.price,
            '\u5143 ',
            _react2.default.createElement(
                's',
                null,
                '599\u5143'
            )
        );
    },
    tips_deliver: '温馨提示：请预约后及时抢购,购买成功后3天内发货 | 支持7天无理由退货',
    tips_presell_deliver: '* 预售商品发货时间将在您选定发货时间内，按付款先后顺序发出，网心保留提前发货的权利。',
    goods_tip: _react2.default.createElement(
        'div',
        { className: 'np-buy-promise' },
        _react2.default.createElement(
            'ul',
            { className: 'oc-promise' },
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement('img', { src: '/images/purchase/ico_cart_7.png', alt: '' }),
                '7\u5929\u65E0\u7406\u7531\u9000\u6362\u8D27'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement('img', { src: '/images/purchase/ico_cart_15.png', alt: '' }),
                '15\u5929\u8D28\u91CF\u95EE\u9898\u6362\u8D27'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement('img', { src: '/images/purchase/ico_cart_365.png', alt: '' }),
                '365\u5929\u4FDD\u4FEE'
            )
        )
    ),
    submit_order: '提交订单',

    banner_title: '玩客云 畅快下载的私人云盘',
    mj_price_title: _react2.default.createElement(
        'div',
        { className: 'np-buy-text' },
        _react2.default.createElement(
            'h2',
            null,
            '\u73A9\u5BA2\u4E91 \u7545\u5FEB\u4E0B\u8F7D\u7684\u79C1\u4EBA\u4E91\u76D8'
        ),
        _react2.default.createElement(
            'p',
            null,
            '\u3010\u6EE1599\u7ACB\u51CF271\u5143\uFF0C\u5230\u624B\u4EF7328\u5143\uFF01\u9650\u65F6\u6D3B\u52A8\u3011\u5168\u65B0\u4E00\u4EE3\u5171\u4EAB\u667A\u80FD\u786C\u4EF6\uFF0C\u7528\u6237\u5206\u4EAB\u95F2\u7F6E\u7684\u7F51\u7EDC\u5E26\u5BBD\u3001\u5B58\u50A8\u7A7A\u95F4\u4EE5\u53CA\u8BA1\u7B97\u8D44\u6E90\uFF1B'
        ),
        _react2.default.createElement(
            'div',
            { className: 'np-buy-price' },
            '\u9650\u65F6\u4F18\u60E0\uFF1A',
            _react2.default.createElement(
                'em',
                null,
                _react2.default.createElement(
                    'span',
                    null,
                    '328'
                ),
                '\u5143'
            ),
            _react2.default.createElement(
                'del',
                null,
                '599\u5143'
            )
        )
    ),
    mj_price: _react2.default.createElement(
        'div',
        { className: 'np-buy-sum' },
        _react2.default.createElement(
            'p',
            null,
            '\u5408\u8BA1\uFF1A',
            _react2.default.createElement(
                'em',
                null,
                '480'
            ),
            '\u5143'
        )
    ),
    // sub_title: <p><strong><a href="/html/book.html">【119元优惠券，满599元使用，立即领取】</a></strong>全新一代区块链共享经济智能硬件，全球首个共享计算+区块链应用</p>,
    sub_title: _react2.default.createElement(
        'p',
        null,
        '\u5168\u65B0\u4E00\u4EE3\u533A\u5757\u94FE\u5171\u4EAB\u7ECF\u6D4E\u667A\u80FD\u786C\u4EF6\uFF0C\u5168\u7403\u9996\u4E2A\u5171\u4EAB\u8BA1\u7B97+\u533A\u5757\u94FE\u5E94\u7528'
    ),
    banner_subtitle: '2小时不限量火热预定中',
    presell_ing: '不限量预售开启中',
    deposit_number1: '已有',
    deposit_number2: '人预约',
    date_day: '天',
    date_hour: '时',
    date_minute: '分',
    date_second: '秒',

    colorcom_subtitle: '选择颜色',
    colorcom_zero: '(售罄)',
    delivercom_subtitle: '选择发货日期',

    imagecode_title: '验证码',
    imagecode_input: '请输入图形验证码',

    rtncode_30004: '当前时间不能抢购',
    rtncode_30006: '状态异常',
    rtncode_30007: '已经抢购成功',
    rtncode_30008: '找不到订单记录',
    rtncode_30009: "没有抢购到资格，无法支付",
    rtncode_30003: '已经预定过了',
    rtncode_40000: "非活动时间",
    rtncode_30106: '宝码已经使用',
    rtncode__2: '系统繁忙，请稍后再试',
    rtncode__2004: '本期已经售罄',
    rtncode__2000: '抢购未开始',
    rtncode__1003: '宝码已被使用',
    rtncode__5: '超过频率限制，请稍后再试',
    rtncode_41006: '订单已超时，请规定时间内付款',
    rtncode_41007: '<h3>您的订单提交失败</h3><p>您在预售订单生成后实际付款前有超过2次超时未支付订单，已失去继续参与本次预售活动的资格，感谢您的支持。</p>',
    rtncode_41007_2: '购买次数超过限制',
    rtncode_41009: '已支付',
    rtncode_41013: '没有这个发货日期了',
    rtncode_41014: '系统繁忙，请稍后再次刷新',
    rtncode_41016: '订单不存在',
    rtncode_41008: '<h3>每位用户限购1台玩客云</h3><p>为充分保证广大玩客的利益，已成功在官网购买过的用户，将不再参与本次玩客云预售，请您谅解。</p>',
    rtncode__301: '<h3>当前账号异常</h3><p>系统检测到您当前账号存在异常行为记录，您将无法参与本次购买，请您谅解。</p>',
    rtncode_30032: '<h3>当前账号异常</h3><p>系统检测到您当前账号存在异常行为记录，您将无法参与本次购买，请您谅解。</p>',
    rtncode_41011: '<h3>您的订单提交失败</h3><p>您在预售订单生成后实际付款前有超过2次超时未支付订单，已失去继续参与本次预售活动的资格，感谢您的支持。</p>',
    rtncode__1: '参数不合法',
    rtncode_41010: '<h3>您有1笔未支付订单</h3>' + '<p>检测到您存在一笔未支付预售订单，请您尽快完成付款。如果超时未支付，本次订单将自动失效。</p>',
    rtncode_30005: '<i class="i-oc-sorry"></i><h3>抱歉，本轮玩客云已售罄</h3><p>在您选购颜色时，我们的玩客云已经售罄，请不要灰心，悄悄的告诉您，您可免预约直接参与下期抢购喔。</p>',
    rtncode_30016: '<i class="i-oc-sorry"></i><h3>抱歉，曜石黑已售罄</h3><p>都是我不好，人数太多，机器太少，曜石黑已售罄，建议您尝试选择其他颜色喔。</p>',
    rtncode_30025: '<i class="i-oc-sorry"></i><h3>抱歉，爱马仕橙已售罄</h3><p>都是我不好，人数太多，机器太少，爱马仕橙已售罄，建议您尝试选择其他颜色喔。</p>',
    rtncode_30026: '<i class="i-oc-sorry"></i><h3>抱歉，科技蓝已售罄</h3><p>都是我不好，人数太多，机器太少，科技蓝已售罄，建议您尝试选择其他颜色喔。</p>',
    tips_continue: '继续购买',
    rtncode_41012: '<i class="i-oc-finished"></i><p>活动尚未开始，请您耐心等待喔</p>',
    rtncode_41018: '<i class="i-oc-finished"></i><p>玩客云预售尚未开启，请您耐心等待喔。</p>',
    rtncode_41022: '<i class="i-oc-finished"></i><p>活动尚未开启，请您耐心等待喔。</p> ',
    rtncode_30303: '<i class="i-oc-finished"></i><p>满减活动已结束</p>',

    rtntqcode_used: '特权码已经使用'

}, _defineProperty(_module$exports, 'rtntqcode_used', '特权码已经使用'), _defineProperty(_module$exports, 'fcode_notget', '未检测到宝码，去使用宝码'), _defineProperty(_module$exports, 'fcode_use', '使用宝码购买'), _defineProperty(_module$exports, 'fcode_tips', '支持：7天无理由退货，15天包换，1年保修'), _defineProperty(_module$exports, 'tqcode_notget', '未检测到特权码，去使用特权码'), _defineProperty(_module$exports, 'tqcode_use', '使用特权码购买'), _defineProperty(_module$exports, 'deposit_notbegin', '<i class="i-oc-finished"></i><h3>活动尚未开启</h3><p>预售开启时间：12月13日-19日 每天10:00-18:00，敬请期待</p>'), _defineProperty(_module$exports, 'deposit_end', '<i class="i-oc-finished"></i><h3>预售活动已结束</h3><p>玩客云预售活动已结束，感谢您的支持！</p>'), _defineProperty(_module$exports, 'notifi_selectcolor', '请选择颜色'), _defineProperty(_module$exports, 'notifi_selectdate', '请选择发货日期'), _defineProperty(_module$exports, 'deposit_tips_limit', '<h3>温馨提示</h3><p>每个用户只可提交2次预售订单，检测到您存在一笔超时失效预售订单，本次提交订单后请您尽快完成付款，如果再次支付超时，您将不能继续参与本次预售活动。</p>'), _defineProperty(_module$exports, 'deposit_tips_queue', '<i class="i-oc-queue"></i><h3>正在排队中，请不要刷新页面</h3><p>当前参与预售的小伙伴较多，正在努力为您排队，请您耐心等待，不要刷新页面喔。</p>'), _defineProperty(_module$exports, 'deposit_tips_yongdu', '<i class="i-oc-yongdu"></i><h3>抱歉，网络走丢了</h3><p>当前购买人数较多，正在努力为您加载，请稍候重试喔。</p>'), _defineProperty(_module$exports, 'deposit_tips_success', '<i class="i-oc-chenggong"></i><h3>恭喜你，已成功预定玩客云1台</h3><p>该笔订单支付有效期为15分钟，请尽快完成支付，逾期支付订单将做失效处理。</p>'), _defineProperty(_module$exports, 'deposit_tips_queue2', '<i class="i-oc-queue"></i><h3>正在排队中，请不要刷新页面</h3><p>当前参与预售的小伙伴较多，正在努力为您排队，请您耐心等待，不要刷新页面喔。</p>'), _defineProperty(_module$exports, 'product_title', '产品数量'), _defineProperty(_module$exports, 'product_num', '1台'), _defineProperty(_module$exports, 'deposit_rules', _react2.default.createElement(
    'div',
    { className: 'oc-buy-aside-rule' },
    _react2.default.createElement(
        'h3',
        null,
        '\u9810\u552E\u6D3B\u52D5\u898F\u5247'
    ),
    _react2.default.createElement(
        'ol',
        { className: 'oc-buy-aside-rule-list' },
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u9810\u552E\u6D3B\u52D5\u671F\u9593\uFF1A'
            ),
            '12\u670813\u65E5-12\u670819\u65E5\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u9810\u552E\u958B\u653E\u6642\u9593\uFF1A'
            ),
            '12\u670813\u65E5-19\u65E5 \u6BCF\u592910:00-18:00\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u9810\u552E\u5546\u54C1\uFF1A'
            ),
            '\u73A9\u5BA2\u96F2\uFF0C\u9854\u8272\u7232\u79D1\u6280\u85CD\u3001\u66DC\u77F3\u9ED1\u3001\u611B\u99AC\u4ED5\u6A59\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u9810\u552E\u50F9\u683C\uFF1A'
            ),
            '399\u5143\u5168\u6B3E\u9810\u552E\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u9810\u552E\uFF1A'
            ),
            '\u662F\u6307\u60A8\u7121\u9700\u9810\u7D04\u73A9\u5BA2\u96F2\uFF0C\u9078\u5B9A\u767C\u8CA8\u6642\u9593\u5F8C\u63D0\u524D\u5168\u6B3E\u652F\u4ED8\uFF0C\u4EE5\u60A8\u652F\u4ED8\u6210\u529F\u7CFB\u7D71\u544A\u77E5\u767C\u8CA8\u6642\u9593\u7232\u51C6\uFF0C\u6211\u5011\u5C07\u6309\u627F\u8AFE\u7684\u6642\u9593\u9678\u7E8C\u7232\u60A8\u5B89\u6392\u767C\u8CA8\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u9650\u8CFC\u6578\u91CF\uFF1A'
            ),
            _react2.default.createElement(
                'strong',
                null,
                '\u7232\u5145\u5206\u4FDD\u969C\u7528\u6236\u6B0A\u76CA\uFF0C\u6BCF\u500B\u7528\u6236\u50C5\u9650\u8CFC\u8CB71\u53F0\u73A9\u5BA2\u96F2\uFF0C\u91CD\u8907\u8CFC\u8CB7\u7121\u6548\uFF0C\u5DF2\u7D93\u6210\u529F\u5728\u73A9\u5BA2\u96F2\u5B98\u7DB2\u8CFC\u8CB7\u904E\u73A9\u5BA2\u96F2\u7684\u7528\u6236\u5C07\u7121\u6CD5\u53C3\u8207\u672C\u6B21\u9810\u552E\u6D3B\u52D5\uFF1B'
            )
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u767C\u8CA8\u6642\u9593\uFF1A'
            ),
            _react2.default.createElement(
                'strong',
                null,
                '\u9810\u552E\u5546\u54C1\u7684\u767C\u8CA8\u6642\u9593\uFF0C\u5728\u60A8\u9078\u5B9A\u767C\u8CA8\u6642\u9593\u6A94\u5167\u6309\u4ED8\u6B3E\u7684\u5148\u5F8C\u9806\u5E8F\u9678\u7E8C\u5B89\u6392\u767C\u51FA\uFF0C\u7DB2\u5FC3\u79D1\u6280\u4FDD\u7559\u63D0\u524D\u767C\u8CA8\u7684\u6B0A\u5229\uFF0C'
            ),
            '\u7232\u4E86\u4FDD\u8B49\u826F\u597D\u7684\u7528\u6236\u9AD4\u9A57\uFF0C\u6211\u5011\u6703\u5728\u6BCF\u6708\u8A2D\u7F6E\u53EF\u767C\u8CA8\u7684\u6642\u9593\u6A94\u4F4D\u4F9B\u7528\u6236\u9078\u64C7\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u63D0\u4EA4\u8A02\u55AE\uFF1A'
            ),
            '\u8ACB\u6B63\u78BA\u586B\u5BEB\u6536\u8CA8\u4FE1\u606F\uFF0C\u9078\u53D6\u914D\u9001\u65B9\u5F0F\u4E26\u78BA\u8A8D\u6240\u9078\u5546\u54C1\u9854\u8272\u3001\u50F9\u683C\u4FE1\u606F\uFF0C\u8ACB\u76E1\u5FEB\u63D0\u4EA4\u8A02\u55AE\uFF0C\u8A02\u55AE\u4E00\u65E6\u63D0\u4EA4\u5C07\u4E0D\u53EF\u53D6\u6D88\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u652F\u4ED8\u6642\u6548\uFF1A'
            ),
            _react2.default.createElement(
                'strong',
                null,
                '\u8ACB\u7559\u610F\u60A8\u7684\u8A02\u55AE\u652F\u4ED8\u6642\u6548\uFF0C\u8A02\u55AE\u751F\u6210\u5F8C\u5373\u9032\u516515\u5206\u937E\u652F\u4ED8\u5012\u8A08\u6642\uFF0C'
            ),
            '\u6C92\u6709\u5728\u652F\u4ED8\u6642\u6548\u5167\u6210\u529F\u652F\u4ED8\u7684\u8A02\u55AE\uFF0C\u7CFB\u7D71\u5C07\u8996\u7232\u60A8\u81EA\u52D5\u653E\u68C4\u4E26\u53D6\u6D88\u8A02\u55AE\uFF0C\u60A8\u6240\u5360\u7684\u767C\u8CA8\u6642\u9593\u540D\u984D\u4E5F\u5C07\u88AB\u91CD\u65B0\u91CB\u653E\uFF0C\u5DF2\u652F\u4ED8\u6210\u529F\u7684\u8A02\u55AE\u8996\u7232\u672C\u6B21\u9810\u552E\u4E0B\u55AE\u6210\u529F\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u6709\u95DC\u652F\u4ED8\uFF1A'
            ),
            '\u6BCF\u4F4D\u7528\u6236\u53EF\u4EE5\u4E0B\u55AE2\u6B21\uFF0C\u50C5\u53EF\u6210\u529F\u8CFC\u8CB71\u6B21\u3002\u60A8\u5728\u8A02\u55AE\u751F\u6210\u5F8C\u5BE6\u969B\u4ED8\u6B3E\u524D\u8D85\u904E2\u6B21\u8D85\u6642\u672A\u652F\u4ED8\u8A02\u55AE\uFF0C\u5C07\u5931\u53BB\u7E7C\u7E8C\u53C3\u8207\u672C\u6B21\u9810\u552E\u6D3B\u52D5\u7684\u8CC7\u683C\uFF0C\u7528\u6236\u5B8C\u6210\u652F\u4ED8\u7684\u6642\u9593\u4EE5\u7B2C\u4E09\u65B9\u652F\u4ED8\u6216\u9280\u884C\u63D0\u4F9B\u7D66\u7DB2\u5FC3\u7684\u652F\u4ED8\u6D41\u6C34\u6642\u9593\u7232\u51C6\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u9810\u552E\u5546\u54C1\u652F\u4ED8\u50F9\u683C\uFF1A'
            ),
            '\u4EE5\u60A8\u652F\u4ED8\u6210\u529F\u6642\u7684\u50F9\u683C\u7232\u51C6\uFF0C\u5982\u9810\u552E\u5546\u54C1\u767C\u751F\u8ABF\u50F9\uFF0C\u5DF2\u652F\u4ED8\u8A02\u55AE\u5C07\u4E0D\u53D7\u5F71\u97FF\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u9810\u552E\u8A02\u55AE\u5FEB\u905E\uFF1A'
            ),
            '\u9810\u552E\u8A02\u55AE\u4E0D\u652F\u6301\u81EA\u63D0\uFF0C\u6211\u5011\u9ED8\u8A8D\u7533\u901A\u5FEB\u905E\uFF0C\u5982\u9078\u9806\u8C50\u5FEB\u905E\uFF0C\u9700\u984D\u5916\u652F\u4ED818\u5143\u5FEB\u905E\u8CBB\u7528\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u6709\u95DC\u6DD8\u5BF6\u8846\u7C4C\u512A\u60E0\u5238\uFF1A'
            ),
            '\u672C\u6B21\u9810\u552E\u6D3B\u52D5\u652F\u6301\u6DD8\u5BF6\u8846\u7C4C\u671F\u9593\u8CFC\u8CB7\u7684\u512A\u60E0\u5238\u62B5\u6263\uFF0C\u8ACB\u5728\u512A\u60E0\u5238\u6709\u6548\u671F\u524D\u5B8C\u6210\u4F7F\u7528\uFF0C\u512A\u60E0\u5238\u6BCF\u500B\u7528\u6236\u53EA\u80FD\u4F7F\u75281\u5F35\uFF0C\u4E0D\u53EF\u758A\u52A0\uFF0C\u4E00\u7D93\u4F7F\u7528\u7ACB\u5373\u4F5C\u5EE2\uFF0C\u5982\u4F7F\u7528\u512A\u60E0\u5238\u5F8C\u7533\u8ACB\u53D6\u6D88\u8A02\u55AE\uFF0C\u9000\u6B3E\u6642\u4EE5\u5BE6\u969B\u652F\u4ED8\u91D1\u984D\u7232\u51C6\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u9810\u552E\u8A02\u55AE\u9000\u6B3E\uFF1A'
            ),
            '\u9810\u552E\u8A02\u55AE\u5728\u9810\u552E\u6D3B\u52D5\u7D50\u675F\u5F8C\u81F3\u767C\u8CA8\u65E5\u7684\u524D\u4E00\u5929\u4E2D\u534812:00\u4E4B\u524D\uFF0C\u7528\u6236\u53EF\u901A\u904E\u6211\u7684\u8A02\u55AE\u81EA\u52D5\u7533\u8ACB\u552E\u5F8C\u53D6\u6D88\u9810\u552E\u8A02\u55AE\uFF0C\u5BA2\u670D\u5728\u6536\u5230\u60A8\u7684\u7533\u8ACB\u5F8C\uFF0C\u5C07\u4E8E3-5\u500B\u5DE5\u4F5C\u65E5\u5167\u7232\u60A8\u8FA6\u7406\u9000\u6B3E\u64CD\u4F5C\uFF0C\u9810\u552E\u8A02\u55AE\u767C\u8CA8\u5F8C\uFF0C\u9000\u63DB\u8CA8\u6D41\u7A0B\u540C\u6B63\u5E38\u8A02\u55AE\u4E00\u81F4\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u8A02\u55AE\u5730\u5740\u4E0D\u53EF\u4FEE\u6539\uFF1A'
            ),
            '\u7232\u6253\u64CA\u9EC3\u725B\uFF0C\u6536\u8CA8\u4FE1\u606F\u5C07\u4E0D\u53EF\u8B8A\u66F4\uFF0C\u8ACB\u4ED4\u7D30\u78BA\u8A8D\u60A8\u7684\u6536\u8CA8\u4FE1\u606F\uFF0C\u4ED8\u6B3E\u6210\u529F\u5F8C\u5C07\u4E0D\u53EF\u66F4\u6539\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'strong',
                null,
                '\u9632\u7BC4\u9EC3\u725B\uFF1A'
            ),
            '\u7232\u4FDD\u8B77\u5EE3\u5927\u7528\u6236\u7684\u6B0A\u76CA\uFF0C\u6253\u64CA\u9EC3\u725B\u9AD8\u50F9\u5012\u8CE3\uFF0C\u7DB2\u5FC3\u5C07\u4FDD\u7559\u53D6\u6D88\u60E1\u610F\u8A02\u55AE\u4E26\u7D66\u4E88\u9000\u6B3E\u7684\u6B0A\u5229\uFF0C\u4E00\u65E6\u767C\u73FE\u7528\u6236\u5B58\u5728\u60E1\u610F\u5237\u55AE\u3001\u4E00\u4EBA\u591A\u55AE\u3001\u8D85\u6642\u652F\u4ED8\u7B49\u9055\u898F\u884C\u7232\uFF0C\u7DB2\u5FC3\u6709\u6B0A\u7ACB\u5373\u53D6\u6D88\u7528\u6236\u7684\u8A02\u55AE\u4E26\u7D66\u4E88\u9000\u6B3E\uFF0C\u4E14\u8A72\u7528\u6236\u5931\u53BB\u7E7C\u7E8C\u53C3\u8207\u672C\u6B21\u9810\u552E\u6D3B\u52D5\u7684\u8CC7\u683C\u3002\u7DB2\u5FC3\u6709\u6B0A\u4F9D\u64DA\u672C\u5354\u8B70\u7D04\u5B9A\u5167\u5BB9\u57FA\u4E8E\u7368\u7ACB\u81EA\u4E3B\u5224\u65B7\u8A8D\u5B9A\u7528\u6236\u662F\u5426\u5B58\u5728\u60E1\u610F\u5237\u55AE\u3001\u4E00\u4EBA\u591A\u55AE\u3001\u8D85\u6642\u652F\u4ED8\u7B49\u9055\u898F\u884C\u7232\uFF0C\u5982\u7528\u6236\u5C0D\u7DB2\u5FC3\u53D6\u6D88\u8A02\u55AE\u5B58\u6709\u7570\u8B70\u7684\uFF0C\u61C9\u7576\u81EA\u5176\u8A02\u55AE\u88AB\u53D6\u6D88\u8D7724\u5C0F\u6642\u5167\u8207\u7DB2\u5FC3\u806F\u7CFB\uFF0C\u8D85\u904E24\u5C0F\u6642\u7684\uFF0C\u8996\u7232\u7528\u6236\u4E0D\u5B58\u6709\u4EFB\u4F55\u7570\u8B70\u3002'
        )
    ),
    _react2.default.createElement(
        'h3',
        null,
        '\u6EAB\u99A8\u63D0\u793A\uFF1A'
    ),
    _react2.default.createElement(
        'ol',
        { className: 'oc-buy-aside-rule-list' },
        _react2.default.createElement(
            'li',
            null,
            '\u73A9\u5BA2\u96F2\u5B98\u65B9\u8CFC\u8CB7\u6E20\u9053\uFF1A\u73A9\u5BA2\u96F2PC\u7248\u5B98\u7DB2\u3001\u79FB\u52D5\u7248\u5B98\u7DB2\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            '\u7232\u78BA\u4FDD\u60A8\u5728\u66F4\u65E9\u7684\u6642\u9593\u62FF\u5230\u5546\u54C1\uFF0C\u8ACB\u5728\u958B\u552E\u524D\u6821\u51C6\u60A8\u7684\u96FB\u8166\u6216\u624B\u6A5F\u6642\u9593\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            '\u7531\u4E8E\u8FD1\u671F\u73A9\u5BA2\u96F2\u5305\u88DDLOGO\u9032\u884C\u4E86\u66F4\u65B0\uFF0C\u65B0\u8001\u5305\u88DD\u5C07\u96A8\u6A5F\u767C\u8CA8\uFF0C\u656C\u8ACB\u8AD2\u89E3\uFF1B'
        ),
        _react2.default.createElement(
            'li',
            null,
            '\u5982\u6709\u4EFB\u4F55\u7591\u554F\u8ACB\u64A5\u6253400-109-8880\u9084\u53EF\u8A2A\u554F\u670D\u52D9\u9801',
            _react2.default.createElement(
                'a',
                { href: 'http://wpa.qq.com/msgrd?v=3&uin=212454816&site=qq&menu=yes', target: '_blank' },
                '\u806F\u7CFBQQ\u5728\u7DDA\u5BA2\u670D'
            ),
            '\uFF0C\u670D\u52D9\u6642\u9593 09:00-21:00\u3002'
        )
    )
)), _defineProperty(_module$exports, 'buy_steps', _react2.default.createElement(
    'div',
    { className: 'oc-buy-aside-steps' },
    _react2.default.createElement(
        'h3',
        null,
        '\u9884\u5B9A\u8D2D\u4E70\u6D41\u7A0B'
    ),
    _react2.default.createElement(
        'ol',
        null,
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'h4',
                null,
                '1. \u9884\u5B9A\u8D2D\u4E70'
            ),
            _react2.default.createElement(
                'p',
                null,
                '\u9884\u5B9A\u5373\u5C06\u5F00\u59CB'
            )
        ),
        _react2.default.createElement('li', { className: 'oc-buy-aside-steps-arrow' }),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'h4',
                null,
                '2. \u9884\u4ED8\u5B9A\u91D1'
            ),
            _react2.default.createElement(
                'p',
                null,
                '2017-08-10 10:10\u81F32017-08-30: 18:00'
            )
        ),
        _react2.default.createElement('li', { className: 'oc-buy-aside-steps-arrow' }),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'h4',
                null,
                '3. \u652F\u4ED8\u5C3E\u6B3E'
            ),
            _react2.default.createElement(
                'p',
                null,
                '\u7B49\u5F85\u5C3E\u6B3E\u65F6\u95F4\u5F00\u542F'
            )
        ),
        _react2.default.createElement('li', { className: 'oc-buy-aside-steps-arrow' }),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'h4',
                null,
                '4. \u53D1\u8D27'
            ),
            _react2.default.createElement(
                'p',
                null,
                '\u6309\u5B9A\u91D1\u652F\u4ED8\u987A\u5E8F\u4F9D\u6B21\u53D1\u8D27'
            )
        )
    )
)), _defineProperty(_module$exports, 'verify_refresh', '刷新题目'), _defineProperty(_module$exports, 'verify_input', '请输入验证码'), _defineProperty(_module$exports, 'verify_yellow', '请您输入一次验证码，您可借助搜索引擎，我们一起防黄牛。'), _defineProperty(_module$exports, 'verify_error', '验证码有误，请重新填写'), _defineProperty(_module$exports, 'verify_empty', '请输入答案'), _module$exports);

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
    color_black: '曜石黑',
    color_orange: '愛馬仕橙',
    color_blue: '科技藍',
    pay_now: '立即支付',
    check_order: '檢視訂單',
    notifi_tryagain: '<i class="i-oc-queue"></i><h3>正在為閣下排隊中...</h3><p>目前搶購人數較多，正在努力為閣下載入，請稍後重試喔。</p>',
    notifi_yongdu: '<i class="i-oc-yongdu"></i><h3>抱歉，網路走丟了</h3><p>目前搶購人數較多，正在努力為閣下載入，請稍後重試喔。</p>',
    notifi_success: '<i class="i-oc-chenggong"></i><h3>恭喜，閣下已經成功搶到玩客雲1台</h3><p>支付有效期為45分鐘，請儘快完成支付，否則訂單將失效喔。</p>',
    notifi_chakan: '<i class="i-oc-chakan"></i><h3>每位玩客只能購買1台玩客雲</h3><p>閣下已經成功搶購，不要貪心哦。</p>',
    notifi_limit1: '<h3>請您先預約</h3><p>預約成功的用戶才能參與搶購玩客雲哦！</p>',

    login_remind: '為了方便購買，請提前登錄',
    login_now: '立即登錄',
    close: '關閉',
    ok: '確定',
    pic_soldout: '已搶完',
    more: '已搶完',
    count_down1: '離搶購開始還有',
    count_down2: '正在搶購中...',
    buy_now: '立即購買',
    price_official: _react2.default.createElement(
        'span',
        { className: 'oc-buy-price-pay' },
        '\u5B98\u7DB2\u8CFC\u8CB7\uFF1AHK$720'
    ),
    price_official_v2: _react2.default.createElement(
        'div',
        { className: 'np-buy-price' },
        '\u5B98\u7DB2\u8CFC\u8CB7\uFF1A',
        _react2.default.createElement(
            'em',
            null,
            _react2.default.createElement(
                'span',
                null,
                'HK$720'
            )
        )
    ),
    price_yuan: '元',
    price_total: _react2.default.createElement(
        'h3',
        null,
        '\u5408\u8A08\uFF1A',
        _react2.default.createElement(
            'strong',
            null,
            'HK$720'
        )
    ),
    price_total_custom: function price_total_custom(props) {
        return _react2.default.createElement(
            'h3',
            null,
            '\u5408\u8A08\uFF1A',
            _react2.default.createElement(
                'strong',
                null,
                'HK$',
                props.price
            )
        );
    },
    price_presalle: _react2.default.createElement(
        'h3',
        null,
        '\u9810\u552E\u50F9\uFF1A',
        _react2.default.createElement(
            'strong',
            null,
            'HK$720'
        )
    ),
    tips_deliver: '溫馨貼士：選擇送貨上門的用戶將於付款成功后7日內發貨，選擇自提取貨的用戶請在收到自提訊息后的7日內完成提貨。',
    goods_tip: _react2.default.createElement(
        'div',
        { className: 'np-buy-promise' },
        _react2.default.createElement('i', { className: 'i-promise' }),
        '7\u5929\u7121\u7406\u7531\u9000\u63DB\u8CA8\xA0\xA0\xA0\xA0',
        _react2.default.createElement('i', { className: 'i-promise' }),
        '15\u5929\u8CEA\u91CF\u554F\u984C\u63DB\u8CA8\xA0\xA0\xA0\xA0',
        _react2.default.createElement('i', { className: 'i-promise' }),
        '365\u5929\u4FDD\u4FEE'
    ),
    price_discount: function price_discount(props) {
        return _react2.default.createElement(
            'span',
            { className: 'oc-buy-price-pay' },
            '\u6D3B\u52D5\u512A\u60E0\u50F9: HK$',
            props.price,
            ' ',
            _react2.default.createElement(
                's',
                null,
                'HK$720'
            )
        );
    },
    tips_presell_deliver: '* 預售商品發貨時間將在閣下選定發貨時間內，按付款先後順序發出，網心保留提前發貨的權利。',
    submit_order: '提交訂單',

    banner_title: '玩客雲 自由暢快的個人雲盤',
    banner_subtitle: '2小時不限量火熱預定中',
    sub_title: _react2.default.createElement(
        'p',
        null,
        '\u5168\u65B0\u58F9\u4EE3\u5171\u4EAB\u667A\u80FD\u786C\u4EF6\uFF0C\u7528\u6236\u5206\u4EAB\u9591\u7F6E\u7684\u7DB2\u7D61\u5E36\u5BEC\u3001\u5B58\u5132\u7A7A\u9593\u4EE5\u53CA\u8A08\u7B97\u8CC7\u6E90'
    ),
    presell_ing: '不限量預售开启中',
    deposit_number1: '已有',
    deposit_number2: '人預約',
    date_day: '天',
    date_hour: '時',
    date_minute: '分',
    date_second: '秒',

    colorcom_subtitle: '選擇顏色',
    colorcom_zero: '(售罄)',
    delivercom_subtitle: '選擇發貨日期',

    imagecode_title: '驗證碼',
    imagecode_input: '請輸入圖形驗證碼',

    rtncode_30004: '目前時間不能搶購',
    rtncode_30006: '狀態異常',
    rtncode_30007: '已經搶購成功',
    rtncode_30008: '找不到訂單記錄',
    rtncode_30009: "沒有搶購到資格，無法支付",
    rtncode_30003: '已經預定過了',
    rtncode_40000: "非活動時間",
    rtncode_30106: '寶碼已經使用',
    rtncode__2: '系統繁忙，請稍後再試',
    rtncode__2004: '本期已經售罄',
    rtncode__2000: '搶購未開始',
    rtncode__1003: '寶碼已被使用',
    rtncode__5: '超過頻率限制，請稍後再試',
    rtncode_41006: '訂單已逾時，請規定時間內付款',
    rtncode_41007: '<h3>您的訂單提交失敗</h3><p>您在預售訂單生成後實際付款前有超過2次超時未支付訂單，已失去繼續參與本次預售活動的資格，感謝您的支持。</p>',
    rtncode_41007_2: '購買次數超過限制',
    rtncode_41009: '已支付',
    rtncode_41013: '沒有這個發貨日期了',
    rtncode_41014: '系統繁忙，請稍後再次重新整理',
    rtncode_41016: '訂單不存在',
    rtncode_41008: '<h3>每位用戶限購1台玩客雲</h3><p>爲充分保證廣大玩客的利益，已成功在官網購買過的用戶，將不再參與本次玩客雲預售，請您諒解。</p>',
    rtncode__301: '<h3>當前賬號異常</h3><p>系統檢測到您當前賬號存在異常行爲記錄，您將無法參與本次購買，請您諒解。</p>',
    rtncode_30032: '<h3>當前賬號異常</h3><p>系統檢測到您當前賬號存在異常行爲記錄，您將無法參與本次購買，請您諒解。</p>',
    rtncode_41011: '<h3>您的訂單提交失敗</h3><p>您在預售訂單生成後實際付款前有超過2次超時未支付訂單，已失去繼續參與本次預售活動的資格，感謝您的支持。</p>',
    rtncode__1: '參數不合法',
    rtncode_41010: '<h3>您有1筆未支付訂單</h3><p>檢測到您存在一筆未支付預售訂單，請您盡快完成付款。如果超時未支付，本次訂單將自動失效。</p>',
    rtncode_30005: '<i class="i-oc-sorry"></i><h3>抱歉，本輪玩客雲已售罄</h3><p>在您選購顔色時，我們的玩客雲已經售罄，請不要灰心，悄悄的告訴您，您可免預約直接參與下期搶購喔。</p>',
    rtncode_30016: '<i class="i-oc-sorry"></i><h3>抱歉，曜石黑已售罄</h3><p>都是我不好，人數太多，機器太少，曜石黑已售罄，建議您嘗試選擇其他顔色喔。</p>',
    rtncode_30025: '<i class="i-oc-sorry"></i><h3>抱歉，愛馬仕橙已售罄</h3><p>都是我不好，人數太多，機器太少，愛馬仕橙已售罄，建議您嘗試選擇其他顔色喔。</p>',
    rtncode_30026: '<i class="i-oc-sorry"></i><h3>抱歉，科技藍已售罄</h3><p>都是我不好，人數太多，機器太少，科技藍已售罄，建議您嘗試選擇其他顔色喔。</p>',
    tips_continue: '繼續購買',
    rtncode_41012: '<i class="i-oc-finished"></i><p>活動尚未開始，請閣下耐心等待喔</p>',
    rtncode_41018: '<i class="i-oc-finished"></i><p>玩客雲預售尚未開啟，請閣下耐心等待喔。</p>',
    rtncode_41022: '<i class="i-oc-finished"></i><p>活動尚未開啟，請閣下耐心等待喔。</p> ',
    rtncode_30303: '<i class="i-oc-finished"></i><p>滿減活動已結束</p>',

    fcode_notget: '未偵測到寶碼，去使用寶碼',
    fcode_use: '使用寶碼購買',
    fcode_tips: '溫馨貼士：玩客雲售後服務承諾，嚴格依據香港特別行政區當地相關法律實行售後服務',

    deposit_notbegin: '<i class="i-oc-finished"></i><h3>活動尚未開啓</h3><p>預售開啓時間：12月13日-19日 每天10:00-18:00，敬請期待</p>',
    deposit_end: '<i class="i-oc-finished"></i><h3>預售活動已結束</h3><p>玩客雲預售活動已結束，感謝您的支持！</p>',
    notifi_selectcolor: '請選擇顔色',
    notifi_selectdate: '請選擇發貨日期',
    deposit_tips_limit: '<h3>溫馨提示</h3><p>每個用戶只可提交2次預售訂單，檢測到您存在一筆超時失效預售訂單，本次提交訂單後請您盡快完成付款，如果再次支付超時，您將不能繼續參與本次預售活動。</p>',
    deposit_tips_queue: '<i class="i-oc-queue"></i><h3>正在排隊中，請不要刷新頁面</h3><p>當前參與預售的小夥伴較多，正在努力爲您排隊，請您耐心等待，不要刷新頁面喔。</p>',
    deposit_tips_yongdu: '<i class="i-oc-yongdu"></i><h3>抱歉，網絡走丟了</h3><p>當前購買人數較多，正在努力爲您加載，請稍候重試喔。</p>',
    deposit_tips_success: '<i class="i-oc-chenggong"></i><h3>恭喜你，已成功預定玩客雲1台</h3><p>該筆訂單支付有效期爲15分鍾，請盡快完成支付，逾期支付訂單將做失效處理。</p>',
    deposit_tips_queue2: '<i class="i-oc-queue"></i><h3>正在排隊中，請不要刷新頁面</h3><p>當前參與預售的小夥伴較多，正在努力爲您排隊，請您耐心等待，不要刷新頁面喔。</p>',
    product_title: '産品數量',
    product_num: '1台',

    deposit_rules: _react2.default.createElement(
        'div',
        { className: 'oc-buy-aside-rule' },
        _react2.default.createElement(
            'h3',
            null,
            '\u9884\u552E\u6D3B\u52A8\u89C4\u5219'
        ),
        _react2.default.createElement(
            'ol',
            { className: 'oc-buy-aside-rule-list' },
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u9884\u552E\u6D3B\u52A8\u671F\u95F4\uFF1A'
                ),
                '12\u670813\u65E5-12\u670819\u65E5\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u9884\u552E\u5F00\u653E\u65F6\u95F4\uFF1A'
                ),
                '12\u670813\u65E5-19\u65E5 \u6BCF\u592910:00-18:00\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u9884\u552E\u5546\u54C1\uFF1A'
                ),
                '\u73A9\u5BA2\u4E91\uFF0C\u989C\u8272\u4E3A\u79D1\u6280\u84DD\u3001\u66DC\u77F3\u9ED1\u3001\u7231\u9A6C\u4ED5\u6A59\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u9884\u552E\u4EF7\u683C\uFF1A'
                ),
                '399\u5143\u5168\u6B3E\u9884\u552E\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u9884\u552E\uFF1A'
                ),
                '\u662F\u6307\u60A8\u65E0\u9700\u9884\u7EA6\u73A9\u5BA2\u4E91\uFF0C\u9009\u5B9A\u53D1\u8D27\u65F6\u95F4\u540E\u63D0\u524D\u5168\u6B3E\u652F\u4ED8\uFF0C\u4EE5\u60A8\u652F\u4ED8\u6210\u529F\u7CFB\u7EDF\u544A\u77E5\u53D1\u8D27\u65F6\u95F4\u4E3A\u51C6\uFF0C\u6211\u4EEC\u5C06\u6309\u627F\u8BFA\u7684\u65F6\u95F4\u9646\u7EED\u4E3A\u60A8\u5B89\u6392\u53D1\u8D27\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u9650\u8D2D\u6570\u91CF\uFF1A'
                ),
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u4E3A\u5145\u5206\u4FDD\u969C\u7528\u6237\u6743\u76CA\uFF0C\u6BCF\u4E2A\u7528\u6237\u4EC5\u9650\u8D2D\u4E701\u53F0\u73A9\u5BA2\u4E91\uFF0C\u91CD\u590D\u8D2D\u4E70\u65E0\u6548\uFF0C\u5DF2\u7ECF\u6210\u529F\u5728\u73A9\u5BA2\u4E91\u5B98\u7F51\u8D2D\u4E70\u8FC7\u73A9\u5BA2\u4E91\u7684\u7528\u6237\u5C06\u65E0\u6CD5\u53C2\u4E0E\u672C\u6B21\u9884\u552E\u6D3B\u52A8\uFF1B'
                )
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u53D1\u8D27\u65F6\u95F4\uFF1A'
                ),
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u9884\u552E\u5546\u54C1\u7684\u53D1\u8D27\u65F6\u95F4\uFF0C\u5728\u60A8\u9009\u5B9A\u53D1\u8D27\u65F6\u95F4\u6863\u5185\u6309\u4ED8\u6B3E\u7684\u5148\u540E\u987A\u5E8F\u9646\u7EED\u5B89\u6392\u53D1\u51FA\uFF0C\u7F51\u5FC3\u79D1\u6280\u4FDD\u7559\u63D0\u524D\u53D1\u8D27\u7684\u6743\u5229\uFF0C'
                ),
                '\u4E3A\u4E86\u4FDD\u8BC1\u826F\u597D\u7684\u7528\u6237\u4F53\u9A8C\uFF0C\u6211\u4EEC\u4F1A\u5728\u6BCF\u6708\u8BBE\u7F6E\u53EF\u53D1\u8D27\u7684\u65F6\u95F4\u6863\u4F4D\u4F9B\u7528\u6237\u9009\u62E9\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u63D0\u4EA4\u8BA2\u5355\uFF1A'
                ),
                '\u8BF7\u6B63\u786E\u586B\u5199\u6536\u8D27\u4FE1\u606F\uFF0C\u9009\u53D6\u914D\u9001\u65B9\u5F0F\u5E76\u786E\u8BA4\u6240\u9009\u5546\u54C1\u989C\u8272\u3001\u4EF7\u683C\u4FE1\u606F\uFF0C\u8BF7\u5C3D\u5FEB\u63D0\u4EA4\u8BA2\u5355\uFF0C\u8BA2\u5355\u4E00\u65E6\u63D0\u4EA4\u5C06\u4E0D\u53EF\u53D6\u6D88\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u652F\u4ED8\u65F6\u6548\uFF1A'
                ),
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u8BF7\u7559\u610F\u60A8\u7684\u8BA2\u5355\u652F\u4ED8\u65F6\u6548\uFF0C\u8BA2\u5355\u751F\u6210\u540E\u5373\u8FDB\u516515\u5206\u949F\u652F\u4ED8\u5012\u8BA1\u65F6\uFF0C'
                ),
                '\u6CA1\u6709\u5728\u652F\u4ED8\u65F6\u6548\u5185\u6210\u529F\u652F\u4ED8\u7684\u8BA2\u5355\uFF0C\u7CFB\u7EDF\u5C06\u89C6\u4E3A\u60A8\u81EA\u52A8\u653E\u5F03\u5E76\u53D6\u6D88\u8BA2\u5355\uFF0C\u60A8\u6240\u5360\u7684\u53D1\u8D27\u65F6\u95F4\u540D\u989D\u4E5F\u5C06\u88AB\u91CD\u65B0\u91CA\u653E\uFF0C\u5DF2\u652F\u4ED8\u6210\u529F\u7684\u8BA2\u5355\u89C6\u4E3A\u672C\u6B21\u9884\u552E\u4E0B\u5355\u6210\u529F\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u6709\u5173\u652F\u4ED8\uFF1A'
                ),
                '\u6BCF\u4F4D\u7528\u6237\u53EF\u4EE5\u4E0B\u53552\u6B21\uFF0C\u4EC5\u53EF\u6210\u529F\u8D2D\u4E701\u6B21\u3002\u60A8\u5728\u8BA2\u5355\u751F\u6210\u540E\u5B9E\u9645\u4ED8\u6B3E\u524D\u8D85\u8FC72\u6B21\u8D85\u65F6\u672A\u652F\u4ED8\u8BA2\u5355\uFF0C\u5C06\u5931\u53BB\u7EE7\u7EED\u53C2\u4E0E\u672C\u6B21\u9884\u552E\u6D3B\u52A8\u7684\u8D44\u683C\uFF0C\u7528\u6237\u5B8C\u6210\u652F\u4ED8\u7684\u65F6\u95F4\u4EE5\u7B2C\u4E09\u65B9\u652F\u4ED8\u6216\u94F6\u884C\u63D0\u4F9B\u7ED9\u7F51\u5FC3\u7684\u652F\u4ED8\u6D41\u6C34\u65F6\u95F4\u4E3A\u51C6\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u9884\u552E\u5546\u54C1\u652F\u4ED8\u4EF7\u683C\uFF1A'
                ),
                '\u4EE5\u60A8\u652F\u4ED8\u6210\u529F\u65F6\u7684\u4EF7\u683C\u4E3A\u51C6\uFF0C\u5982\u9884\u552E\u5546\u54C1\u53D1\u751F\u8C03\u4EF7\uFF0C\u5DF2\u652F\u4ED8\u8BA2\u5355\u5C06\u4E0D\u53D7\u5F71\u54CD\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u9884\u552E\u8BA2\u5355\u5FEB\u9012\uFF1A'
                ),
                '\u9884\u552E\u8BA2\u5355\u4E0D\u652F\u6301\u81EA\u63D0\uFF0C\u6211\u4EEC\u9ED8\u8BA4\u7533\u901A\u5FEB\u9012\uFF0C\u5982\u9009\u987A\u4E30\u5FEB\u9012\uFF0C\u9700\u989D\u5916\u652F\u4ED818\u5143\u5FEB\u9012\u8D39\u7528\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u6709\u5173\u6DD8\u5B9D\u4F17\u7B79\u4F18\u60E0\u5238\uFF1A'
                ),
                '\u672C\u6B21\u9884\u552E\u6D3B\u52A8\u652F\u6301\u6DD8\u5B9D\u4F17\u7B79\u671F\u95F4\u8D2D\u4E70\u7684\u4F18\u60E0\u5238\u62B5\u6263\uFF0C\u8BF7\u5728\u4F18\u60E0\u5238\u6709\u6548\u671F\u524D\u5B8C\u6210\u4F7F\u7528\uFF0C\u4F18\u60E0\u5238\u6BCF\u4E2A\u7528\u6237\u53EA\u80FD\u4F7F\u75281\u5F20\uFF0C\u4E0D\u53EF\u53E0\u52A0\uFF0C\u4E00\u7ECF\u4F7F\u7528\u7ACB\u5373\u4F5C\u5E9F\uFF0C\u5982\u4F7F\u7528\u4F18\u60E0\u5238\u540E\u7533\u8BF7\u53D6\u6D88\u8BA2\u5355\uFF0C\u9000\u6B3E\u65F6\u4EE5\u5B9E\u9645\u652F\u4ED8\u91D1\u989D\u4E3A\u51C6\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u9884\u552E\u8BA2\u5355\u9000\u6B3E\uFF1A'
                ),
                '\u9884\u552E\u8BA2\u5355\u5728\u9884\u552E\u6D3B\u52A8\u7ED3\u675F\u540E\u81F3\u53D1\u8D27\u65E5\u7684\u524D\u4E00\u5929\u4E2D\u534812:00\u4E4B\u524D\uFF0C\u7528\u6237\u53EF\u901A\u8FC7\u6211\u7684\u8BA2\u5355\u81EA\u52A8\u7533\u8BF7\u552E\u540E\u53D6\u6D88\u9884\u552E\u8BA2\u5355\uFF0C\u5BA2\u670D\u5728\u6536\u5230\u60A8\u7684\u7533\u8BF7\u540E\uFF0C\u5C06\u4E8E3-5\u4E2A\u5DE5\u4F5C\u65E5\u5185\u4E3A\u60A8\u529E\u7406\u9000\u6B3E\u64CD\u4F5C\uFF0C\u9884\u552E\u8BA2\u5355\u53D1\u8D27\u540E\uFF0C\u9000\u6362\u8D27\u6D41\u7A0B\u540C\u6B63\u5E38\u8BA2\u5355\u4E00\u81F4\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u8BA2\u5355\u5730\u5740\u4E0D\u53EF\u4FEE\u6539\uFF1A'
                ),
                '\u4E3A\u6253\u51FB\u9EC4\u725B\uFF0C\u6536\u8D27\u4FE1\u606F\u5C06\u4E0D\u53EF\u53D8\u66F4\uFF0C\u8BF7\u4ED4\u7EC6\u786E\u8BA4\u60A8\u7684\u6536\u8D27\u4FE1\u606F\uFF0C\u4ED8\u6B3E\u6210\u529F\u540E\u5C06\u4E0D\u53EF\u66F4\u6539\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'strong',
                    null,
                    '\u9632\u8303\u9EC4\u725B\uFF1A'
                ),
                '\u4E3A\u4FDD\u62A4\u5E7F\u5927\u7528\u6237\u7684\u6743\u76CA\uFF0C\u6253\u51FB\u9EC4\u725B\u9AD8\u4EF7\u5012\u5356\uFF0C\u7F51\u5FC3\u5C06\u4FDD\u7559\u53D6\u6D88\u6076\u610F\u8BA2\u5355\u5E76\u7ED9\u4E88\u9000\u6B3E\u7684\u6743\u5229\uFF0C\u4E00\u65E6\u53D1\u73B0\u7528\u6237\u5B58\u5728\u6076\u610F\u5237\u5355\u3001\u4E00\u4EBA\u591A\u5355\u3001\u8D85\u65F6\u652F\u4ED8\u7B49\u8FDD\u89C4\u884C\u4E3A\uFF0C\u7F51\u5FC3\u6709\u6743\u7ACB\u5373\u53D6\u6D88\u7528\u6237\u7684\u8BA2\u5355\u5E76\u7ED9\u4E88\u9000\u6B3E\uFF0C\u4E14\u8BE5\u7528\u6237\u5931\u53BB\u7EE7\u7EED\u53C2\u4E0E\u672C\u6B21\u9884\u552E\u6D3B\u52A8\u7684\u8D44\u683C\u3002\u7F51\u5FC3\u6709\u6743\u4F9D\u636E\u672C\u534F\u8BAE\u7EA6\u5B9A\u5185\u5BB9\u57FA\u4E8E\u72EC\u7ACB\u81EA\u4E3B\u5224\u65AD\u8BA4\u5B9A\u7528\u6237\u662F\u5426\u5B58\u5728\u6076\u610F\u5237\u5355\u3001\u4E00\u4EBA\u591A\u5355\u3001\u8D85\u65F6\u652F\u4ED8\u7B49\u8FDD\u89C4\u884C\u4E3A\uFF0C\u5982\u7528\u6237\u5BF9\u7F51\u5FC3\u53D6\u6D88\u8BA2\u5355\u5B58\u6709\u5F02\u8BAE\u7684\uFF0C\u5E94\u5F53\u81EA\u5176\u8BA2\u5355\u88AB\u53D6\u6D88\u8D7724\u5C0F\u65F6\u5185\u4E0E\u7F51\u5FC3\u8054\u7CFB\uFF0C\u8D85\u8FC724\u5C0F\u65F6\u7684\uFF0C\u89C6\u4E3A\u7528\u6237\u4E0D\u5B58\u6709\u4EFB\u4F55\u5F02\u8BAE\u3002'
            )
        ),
        _react2.default.createElement(
            'h3',
            null,
            '\u6E29\u99A8\u63D0\u793A\uFF1A'
        ),
        _react2.default.createElement(
            'ol',
            { className: 'oc-buy-aside-rule-list' },
            _react2.default.createElement(
                'li',
                null,
                '\u73A9\u5BA2\u4E91\u5B98\u65B9\u8D2D\u4E70\u6E20\u9053\uFF1A\u73A9\u5BA2\u4E91PC\u7248\u5B98\u7F51\u3001\u79FB\u52A8\u7248\u5B98\u7F51\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                '\u4E3A\u786E\u4FDD\u60A8\u5728\u66F4\u65E9\u7684\u65F6\u95F4\u62FF\u5230\u5546\u54C1\uFF0C\u8BF7\u5728\u5F00\u552E\u524D\u6821\u51C6\u60A8\u7684\u7535\u8111\u6216\u624B\u673A\u65F6\u95F4\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                '\u7531\u4E8E\u8FD1\u671F\u73A9\u5BA2\u4E91\u5305\u88C5LOGO\u8FDB\u884C\u4E86\u66F4\u65B0\uFF0C\u65B0\u8001\u5305\u88C5\u5C06\u968F\u673A\u53D1\u8D27\uFF0C\u656C\u8BF7\u8C05\u89E3\uFF1B'
            ),
            _react2.default.createElement(
                'li',
                null,
                '\u5982\u6709\u4EFB\u4F55\u7591\u95EE\u8BF7\u62E8\u6253400-109-8880\u8FD8\u53EF\u8BBF\u95EE\u670D\u52A1\u9875',
                _react2.default.createElement(
                    'a',
                    { href: 'http://wpa.qq.com/msgrd?v=3&uin=212454816&site=qq&menu=yes', target: '_blank' },
                    '\u8054\u7CFBQQ\u5728\u7EBF\u5BA2\u670D'
                ),
                '\uFF0C\u670D\u52A1\u65F6\u95F4 09:00-21:00\u3002'
            )
        )
    ),
    buy_steps: _react2.default.createElement(
        'div',
        { className: 'oc-buy-aside-steps' },
        _react2.default.createElement(
            'h3',
            null,
            '\u9810\u5B9A\u8CFC\u8CB7\u6D41\u7A0B'
        ),
        _react2.default.createElement(
            'ol',
            null,
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'h4',
                    null,
                    '1. \u9810\u5B9A\u8CFC\u8CB7'
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    '\u9810\u5B9A\u5373\u5C07\u958B\u59CB'
                )
            ),
            _react2.default.createElement('li', { className: 'oc-buy-aside-steps-arrow' }),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'h4',
                    null,
                    '2. \u9810\u4ED8\u5B9A\u91D1'
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    '2017-08-10 10:10\u81F32017-08-30: 18:00'
                )
            ),
            _react2.default.createElement('li', { className: 'oc-buy-aside-steps-arrow' }),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'h4',
                    null,
                    '3. \u652F\u4ED8\u5C3E\u6B3E'
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    '\u7B49\u5F85\u5C3E\u6B3E\u6642\u9593\u958B\u5553'
                )
            ),
            _react2.default.createElement('li', { className: 'oc-buy-aside-steps-arrow' }),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'h4',
                    null,
                    '4. \u767C\u8CA8'
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    '\u6309\u5B9A\u91D1\u652F\u4ED8\u9806\u5E8F\u4F9D\u6B21\u767C\u8CA8'
                )
            )
        )
    ),

    verify_verify_refresh: '刷新題目',
    verify_input: '請輸入驗證碼',
    verify_yellow: '為保護用戶的利益，打擊黃牛，請您輸入一次驗證碼',
    verify_error: '驗證碼有誤，請重新填寫',
    verify_empty: '請輸入答案'

};

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Login = __webpack_require__(88);

var _Login2 = _interopRequireDefault(_Login);

var _componentsv = __webpack_require__(142);

var _loginbar = __webpack_require__(274);

var _loginbar2 = _interopRequireDefault(_loginbar);

var _CouponBar = __webpack_require__(275);

var _CouponBar2 = _interopRequireDefault(_CouponBar);

var _stateless = __webpack_require__(276);

var _Renders = __webpack_require__(277);

var _Pops = __webpack_require__(278);

var _counter = __webpack_require__(143);

var _diskselector = __webpack_require__(279);

var _diskselector2 = _interopRequireDefault(_diskselector);

var _swiperbox = __webpack_require__(281);

var _swiperbox2 = _interopRequireDefault(_swiperbox);

var _util = __webpack_require__(16);

var _purchase = __webpack_require__(50);

var _purchase2 = _interopRequireDefault(_purchase);

var _utils = __webpack_require__(1);

var _consts = __webpack_require__(2);

var _saleConfig = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var api = {
	getconfig: _consts.ONECLOUD_API_HOST + '/opensale/getconfig',
	commit: _consts.ONECLOUD_API_HOST + '/opensale/commit',
	usercouponlist: _consts.ONECLOUD_API_HOST + '/coupon/userCouponList'
};
var ACT_STATUS_NO = 0; // 无活动，原价
var ACT_STATUS_MJ = 1; // 满减活动
var GET_CONFIG_LOOP_TIMES = 0;

// 0-活动未开始,1-抢购中,2-抢购结束
/* 开放售卖原价【CN版】满减活动【CN版】 */

var OpensalePurchaseV3 = function (_Component) {
	_inherits(OpensalePurchaseV3, _Component);

	function OpensalePurchaseV3(props) {
		_classCallCheck(this, OpensalePurchaseV3);

		var _this = _possibleConstructorReturn(this, (OpensalePurchaseV3.__proto__ || Object.getPrototypeOf(OpensalePurchaseV3)).call(this, props));

		_this.getConfig = function () {
			if ((0, _utils.getCookie)('lang') !== 'cn') return;
			var doneCb = function doneCb(res) {
				console.log(res);
				var success = function success(data) {
					var mj_status = data.mj_status,
					    mj_price = data.mj_price,
					    hd_price = data.hd_price,
					    black_sell_out = data.black_sell_out,
					    blue_sell_out = data.blue_sell_out,
					    orange_sell_out = data.orange_sell_out;
					var priceList = _this.state.priceList;

					var stateData = {};
					if (mj_status == ACT_STATUS_MJ) {
						stateData = {
							hasDiscount: true,
							priceList: _extends({}, priceList, {
								wky: mj_price,
								diskActPrice: hd_price
							}),
							sellout: {
								black: black_sell_out,
								blue: blue_sell_out,
								orange: orange_sell_out,
								disk: false
							}
						};
					} else {
						stateData = {
							hasDiscount: false,
							priceList: _extends({}, priceList, {
								wky: 599,
								diskActPrice: hd_price
							}),
							sellout: {
								black: black_sell_out,
								blue: blue_sell_out,
								orange: orange_sell_out,
								disk: false
							}
						};
					}
					_this.setState(stateData, function () {
						return _this.countTotalPrice();
					});
				};
				_this.responeHandler({ res: res, success: success });
			};
			var failCb = function failCb(res) {
				if (GET_CONFIG_LOOP_TIMES == 1) {
					// this.showPopHandler(t('notifi_yongdu'))
					_this.showNetBusy();
				} else {
					GET_CONFIG_LOOP_TIMES++;
					setTimeout(_this.getConfig, 2000);
				}
			};
			(0, _utils.postPromise)(api.getconfig).done(doneCb).fail(failCb);
		};

		_this.showPopHandler = function (msg, url, btn) {
			_this.setState({
				popShow: true,
				popMsg: msg,
				popJump: url || '',
				popBtn: btn || (0, _purchase2.default)('ok')
			});
		};

		_this.closePop = function () {
			_this.setState({ popShow: false });
		};

		_this.updateDiskData = function (data) {
			_this.setState(data);
		};

		_this.queryParams = {
			isPc: (0, _utils.browser)('pc') ? true : false
		};
		_this.state = {
			hasLogin: false,
			hasDiscount: false,
			shoppingList: {
				orange: 0,
				black: 0,
				blue: 1,
				diskCount: 0
			},
			priceList: {
				wky: 599,
				disk: 749,
				diskActPrice: 0 // 549
			},
			color: 'blue',
			popShow: false,
			popMsg: '',
			popJump: '',
			popBtn: (0, _purchase2.default)('ok'),
			hideClose: false,
			loadingTime: false,
			diskChecked: false,
			totalPrice: 0,
			selectedColor: 'blue',
			sellout: {
				black: false,
				blue: false,
				orange: false,
				disk: false
			},
			couponNum: 0,
			showLoading: false
		};

		_this.changeShoppingList = _this.changeShoppingList.bind(_this);
		_this.countTotalPrice = _this.countTotalPrice.bind(_this);
		_this.changeImageColor = _this.changeImageColor.bind(_this);
		_this.handleSubmitAdd = _this.handleSubmitAdd.bind(_this);
		_this.handleSubmitBuy = _this.handleSubmitBuy.bind(_this);
		_this.loginCallback = _this.loginCallback.bind(_this);
		return _this;
	}

	_createClass(OpensalePurchaseV3, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			$('html').addClass('whitebg');
			this.getConfig();
			this.checkLogin();
		}
	}, {
		key: 'changeImageColor',
		value: function changeImageColor(selected) {
			this.setState({ selectedColor: selected });
		}
	}, {
		key: 'changeShoppingList',
		value: function changeShoppingList(type, count) {
			var shoppingList = this.state.shoppingList;

			shoppingList[type] = Number(count);
			this.setState({ shoppingList: shoppingList }, this.countTotalPrice);
		}
	}, {
		key: 'handleSubmitAdd',
		value: function handleSubmitAdd(e) {
			var _this2 = this;

			e.preventDefault();
			var _state$shoppingList = this.state.shoppingList,
			    blue = _state$shoppingList.blue,
			    black = _state$shoppingList.black,
			    orange = _state$shoppingList.orange,
			    diskCount = _state$shoppingList.diskCount;

			var cartFromLocal = (0, _util.getOriginData)();
			var localNumbers = cartFromLocal.blue + cartFromLocal.black + cartFromLocal.orange;
			typeof onStatBtnClick === 'function' && onStatBtnClick('add_to_cart', null, 'blue=' + blue + '&orange=' + orange + '&black=' + black + '%harddisk=' + diskCount);
			if (blue + black + orange <= 0) {
				if (localNumbers > 0 && diskCount === 0) {
					this.showPopHandler('请选择商品数量');
					return;
				}
				if (localNumbers === 0) {
					this.showPopHandler('请选择玩客云数量');
					return;
				}
			}
			(0, _util.addToShoppingCart)({
				blue: blue,
				black: black,
				orange: orange,
				disk: diskCount
			}, function (res) {
				var codeHandlers = {
					70202: function _() {
						return _this2.showPopHandler('超过最大可购买数量');
					},
					70204: function _() {
						return _this2.showPopHandler(res.sMsg, function () {
							sellout.black = true;
							_this2.setState({ sellout: sellout });
							_this2.changeShoppingList('black', 0);
						});
					},
					70205: function _() {
						return _this2.showPopHandler(res.sMsg, function () {
							sellout.blue = true;
							_this2.setState({ sellout: sellout });
							_this2.changeShoppingList('blue', 0);
						});
					},
					702046: function _() {
						return _this2.showPopHandler(res.sMsg, function () {
							sellout.orange = true;
							_this2.setState({ sellout: sellout });
							_this2.changeShoppingList('orange', 0);
						});
					}
				};
				if (codeHandlers[res.iRet]) {
					codeHandlers[res.iRet]();
				} else {
					setTimeout(function () {
						window.location.href = '/site/cart.html';
					}, 50);
				}
			}, this.showPopHandler);
		}
	}, {
		key: 'handleSubmitBuy',
		value: function handleSubmitBuy(e) {
			var _this3 = this;

			e && e.preventDefault();
			var _state = this.state,
			    hasLogin = _state.hasLogin,
			    _state$shoppingList2 = _state.shoppingList,
			    blue = _state$shoppingList2.blue,
			    black = _state$shoppingList2.black,
			    orange = _state$shoppingList2.orange,
			    diskCount = _state$shoppingList2.diskCount,
			    hasDiscount = _state.hasDiscount;

			var onecloudCount = blue + black + orange;
			typeof onStatBtnClick === 'function' && onStatBtnClick('buynow', null, 'blue=' + blue + '&orange=' + orange + '&black=' + black + '%harddisk=' + diskCount);

			if (onecloudCount <= 0) {
				this.showPopHandler('请选择玩客云数量');
				return;
			} else if (onecloudCount > _saleConfig.SINGLE_ORDER_MAX_NUM) {
				this.showPopHandler('超过最大可购买数量');
				return;
			}
			if (!hasLogin) {
				this.login();
				return;
			}

			var postData = {
				sub_type: hasDiscount ? ACT_STATUS_MJ : ACT_STATUS_NO,
				black_num: black,
				orange_num: orange,
				blue_num: blue,
				hd_num: diskCount

				// product_id: 2, // mini qin.test
			};

			var doneCb = function doneCb(res) {
				_this3.closeLoading();
				var success = function success(data) {
					var codeHandlers = {
						30400: function _() {
							return _this3.showPopHandler('超过最大可购买数量');
						},
						30016: function _() {
							return _this3.showPopHandler(res.sMsg, function () {
								sellout.black = true;
								_this3.setState({ sellout: sellout });
								_this3.changeShoppingList('black', 0);
							});
						},
						30026: function _() {
							return _this3.showPopHandler(res.sMsg, function () {
								sellout.blue = true;
								_this3.setState({ sellout: sellout });
								_this3.changeShoppingList('blue', 0);
							});
						},
						30025: function _() {
							return _this3.showPopHandler(res.sMsg, function () {
								sellout.orange = true;
								_this3.setState({ sellout: sellout });
								_this3.changeShoppingList('orange', 0);
							});
						}
					};
					if (codeHandlers[res.iRet]) {
						codeHandlers[res.iRet]();
					} else {
						setTimeout(function () {
							window.location.href = (0, _utils.createUrl)('html/count', { type: 'opensale', orderid: data.order_id });

							// qin.test mini下单
							// window.location.href = createUrl('html/mini-order', {type:'mini', orderid: data.order_id})
						}, 50);
					}
				};
				_this3.responeHandler({ res: res, success: success });
			};
			this.showLoading();
			(0, _utils.postPromise)(api.commit, postData).done(doneCb).fail(function () {
				return _this3.showNetBusy();
			});
		}
	}, {
		key: 'checkLogin',
		value: function checkLogin() {
			var _this4 = this;

			if (window.siteHasLogined) {
				this.setState({
					hasLogin: true
				}, function () {
					return _this4.fetchCoupon();
				});
			} else {
				var doneCb = function doneCb(res) {
					+res.iRet === 0 && _this4.setState({
						hasLogin: true
					}, function () {
						return _this4.fetchCoupon();
					});
				};
				(0, _utils.postPromise)(_consts.commonApi.checklogin).done(doneCb);
			}
		}
	}, {
		key: 'fetchCoupon',
		value: function fetchCoupon() {
			var _this5 = this;

			var doneCb = function doneCb(res) {
				+res.iRet === 0 && _this5.setState({
					couponNum: res.data.list.length
				});
			};
			(0, _utils.ajaxGet)(api.usercouponlist + '?status=0', doneCb);
		}
	}, {
		key: 'login',
		value: function login() {
			this.setState({
				useDefaultMsgDom: false,
				popShow: true,
				popMsg: _react2.default.createElement(_Login2.default, { buttonName: '\u7ACB\u5373\u767B\u5F55', loginCallback: this.loginCallback }),
				popJump: '',
				popBtn: 'hide',
				hideClose: false
			});
		}
	}, {
		key: 'loginCallback',
		value: function loginCallback() {
			var _this6 = this;

			this.setState({
				popShow: false,
				hasLogin: true
			}, function () {
				_this6.handleSubmitBuy();
			});
		}
	}, {
		key: 'showNetBusy',
		value: function showNetBusy() {
			this.closeLoading();
			this.showPopHandler('网络繁忙，请稍候重试（S）');
		}
	}, {
		key: 'showLoading',
		value: function showLoading() {
			this.setState({ showLoading: true });
		}
	}, {
		key: 'closeLoading',
		value: function closeLoading() {
			this.setState({ showLoading: false });
		}
	}, {
		key: 'commonErrorHandler',
		value: function commonErrorHandler(resCode, sMsg) {
			var statusList = {
				'30004': (0, _purchase2.default)('rtncode_30004'),
				'30006': (0, _purchase2.default)('rtncode_30006'),
				'30008': (0, _purchase2.default)('rtncode_30008'),
				'30009': (0, _purchase2.default)('rtncode_30009'),
				'40000': (0, _purchase2.default)('rtncode_40000'),
				'30003': (0, _purchase2.default)('rtncode_30003'),
				'30106': (0, _purchase2.default)('rtncode_30106'),
				'-2': (0, _purchase2.default)('rtncode__2'),
				'-2004': (0, _purchase2.default)('rtncode__2004'),
				'-2000': (0, _purchase2.default)('rtncode__2000'),
				'-1003': (0, _purchase2.default)('rtncode__1003'),
				'-5': (0, _purchase2.default)('rtncode__5'),

				"41006": (0, _purchase2.default)('rtncode_41006'),
				"41007": (0, _purchase2.default)('rtncode_41007_2'),
				"41009": (0, _purchase2.default)('rtncode_41009'),
				"41012": (0, _purchase2.default)('rtncode_41012'),
				"41013": (0, _purchase2.default)('rtncode_41013'),
				"41014": (0, _purchase2.default)('rtncode_41014'),
				'41016': (0, _purchase2.default)('rtncode_41016'),
				'41018': (0, _purchase2.default)('rtncode_41018'),
				"41022": (0, _purchase2.default)('rtncode_41022')
			};
			var sellOutList = {
				'30005': (0, _purchase2.default)('rtncode_30005'),
				'30016': (0, _purchase2.default)('rtncode_30016'),
				'30025': (0, _purchase2.default)('rtncode_30025'),
				'30026': (0, _purchase2.default)('rtncode_30026')
			};

			if (resCode == -501) {
				var url = window.location.href;
				(0, _componentsv.jumpToLogin)();
			} else if (resCode == 30007) {
				this.showPopHandler((0, _purchase2.default)('rtncode_30007'), (0, _utils.createUrl)('html/usercenter'), (0, _purchase2.default)('check_order'));
			} else if (resCode == 30303) {
				this.showPopHandler((0, _purchase2.default)('rtncode_30303'));
				this.getConfig();
			} else if (sellOutList[resCode]) {
				if (resCode == 30005) {
					this.showPopHandler(sellOutList[resCode]);
				} else {
					this.showPopHandler(sellOutList[resCode], '', (0, _purchase2.default)('tips_continue'));
					//this.getColorList()
				}
			} else if (statusList[resCode]) {
				this.showPopHandler(statusList[resCode]);
			} else if (resCode !== 0) {
				// CN
				this.showPopHandler(sMsg);
			}
			// if (callback&&typeof callback=="function"){
			// 	callback(resCode,res)
			// }
		}
	}, {
		key: 'responeHandler',
		value: function responeHandler(_ref) {
			var res = _ref.res,
			    success = _ref.success;

			var resCode = res.iRet;
			this.commonErrorHandler(resCode, res.sMsg);

			if (resCode == 0) {
				if (res.data) {
					success(res.data);
				} else {
					success();
				}
			}
		}
	}, {
		key: 'countTotalPrice',
		value: function countTotalPrice() {
			var _state2 = this.state,
			    _state2$shoppingList = _state2.shoppingList,
			    orange = _state2$shoppingList.orange,
			    black = _state2$shoppingList.black,
			    blue = _state2$shoppingList.blue,
			    diskCount = _state2$shoppingList.diskCount,
			    _state2$priceList = _state2.priceList,
			    wky = _state2$priceList.wky,
			    diskActPrice = _state2$priceList.diskActPrice;

			var wkyCount = orange + black + blue;
			var totalPrice = wkyCount * wky + diskCount * diskActPrice;
			this.setState({ totalPrice: totalPrice });
		}
	}, {
		key: 'render',
		value: function render() {
			var _state3 = this.state,
			    _state3$shoppingList = _state3.shoppingList,
			    blue = _state3$shoppingList.blue,
			    black = _state3$shoppingList.black,
			    orange = _state3$shoppingList.orange,
			    shoppingList = _state3.shoppingList,
			    priceList = _state3.priceList,
			    hasLogin = _state3.hasLogin,
			    loadingTime = _state3.loadingTime,
			    hasDiscount = _state3.hasDiscount,
			    totalPrice = _state3.totalPrice,
			    selectedColor = _state3.selectedColor,
			    sellout = _state3.sellout,
			    couponNum = _state3.couponNum,
			    showLoading = _state3.showLoading,
			    popShow = _state3.popShow,
			    popBtn = _state3.popBtn,
			    popMsg = _state3.popMsg,
			    popJump = _state3.popJump,
			    hideClose = _state3.hideClose,
			    useDefaultMsgDom = _state3.useDefaultMsgDom;
			var isPc = this.queryParams.isPc;


			var tipData = {};
			if (popShow) {
				tipData = {
					msg: popMsg,
					btn: popBtn,
					jump: popJump,
					hideClose: hideClose,
					onClose: this.closePop,
					useDefaultMsgDom: useDefaultMsgDom
				};
			}

			return _react2.default.createElement(
				OpensaleCombiner,
				{
					topbar: hasLogin ? _react2.default.createElement(_CouponBar2.default, { num: couponNum }) : _react2.default.createElement(_loginbar2.default, { isLogin: false }),
					popcomp: popShow && _react2.default.createElement(_Pops.TipPop, tipData),
					swiper: _react2.default.createElement(_swiperbox2.default, { selectedColor: selectedColor })
				},
				hasDiscount ? (0, _purchase2.default)('mj_price_title') : _react2.default.createElement(OfficialPrice, null),
				_react2.default.createElement(ColorSelector, { sellout: sellout, changeShoppingList: this.changeShoppingList, blue: blue, black: black, orange: orange, selectedColor: selectedColor, changeImageColor: this.changeImageColor }),
				_react2.default.createElement(_diskselector2.default, { changeShoppingList: this.changeShoppingList, shoppingList: shoppingList, priceList: priceList }),
				_react2.default.createElement(_stateless.TotalPriceBox, { totalPrice: totalPrice }),
				_react2.default.createElement(_Renders.RenderSubmitBtn, {
					isPc: isPc,
					loadingTime: loadingTime,
					onClickAdd: this.handleSubmitAdd,
					onClickBuy: this.handleSubmitBuy,
					disabled: false
				}),
				(0, _purchase2.default)('goods_tip'),
				showLoading && _react2.default.createElement(_Pops.TipLoadingPop, { msg: '\u6570\u636E\u53D1\u9001\u4E2D\uFF0C\u8BF7\u7A0D\u5019...' })
			);
		}
	}]);

	return OpensalePurchaseV3;
}(_react.Component);

exports.default = OpensalePurchaseV3;


var OpensaleCombiner = function OpensaleCombiner(_ref2) {
	var topbar = _ref2.topbar,
	    popcomp = _ref2.popcomp,
	    swiper = _ref2.swiper,
	    children = _ref2.children;

	return _react2.default.createElement(
		'div',
		null,
		topbar,
		popcomp,
		_react2.default.createElement(
			'div',
			{ className: 'np-main' },
			_react2.default.createElement(
				'div',
				{ className: 'np-buy-box' },
				swiper,
				_react2.default.createElement(
					'div',
					{ className: 'np-buy-main' },
					children
				)
			)
		)
	);
};
var OfficialPrice = function OfficialPrice() {
	return _react2.default.createElement(
		'div',
		{ className: 'np-buy-text' },
		_react2.default.createElement(
			'h2',
			null,
			(0, _purchase2.default)('banner_title')
		),
		(0, _purchase2.default)('sub_title'),
		(0, _purchase2.default)('price_official_v2')
	);
};

var ColorSelector = function ColorSelector(_ref3) {
	var sellout = _ref3.sellout,
	    changeShoppingList = _ref3.changeShoppingList,
	    blue = _ref3.blue,
	    black = _ref3.black,
	    orange = _ref3.orange,
	    selectedColor = _ref3.selectedColor,
	    changeImageColor = _ref3.changeImageColor;

	return _react2.default.createElement(
		'div',
		{ className: 'np-buy-unit' },
		_react2.default.createElement(
			'dl',
			{ className: 'np-buy-color-new' },
			_react2.default.createElement(
				'dt',
				null,
				'\u8BF7\u9009\u62E9\u989C\u8272'
			),
			_react2.default.createElement(
				'dd',
				{ className: sellout.blue ? 'np-buy-soldout' : selectedColor == 'blue' ? 'np-selected' : '', onClick: function onClick() {
						changeImageColor('blue');
					} },
				_react2.default.createElement(
					'div',
					{ className: 'np-select-item' },
					_react2.default.createElement('i', { className: 'np-dot-blue' }),
					'\u79D1\u6280\u84DD'
				),
				_react2.default.createElement(_counter.BlueCounterInOpensale, { value: blue, changeShoppingList: changeShoppingList, sellout: sellout.blue })
			),
			_react2.default.createElement(
				'dd',
				{ className: sellout.orange ? 'np-buy-soldout' : selectedColor == 'orange' ? 'np-selected' : '', onClick: function onClick() {
						changeImageColor('orange');
					} },
				_react2.default.createElement(
					'div',
					{ className: 'np-select-item' },
					_react2.default.createElement('i', { className: 'np-dot-org' }),
					'\u7231\u9A6C\u4ED5\u6A59'
				),
				_react2.default.createElement(_counter.OrangeCounterInOpensale, { value: orange, changeShoppingList: changeShoppingList, sellout: sellout.orange })
			),
			_react2.default.createElement(
				'dd',
				{ className: sellout.black ? 'np-buy-soldout' : selectedColor == 'black' ? 'np-selected' : '', onClick: function onClick() {
						changeImageColor('black');
					} },
				_react2.default.createElement(
					'div',
					{ className: 'np-select-item' },
					_react2.default.createElement('i', { className: 'np-dot-black' }),
					'\u66DC\u77F3\u9ED1'
				),
				_react2.default.createElement(_counter.BlackCounterInOpensale, { value: black, changeShoppingList: changeShoppingList, sellout: sellout.black })
			)
		)
	);
};

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _util = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginBar = function (_Component) {
    _inherits(LoginBar, _Component);

    function LoginBar(props) {
        _classCallCheck(this, LoginBar);

        var _this = _possibleConstructorReturn(this, (LoginBar.__proto__ || Object.getPrototypeOf(LoginBar)).call(this, props));

        _this.state = {
            show: true
        };
        return _this;
    }

    _createClass(LoginBar, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isLogin = this.props.isLogin;
            var show = this.state.show;

            var clickHandler = function clickHandler() {
                _this2.setState({ show: false });
            };
            return !isLogin && show && _react2.default.createElement(
                'div',
                { className: 'np-buylogin' },
                _react2.default.createElement(
                    'div',
                    { className: 'np-main' },
                    _react2.default.createElement(
                        'p',
                        null,
                        '\u4E3A\u4E86\u65B9\u4FBF\u8D2D\u4E70\uFF0C\u8BF7\u63D0\u524D\u767B\u5F55',
                        _react2.default.createElement(
                            'a',
                            { href: 'javascript:;', onClick: _util.jumpToLogin },
                            '\u7ACB\u5373\u767B\u5F55'
                        ),
                        _react2.default.createElement('i', { className: 'i-close', title: '\u5173\u95ED', onClick: clickHandler })
                    )
                )
            );
        }
    }]);

    return LoginBar;
}(_react.Component);

exports.default = LoginBar;

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CouponBar = function (_Component) {
    _inherits(CouponBar, _Component);

    function CouponBar(props) {
        _classCallCheck(this, CouponBar);

        var _this = _possibleConstructorReturn(this, (CouponBar.__proto__ || Object.getPrototypeOf(CouponBar)).call(this, props));

        _this.state = {
            show: true
        };
        return _this;
    }

    _createClass(CouponBar, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props$num = this.props.num,
                num = _props$num === undefined ? 0 : _props$num;
            var show = this.state.show;

            var clickHandler = function clickHandler() {
                _this2.setState({ show: false });
            };
            return num && show ? _react2.default.createElement(
                "div",
                { className: "np-buylogin" },
                _react2.default.createElement(
                    "div",
                    { className: "np-main" },
                    _react2.default.createElement(
                        "p",
                        null,
                        "\u60A8\u6709 ",
                        _react2.default.createElement(
                            "span",
                            { className: "oc-col-blue" },
                            num
                        ),
                        " \u5F20\u53EF\u4F7F\u7528\u7684\u4F18\u60E0\u5238\uFF0C\u7ACB\u5373\u4E0B\u5355\u4F7F\u7528\u5427\uFF01",
                        _react2.default.createElement("i", { className: "i-close", title: "\u5173\u95ED", onClick: clickHandler })
                    )
                )
            ) : null;
        }
    }]);

    return CouponBar;
}(_react.Component);

exports.default = CouponBar;

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BuyButton = exports.PriceBox = exports.PromiseBox = exports.TotalPriceBox = exports.Combiner = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Combiner = exports.Combiner = function Combiner(_ref) {
    var loginBox = _ref.loginBox,
        swiperBox = _ref.swiperBox,
        children = _ref.children;

    return _react2.default.createElement(
        'div',
        null,
        loginBox,
        _react2.default.createElement(
            'div',
            { className: 'np-main' },
            _react2.default.createElement(
                'div',
                { className: 'np-buy-box' },
                swiperBox,
                _react2.default.createElement(
                    'div',
                    { className: 'np-buy-main' },
                    children
                )
            )
        )
    );
};

var TotalPriceBox = exports.TotalPriceBox = function TotalPriceBox(_ref2) {
    var totalPrice = _ref2.totalPrice;

    return _react2.default.createElement(
        'div',
        { className: 'np-buy-sum' },
        _react2.default.createElement(
            'p',
            null,
            '\u5408\u8BA1\uFF1A',
            _react2.default.createElement(
                'em',
                null,
                (0, _utils.formatNumberByComma)(totalPrice)
            ),
            '\u5143'
        )
    );
};
var PromiseBox = exports.PromiseBox = function PromiseBox() {
    return _react2.default.createElement(
        'div',
        { className: 'np-buy-promise' },
        _react2.default.createElement('i', { className: 'i-promise' }),
        '15\u5929\u8D28\u91CF\u95EE\u9898\u6362\u8D27\xA0\xA0\xA0\xA0',
        _react2.default.createElement('i', { className: 'i-promise' }),
        '365\u5929\u4FDD\u4FEE'
    );
};

var PriceBox = exports.PriceBox = function PriceBox(_ref3) {
    var price = _ref3.price,
        counts = _ref3.counts;
    var orange = counts.orange,
        black = counts.black,
        blue = counts.blue;

    var greaterThanZero = orange + black + blue > 0 ? true : false;
    return _react2.default.createElement(
        'div',
        { className: 'np-buy-text' },
        _react2.default.createElement(
            'h2',
            null,
            '\u73A9\u5BA2\u4E91 \u7545\u5FEB\u4E0B\u8F7D\u7684\u79C1\u4EBA\u4E91\u76D8'
        ),
        _react2.default.createElement(
            'p',
            null,
            '\u3010\u4F01\u4E1A\u7528\u6237\u9650\u65F6\u7279\u60E0\u3011\u4E00\u6B21\u6027\u4E0B\u5355\u6EE150\u53F0\u6BCF\u53F0328\u5143\uFF01'
        ),
        greaterThanZero ? _react2.default.createElement(
            'div',
            { className: 'np-buy-price' },
            '\u9650\u65F6\u4F18\u60E0\uFF1A',
            _react2.default.createElement(
                'em',
                null,
                _react2.default.createElement(
                    'span',
                    null,
                    price
                ),
                '\u5143'
            ),
            _react2.default.createElement(
                'del',
                null,
                '599\u5143'
            )
        ) : _react2.default.createElement(
            'div',
            { className: 'np-buy-price' },
            '\u5B98\u65B9\u6307\u5BFC\u4EF7\uFF1A',
            _react2.default.createElement(
                'em',
                null,
                _react2.default.createElement(
                    'span',
                    null,
                    '599\u5143'
                )
            )
        )
    );
};

var BuyButton = exports.BuyButton = function BuyButton(_ref4) {
    var isLogin = _ref4.isLogin,
        totalPrice = _ref4.totalPrice,
        submit = _ref4.submit;

    return _react2.default.createElement(
        'div',
        { className: 'np-buy-btn' },
        isLogin && totalPrice ? _react2.default.createElement(
            'a',
            { className: 'btn-np', href: 'javascript:;', onClick: submit },
            '\u7ACB\u5373\u4E0B\u5355'
        ) : _react2.default.createElement(
            'a',
            { className: 'btn-np btn-np-disable', href: 'javascript:;' },
            '\u7ACB\u5373\u4E0B\u5355'
        )
    );
};

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.RenderSubmitBtn = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderSubmitBtn = function RenderSubmitBtn(_ref) {
	var isPc = _ref.isPc,
	    loadingTime = _ref.loadingTime,
	    onClickAdd = _ref.onClickAdd,
	    onClickBuy = _ref.onClickBuy,
	    disabled = _ref.disabled;

	return _react2.default.createElement(
		"div",
		{ className: "np-buy-btn" },
		disabled ? _react2.default.createElement(
			"a",
			{ href: "javascript:;", className: "btn-np-ect btn-np-disable" },
			_react2.default.createElement("i", { className: "icon-np-shopping" }),
			"\u52A0\u5165\u8D2D\u7269\u8F66"
		) : _react2.default.createElement(
			"a",
			{ href: "javascript:;", className: isPc ? 'btn-np-ect' : 'btn-np btn-oc-fixed', onClick: onClickAdd },
			_react2.default.createElement("i", { className: "icon-np-shopping" }),
			"\u52A0\u5165\u8D2D\u7269\u8F66",
			loadingTime ? _react2.default.createElement("i", { className: "i-oc-loading" }) : null
		),
		isPc && _react2.default.createElement(
			"a",
			{ href: "javascript:;", className: "btn-np btn-oc-fixed", onClick: onClickBuy },
			"\u7ACB\u5373\u8D2D\u4E70"
		)
	);
};

exports.RenderSubmitBtn = RenderSubmitBtn;

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TipLoadingPop = exports.TipPop = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {string} msg  提示文案
 * @param {string|array} btn  按钮文案 或 按钮配置 [{name: '', onBtnClick: function() {}}, ...]
 * @param {string} jump 跳转链接
 * @param {boolean} hideClose 是否隐藏关闭按钮
 * @param {function} onClose 关闭函数
 * @param {boolean} useDefaultMsgDom 是否使用默认提示语 DOM 结构
 */
function TipPop(props) {
  var msg = props.msg,
      btn = props.btn,
      jump = props.jump,
      hideClose = props.hideClose,
      onClose = props.onClose,
      useDefaultMsgDom = props.useDefaultMsgDom;

  btn = btn ? btn : '确定'; // 防止传空串

  var dangerousInnerHTML = {
    __html: msg
  };
  var renderBtn = null;
  if (typeof btn === 'string') {
    renderBtn = _react2.default.createElement(
      'div',
      { className: 'oc-pop-btnbox' },
      jump ? _react2.default.createElement(
        'a',
        { href: jump, className: 'btn-oc' },
        btn
      ) : _react2.default.createElement(
        'a',
        { href: 'javascript:;', className: 'btn-oc', onClick: onClose },
        btn
      )
    );
  } else if (Array.isArray(btn)) {
    renderBtn = _react2.default.createElement(
      'div',
      { className: 'oc-pop-btnbox' },
      btn.map(function (item, index) {
        return _react2.default.createElement(
          'a',
          { key: index, href: 'javascript:;', className: 'btn-oc ' + (index === 0 ? 'btn-oc-line' : ''), onClick: item.onBtnClick },
          item.name
        );
      })
    );
  }
  var msgDom = useDefaultMsgDom ? _react2.default.createElement(
    'div',
    { className: 'oc-pop-text oc-tb-cell' },
    msg.length <= 15 ? _react2.default.createElement(
      'h3',
      null,
      msg
    ) : _react2.default.createElement('div', { dangerouslySetInnerHTML: dangerousInnerHTML })
  ) : _react2.default.createElement(
    'div',
    { className: 'oc-pop-text oc-tb-cell' },
    msg
  );

  return _react2.default.createElement(
    'div',
    { className: 'oc-pop' },
    _react2.default.createElement(
      'div',
      { className: 'oc-pop-wp' },
      _react2.default.createElement(
        'div',
        { className: 'oc-pop-textbox oc-tb' },
        msgDom
      ),
      btn !== 'hide' && renderBtn,
      hideClose ? null : _react2.default.createElement(
        'a',
        { href: 'javascript:;', className: 'oc-pop-close', onClick: onClose },
        't(\'close\')'
      )
    )
  );
}

TipPop.defaultProps = {
  msg: '',
  btn: '确定',
  jump: '',
  useDefaultMsgDom: true,
  hideClose: false,
  onClose: function onClose() {}
};

function TipLoadingPop(props) {
  return _react2.default.createElement(
    'div',
    { className: 'oc-pop' },
    _react2.default.createElement(
      'div',
      { className: 'oc-pop-wp' },
      _react2.default.createElement(
        'div',
        { className: 'oc-pop-textbox oc-tb' },
        _react2.default.createElement(
          'div',
          { className: 'oc-pop-text oc-tb-cell' },
          props.msg.length <= 15 ? _react2.default.createElement(
            'h3',
            null,
            props.msg
          ) : _react2.default.createElement(
            'div',
            null,
            props.msg
          )
        )
      )
    )
  );
}

exports.TipPop = TipPop;
exports.TipLoadingPop = TipLoadingPop;

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _counter = __webpack_require__(143);

var _disk_sml = __webpack_require__(280);

var _disk_sml2 = _interopRequireDefault(_disk_sml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DetailBox = function DetailBox(_ref) {
    var showDetail = _ref.showDetail;

    var detailStyle = showDetail ? {} : { 'display': 'none' };
    return _react2.default.createElement(
        'div',
        { className: 'np-buy-groups-detail', style: detailStyle },
        _react2.default.createElement(
            'div',
            { className: 'np-buy-groups-detail-tb' },
            _react2.default.createElement(
                'h4',
                null,
                '\u4E3B\u4F53'
            ),
            _react2.default.createElement(
                'table',
                null,
                _react2.default.createElement(
                    'tbody',
                    null,
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u54C1\u724C'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            '\u5E0C\u6377 Seagate'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u7CFB\u5217'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            'Expansion'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u578B\u53F7'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            'STEA2000400'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u7C7B\u578B'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            '\u4FBF\u643A\u5F0F\u5B58\u50A8'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u5916\u58F3\u989C\u8272'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            '\u9ED1\u8272'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u5916\u58F3\u6750\u8D28'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            '\u5851\u6599'
                        )
                    )
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'np-buy-groups-detail-tb' },
            _react2.default.createElement(
                'h4',
                null,
                '\u89C4\u683C'
            ),
            _react2.default.createElement(
                'table',
                null,
                _react2.default.createElement(
                    'tbody',
                    null,
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u5BB9\u91CF'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            '2TB'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u5916\u90E8\u8F93\u51FA\u63A5\u53E3'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            'USB3.0'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u7CFB\u7EDF\u8981\u6C42'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            'Win10\uFF1Bwin7\uFF1Bwin8'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u786C\u76D8\u5C3A\u5BF8'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            '2.5\u82F1\u5BF8'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u6307\u793A\u706F'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            '\u6709'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u5C3A\u5BF8\uFF08mm\uFF09'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            '117*80*14.8mm'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'th',
                            null,
                            '\u91CD\u91CF\uFF08g\uFF09'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            '170g'
                        )
                    )
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'np-buy-groups-detail-tb' },
            _react2.default.createElement(
                'h4',
                null,
                '\u5305\u88C5\u6E05\u5355'
            ),
            _react2.default.createElement(
                'p',
                { className: 'np-buy-groups-detail-sum' },
                '\u79FB\u52A8\u786C\u76D8x1\u3001USB 3.0\u8FDE\u63A5\u7EBF x1\u3001\u5FEB\u901F\u5165\u95E8\u6307\u5357 x1'
            )
        )
    );
};

var DiskSelector = function (_Component) {
    _inherits(DiskSelector, _Component);

    function DiskSelector(props) {
        _classCallCheck(this, DiskSelector);

        var _this = _possibleConstructorReturn(this, (DiskSelector.__proto__ || Object.getPrototypeOf(DiskSelector)).call(this, props));

        _this.state = {
            showDetail: false
        };
        _this.toggleDetail = _this.toggleDetail.bind(_this);
        return _this;
    }

    _createClass(DiskSelector, [{
        key: 'toggleDetail',
        value: function toggleDetail() {
            var showDetail = this.state.showDetail;

            !showDetail && onStatBtnClick('prod_detail');
            this.setState({ showDetail: !showDetail });
        }
    }, {
        key: 'render',
        value: function render() {
            var showDetail = this.state.showDetail;
            var _props = this.props,
                type = _props.type,
                diskCount = _props.shoppingList.diskCount,
                changeShoppingList = _props.changeShoppingList,
                _props$priceList = _props.priceList,
                disk = _props$priceList.disk,
                diskActPrice = _props$priceList.diskActPrice;

            var diskCounterDom = {
                opensale: _react2.default.createElement(_counter.DiskCounterInOpensale, { value: diskCount, changeShoppingList: changeShoppingList }),
                business: _react2.default.createElement(_counter.DiskCounterInEnterprise, { value: diskCount, changeShoppingList: changeShoppingList })
            };
            return _react2.default.createElement(
                'div',
                { className: 'np-buy-groups' },
                _react2.default.createElement(
                    'h3',
                    null,
                    '\u8BF7\u9009\u62E9\u642D\u914D\u79FB\u52A8\u786C\u76D8'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'np-buy-groups-itembox' },
                    _react2.default.createElement(
                        'div',
                        { className: 'np-buy-groups-item' },
                        _react2.default.createElement(
                            'div',
                            { className: 'np-buy-gibox' },
                            _react2.default.createElement('img', { src: _disk_sml2.default, alt: '\u5E0C\u6377\u786C\u76D8' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'np-buy-gi-theme' },
                                _react2.default.createElement(
                                    'h4',
                                    null,
                                    '\u5E0C\u63772TB\u9ED1\u94BB\u79FB\u52A8\u786C\u76D8',
                                    _react2.default.createElement(
                                        'em',
                                        { className: 'np-lbl-discount' },
                                        '\u7701',
                                        disk - diskActPrice,
                                        '\u5143'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'np-buy-gi-price' },
                                    _react2.default.createElement(
                                        'em',
                                        null,
                                        diskActPrice,
                                        '\u5143'
                                    ),
                                    _react2.default.createElement(
                                        'del',
                                        null,
                                        disk,
                                        '\u5143'
                                    ),
                                    _react2.default.createElement(
                                        'a',
                                        { href: 'javascript:;', onClick: this.toggleDetail },
                                        '\u5546\u54C1\u8BE6\u60C5'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(DetailBox, { showDetail: showDetail })
                    )
                ),
                diskCounterDom[type]
            );
        }
    }]);

    return DiskSelector;
}(_react.Component);

exports.default = DiskSelector;

DiskSelector.defaultProps = {
    type: 'opensale'
};

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

module.exports = "/js/dist/images/purchase/disk_sml.png";

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _swiper = __webpack_require__(282);

var _swiper2 = _interopRequireDefault(_swiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function swiperInit() {
    var galleryTop = new _swiper2.default('.gallery-top', {
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    });
    var galleryThumbs = new _swiper2.default('.gallery-thumbs', {
        centeredSlides: true,
        slidesPerView: 5,
        touchRatio: 0.2,
        slideToClickedSlide: true
    });
    galleryTop.controller.control = galleryThumbs;
    galleryThumbs.controller.control = galleryTop;
}

var SwiperBox = function (_Component) {
    _inherits(SwiperBox, _Component);

    function SwiperBox(props) {
        _classCallCheck(this, SwiperBox);

        return _possibleConstructorReturn(this, (SwiperBox.__proto__ || Object.getPrototypeOf(SwiperBox)).call(this, props));
    }

    _createClass(SwiperBox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            swiperInit();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                isSellout = _props.isSellout,
                selectedColor = _props.selectedColor;

            var liList = [];
            for (var i = 1; i < 6; i++) {
                liList.push(_react2.default.createElement(
                    'li',
                    { className: 'swiper-slide', key: i },
                    _react2.default.createElement('img', { src: '/images/purchase/products/pic_' + selectedColor + '_' + i + '.jpg?20190617', alt: '' })
                ));
            }
            return _react2.default.createElement(
                'div',
                { className: 'np-buy-feature' },
                _react2.default.createElement(
                    'div',
                    { className: 'np-feature-big' },
                    _react2.default.createElement(
                        'div',
                        { className: 'swiper-container gallery-top swiper-container-horizontal' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'swiper-wrapper' },
                            liList
                        ),
                        _react2.default.createElement('div', { className: 'swiper-pagination swiper-pagination-clickable swiper-pagination-bullets' })
                    ),
                    isSellout && _react2.default.createElement(
                        'div',
                        { className: 'np-feature-none' },
                        _react2.default.createElement(
                            'div',
                            { className: 'np-feature-none-tb' },
                            _react2.default.createElement(
                                'p',
                                null,
                                '\u5DF2\u62A2\u5B8C'
                            ),
                            _react2.default.createElement(
                                'a',
                                { href: '#' },
                                '\u4E86\u89E3\u66F4\u591A >'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'np-feature-bullet' },
                    _react2.default.createElement(
                        'div',
                        { className: 'swiper-container gallery-thumbs swiper-container-horizontal' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'swiper-wrapper' },
                            liList
                        )
                    )
                )
            );
        }
    }]);

    return SwiperBox;
}(_react.Component);

exports.default = SwiperBox;

SwiperBox.defaultProps = {
    isSellout: false,
    selectedColor: 'orange'
};

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Swiper 4.3.3
                                                                                                                                                                                                                                                                               * Most modern mobile touch slider and framework with hardware accelerated transitions
                                                                                                                                                                                                                                                                               * http://www.idangero.us/swiper/
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Copyright 2014-2018 Vladimir Kharlampidi
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Released under the MIT License
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Released on: June 5, 2018
                                                                                                                                                                                                                                                                               */

var _dom = __webpack_require__(283);

var _ssrWindow = __webpack_require__(144);

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Methods = {
  addClass: _dom.addClass,
  removeClass: _dom.removeClass,
  hasClass: _dom.hasClass,
  toggleClass: _dom.toggleClass,
  attr: _dom.attr,
  removeAttr: _dom.removeAttr,
  data: _dom.data,
  transform: _dom.transform,
  transition: _dom.transition,
  on: _dom.on,
  off: _dom.off,
  trigger: _dom.trigger,
  transitionEnd: _dom.transitionEnd,
  outerWidth: _dom.outerWidth,
  outerHeight: _dom.outerHeight,
  offset: _dom.offset,
  css: _dom.css,
  each: _dom.each,
  html: _dom.html,
  text: _dom.text,
  is: _dom.is,
  index: _dom.index,
  eq: _dom.eq,
  append: _dom.append,
  prepend: _dom.prepend,
  next: _dom.next,
  nextAll: _dom.nextAll,
  prev: _dom.prev,
  prevAll: _dom.prevAll,
  parent: _dom.parent,
  parents: _dom.parents,
  closest: _dom.closest,
  find: _dom.find,
  children: _dom.children,
  remove: _dom.remove,
  add: _dom.add,
  styles: _dom.styles
};

Object.keys(Methods).forEach(function (methodName) {
  _dom.$.fn[methodName] = Methods[methodName];
});

var Utils = {
  deleteProps: function deleteProps(obj) {
    var object = obj;
    Object.keys(object).forEach(function (key) {
      try {
        object[key] = null;
      } catch (e) {
        // no getter for object
      }
      try {
        delete object[key];
      } catch (e) {
        // something got wrong
      }
    });
  },
  nextTick: function nextTick(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return setTimeout(callback, delay);
  },
  now: function now() {
    return Date.now();
  },
  getTranslate: function getTranslate(el) {
    var axis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';

    var matrix = void 0;
    var curTransform = void 0;
    var transformMatrix = void 0;

    var curStyle = _ssrWindow.window.getComputedStyle(el, null);

    if (_ssrWindow.window.WebKitCSSMatrix) {
      curTransform = curStyle.transform || curStyle.webkitTransform;
      if (curTransform.split(',').length > 6) {
        curTransform = curTransform.split(', ').map(function (a) {
          return a.replace(',', '.');
        }).join(', ');
      }
      // Some old versions of Webkit choke when 'none' is passed; pass
      // empty string instead in this case
      transformMatrix = new _ssrWindow.window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
      matrix = transformMatrix.toString().split(',');
    }

    if (axis === 'x') {
      // Latest Chrome and webkits Fix
      if (_ssrWindow.window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
      // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
      // Latest Chrome and webkits Fix
      if (_ssrWindow.window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
      // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
  },
  parseUrlQuery: function parseUrlQuery(url) {
    var query = {};
    var urlToParse = url || _ssrWindow.window.location.href;
    var i = void 0;
    var params = void 0;
    var param = void 0;
    var length = void 0;
    if (typeof urlToParse === 'string' && urlToParse.length) {
      urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
      params = urlToParse.split('&').filter(function (paramsPart) {
        return paramsPart !== '';
      });
      length = params.length;

      for (i = 0; i < length; i += 1) {
        param = params[i].replace(/#\S+/g, '').split('=');
        query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
      }
    }
    return query;
  },
  isObject: function isObject(o) {
    return (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && o !== null && o.constructor && o.constructor === Object;
  },
  extend: function extend() {
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    for (var i = 1; i < arguments.length; i += 1) {
      var nextSource = arguments.length <= i ? undefined : arguments[i];
      if (nextSource !== undefined && nextSource !== null) {
        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable) {
            if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
              Utils.extend(to[nextKey], nextSource[nextKey]);
            } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
              to[nextKey] = {};
              Utils.extend(to[nextKey], nextSource[nextKey]);
            } else {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
    }
    return to;
  }
};

var Support = function Support() {
  var testDiv = _ssrWindow.document.createElement('div');
  return {
    touch: _ssrWindow.window.Modernizr && _ssrWindow.window.Modernizr.touch === true || function checkTouch() {
      return !!('ontouchstart' in _ssrWindow.window || _ssrWindow.window.DocumentTouch && _ssrWindow.document instanceof _ssrWindow.window.DocumentTouch);
    }(),

    pointerEvents: !!(_ssrWindow.window.navigator.pointerEnabled || _ssrWindow.window.PointerEvent),
    prefixedPointerEvents: !!_ssrWindow.window.navigator.msPointerEnabled,

    transition: function checkTransition() {
      var style = testDiv.style;
      return 'transition' in style || 'webkitTransition' in style || 'MozTransition' in style;
    }(),
    transforms3d: _ssrWindow.window.Modernizr && _ssrWindow.window.Modernizr.csstransforms3d === true || function checkTransforms3d() {
      var style = testDiv.style;
      return 'webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style;
    }(),

    flexbox: function checkFlexbox() {
      var style = testDiv.style;
      var styles$$1 = 'alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient'.split(' ');
      for (var i = 0; i < styles$$1.length; i += 1) {
        if (styles$$1[i] in style) return true;
      }
      return false;
    }(),

    observer: function checkObserver() {
      return 'MutationObserver' in _ssrWindow.window || 'WebkitMutationObserver' in _ssrWindow.window;
    }(),

    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;
      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        _ssrWindow.window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {
        // No support
      }
      return supportsPassive;
    }(),

    gestures: function checkGestures() {
      return 'ongesturestart' in _ssrWindow.window;
    }()
  };
}();

var SwiperClass = function () {
  function SwiperClass() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SwiperClass);

    var self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  }

  _createClass(SwiperClass, [{
    key: 'on',
    value: function on(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;
      var method = priority ? 'unshift' : 'push';
      events.split(' ').forEach(function (event) {
        if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
        self.eventsListeners[event][method](handler);
      });
      return self;
    }
  }, {
    key: 'once',
    value: function once(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;
      function onceHandler() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        handler.apply(self, args);
        self.off(events, onceHandler);
      }
      return self.on(events, onceHandler, priority);
    }
  }, {
    key: 'off',
    value: function off(events, handler) {
      var self = this;
      if (!self.eventsListeners) return self;
      events.split(' ').forEach(function (event) {
        if (typeof handler === 'undefined') {
          self.eventsListeners[event] = [];
        } else {
          self.eventsListeners[event].forEach(function (eventHandler, index$$1) {
            if (eventHandler === handler) {
              self.eventsListeners[event].splice(index$$1, 1);
            }
          });
        }
      });
      return self;
    }
  }, {
    key: 'emit',
    value: function emit() {
      var self = this;
      if (!self.eventsListeners) return self;
      var events = void 0;
      var data$$1 = void 0;
      var context = void 0;

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (typeof args[0] === 'string' || Array.isArray(args[0])) {
        events = args[0];
        data$$1 = args.slice(1, args.length);
        context = self;
      } else {
        events = args[0].events;
        data$$1 = args[0].data;
        context = args[0].context || self;
      }
      var eventsArray = Array.isArray(events) ? events : events.split(' ');
      eventsArray.forEach(function (event) {
        if (self.eventsListeners && self.eventsListeners[event]) {
          var handlers = [];
          self.eventsListeners[event].forEach(function (eventHandler) {
            handlers.push(eventHandler);
          });
          handlers.forEach(function (eventHandler) {
            eventHandler.apply(context, data$$1);
          });
        }
      });
      return self;
    }
  }, {
    key: 'useModulesParams',
    value: function useModulesParams(instanceParams) {
      var instance = this;
      if (!instance.modules) return;
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName];
        // Extend params
        if (module.params) {
          Utils.extend(instanceParams, module.params);
        }
      });
    }
  }, {
    key: 'useModules',
    value: function useModules() {
      var modulesParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var instance = this;
      if (!instance.modules) return;
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName];
        var moduleParams = modulesParams[moduleName] || {};
        // Extend instance methods and props
        if (module.instance) {
          Object.keys(module.instance).forEach(function (modulePropName) {
            var moduleProp = module.instance[modulePropName];
            if (typeof moduleProp === 'function') {
              instance[modulePropName] = moduleProp.bind(instance);
            } else {
              instance[modulePropName] = moduleProp;
            }
          });
        }
        // Add event listeners
        if (module.on && instance.on) {
          Object.keys(module.on).forEach(function (moduleEventName) {
            instance.on(moduleEventName, module.on[moduleEventName]);
          });
        }

        // Module create callback
        if (module.create) {
          module.create.bind(instance)(moduleParams);
        }
      });
    }
  }], [{
    key: 'installModule',
    value: function installModule(module) {
      var Class = this;
      if (!Class.prototype.modules) Class.prototype.modules = {};
      var name = module.name || Object.keys(Class.prototype.modules).length + '_' + Utils.now();
      Class.prototype.modules[name] = module;
      // Prototype
      if (module.proto) {
        Object.keys(module.proto).forEach(function (key) {
          Class.prototype[key] = module.proto[key];
        });
      }
      // Class
      if (module.static) {
        Object.keys(module.static).forEach(function (key) {
          Class[key] = module.static[key];
        });
      }
      // Callback
      if (module.install) {
        for (var _len3 = arguments.length, params = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          params[_key3 - 1] = arguments[_key3];
        }

        module.install.apply(Class, params);
      }
      return Class;
    }
  }, {
    key: 'use',
    value: function use(module) {
      var Class = this;
      if (Array.isArray(module)) {
        module.forEach(function (m) {
          return Class.installModule(m);
        });
        return Class;
      }

      for (var _len4 = arguments.length, params = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        params[_key4 - 1] = arguments[_key4];
      }

      return Class.installModule.apply(Class, [module].concat(params));
    }
  }, {
    key: 'components',
    set: function set(components) {
      var Class = this;
      if (!Class.use) return;
      Class.use(components);
    }
  }]);

  return SwiperClass;
}();

function updateSize() {
  var swiper = this;
  var width = void 0;
  var height = void 0;
  var $el = swiper.$el;
  if (typeof swiper.params.width !== 'undefined') {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined') {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }

  // Subtract paddings
  width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
  height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

  Utils.extend(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  var swiper = this;
  var params = swiper.params;

  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;

  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children('.' + swiper.params.slideClass);
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];

  var offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.snapGrid.length;

  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index$$1 = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween;

  // reset margins
  if (rtl) slides.css({ marginLeft: '', marginTop: '' });else slides.css({ marginRight: '', marginBottom: '' });

  var slidesNumberEvenToRows = void 0;
  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }
    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  }

  // Calc slides
  var slideSize = void 0;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = slidesPerRow - (params.slidesPerColumn * slidesPerRow - slidesLength);
  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var _slide = slides.eq(i);
    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = void 0;
      var column = void 0;
      var row = void 0;
      if (params.slidesPerColumnFill === 'column') {
        column = Math.floor(i / slidesPerColumn);
        row = i - column * slidesPerColumn;
        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
          row += 1;
          if (row >= slidesPerColumn) {
            row = 0;
            column += 1;
          }
        }
        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
        _slide.css({
          '-webkit-box-ordinal-group': newSlideOrderIndex,
          '-moz-box-ordinal-group': newSlideOrderIndex,
          '-ms-flex-order': newSlideOrderIndex,
          '-webkit-order': newSlideOrderIndex,
          order: newSlideOrderIndex
        });
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - row * slidesPerRow;
      }
      _slide.css('margin-' + (swiper.isHorizontal() ? 'top' : 'left'), row !== 0 && params.spaceBetween && params.spaceBetween + 'px').attr('data-swiper-column', column).attr('data-swiper-row', row);
    }
    if (_slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = _ssrWindow.window.getComputedStyle(_slide[0], null);
      var currentTransform = _slide[0].style.transform;
      var currentWebKitTransform = _slide[0].style.webkitTransform;
      if (currentTransform) {
        _slide[0].style.transform = 'none';
      }
      if (currentWebKitTransform) {
        _slide[0].style.webkitTransform = 'none';
      }
      if (swiper.isHorizontal()) {
        slideSize = _slide[0].getBoundingClientRect().width + parseFloat(slideStyles.getPropertyValue('margin-left')) + parseFloat(slideStyles.getPropertyValue('margin-right'));
      } else {
        slideSize = _slide[0].getBoundingClientRect().height + parseFloat(slideStyles.getPropertyValue('margin-top')) + parseFloat(slideStyles.getPropertyValue('margin-bottom'));
      }
      if (currentTransform) {
        _slide[0].style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        _slide[0].style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        if (swiper.isHorizontal()) {
          slides[i].style.width = slideSize + 'px';
        } else {
          slides[i].style.height = slideSize + 'px';
        }
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index$$1 % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index$$1 % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;

    prevSlideSize = slideSize;

    index$$1 += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid = void 0;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({ width: swiper.virtualSize + params.spaceBetween + 'px' });
  }
  if (!Support.flexbox || params.setWrapperSize) {
    if (swiper.isHorizontal()) $wrapperEl.css({ width: swiper.virtualSize + params.spaceBetween + 'px' });else $wrapperEl.css({ height: swiper.virtualSize + params.spaceBetween + 'px' });
  }

  if (params.slidesPerColumn > 1) {
    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    if (swiper.isHorizontal()) $wrapperEl.css({ width: swiper.virtualSize + params.spaceBetween + 'px' });else $wrapperEl.css({ height: swiper.virtualSize + params.spaceBetween + 'px' });
    if (params.centeredSlides) {
      newSlidesGrid = [];
      for (var _i = 0; _i < snapGrid.length; _i += 1) {
        var slidesGridItem = snapGrid[_i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }
      snapGrid = newSlidesGrid;
    }
  }

  // Remove last grid elements depending on width
  if (!params.centeredSlides) {
    newSlidesGrid = [];
    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
      var _slidesGridItem = snapGrid[_i2];
      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);
      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(_slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    if (swiper.isHorizontal()) {
      if (rtl) slides.css({ marginLeft: spaceBetween + 'px' });else slides.css({ marginRight: spaceBetween + 'px' });
    } else slides.css({ marginBottom: spaceBetween + 'px' });
  }

  Utils.extend(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}

function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var newHeight = 0;
  var i = void 0;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  // Find slides currently in view
  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
      var index$$1 = swiper.activeIndex + i;
      if (index$$1 > swiper.slides.length) break;
      activeSlides.push(swiper.slides.eq(index$$1)[0]);
    }
  } else {
    activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
  }

  // Find new height from highest slide in view
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }

  // Update Height
  if (newHeight) swiper.$wrapperEl.css('height', newHeight + 'px');
}

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;
  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress() {
  var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this && this.translate || 0;

  var swiper = this;
  var params = swiper.params;

  var slides = swiper.slides,
      rtl = swiper.rtlTranslate;


  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();

  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate;

  // Visible Slides
  slides.removeClass(params.slideVisibleClass);

  for (var i = 0; i < slides.length; i += 1) {
    var _slide2 = slides[i];
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - _slide2.swiperSlideOffset) / (_slide2.swiperSlideSize + params.spaceBetween);
    if (params.watchSlidesVisibility) {
      var slideBefore = -(offsetCenter - _slide2.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible = slideBefore >= 0 && slideBefore < swiper.size || slideAfter > 0 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
      if (isVisible) {
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }
    _slide2.progress = rtl ? -slideProgress : slideProgress;
  }
}

function updateProgress() {
  var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this && this.translate || 0;

  var swiper = this;
  var params = swiper.params;

  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;

  var wasBeginning = isBeginning;
  var wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }
  Utils.extend(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });

  if (params.watchSlidesProgress || params.watchSlidesVisibility) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  var swiper = this;

  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;

  var isVirtual = swiper.virtual && params.virtual.enabled;

  slides.removeClass(params.slideActiveClass + ' ' + params.slideNextClass + ' ' + params.slidePrevClass + ' ' + params.slideDuplicateActiveClass + ' ' + params.slideDuplicateNextClass + ' ' + params.slideDuplicatePrevClass);

  var activeSlide = void 0;
  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find('.' + params.slideClass + '[data-swiper-slide-index="' + activeIndex + '"]');
  } else {
    activeSlide = slides.eq(activeIndex);
  }

  // Active classes
  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children('.' + params.slideClass + ':not(.' + params.slideDuplicateClass + ')[data-swiper-slide-index="' + realIndex + '"]').addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass + '[data-swiper-slide-index="' + realIndex + '"]').addClass(params.slideDuplicateActiveClass);
    }
  }
  // Next Slide
  var nextSlide = activeSlide.nextAll('.' + params.slideClass).eq(0).addClass(params.slideNextClass);
  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  }
  // Prev Slide
  var prevSlide = activeSlide.prevAll('.' + params.slideClass).eq(0).addClass(params.slidePrevClass);
  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }
  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children('.' + params.slideClass + ':not(.' + params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(params.slideDuplicateNextClass);
    }
    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children('.' + params.slideClass + ':not(.' + params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(params.slideDuplicatePrevClass);
    }
  }
}

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;

  var activeIndex = newActiveIndex;
  var snapIndex = void 0;
  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    return;
  }

  // Get real index
  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

  Utils.extend(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }
  swiper.emit('slideChange');
}

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = (0, _dom.$)(e.target).closest('.' + params.slideClass)[0];
  var slideFound = false;
  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) slideFound = true;
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt((0, _dom.$)(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = (0, _dom.$)(slide).index();
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};

function getTranslate() {
  var axis = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.isHorizontal() ? 'x' : 'y';

  var swiper = this;

  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;


  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;

  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      progress = swiper.progress;

  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (!params.virtualTranslate) {
    if (Support.transforms3d) $wrapperEl.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');else $wrapperEl.transform('translate(' + x + 'px, ' + y + 'px)');
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;

  // Check if we need to update progress
  var newProgress = void 0;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

var translate = {
  getTranslate: getTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate
};

function setTransition(duration, byController) {
  var swiper = this;

  swiper.$wrapperEl.transition(duration);

  swiper.emit('setTransition', duration, byController);
}

function transitionStart() {
  var runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var direction = arguments[1];

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }
    swiper.emit('slideChangeTransitionStart');
    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}

function transitionEnd$1() {
  var runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var direction = arguments[1];

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex;

  swiper.animating = false;
  swiper.setTransition(0);

  var dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }
    swiper.emit('slideChangeTransitionEnd');
    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}

var transition$1 = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd$1
};

function slideTo() {
  var index$$1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var internal = arguments[3];

  var swiper = this;
  var slideIndex = index$$1;
  if (slideIndex < 0) slideIndex = 0;

  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate;

  if (swiper.animating && params.preventIntercationOnTransition) {
    return false;
  }

  var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex];

  // Update progress
  swiper.updateProgress(translate);

  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
        slideIndex = i;
      }
    }
  }
  // Directions locks
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction = void 0;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';

  // Update Index
  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex);
    // Update Height
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }

  if (speed === 0 || !Support.transition) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd$$1(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.transitionEnd(runCallbacks, direction);
        };
      }
      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}

function slideToLoop() {
  var index$$1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var internal = arguments[3];

  var swiper = this;
  var newIndex = index$$1;
  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments[2];

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating;

  if (params.loop) {
    if (animating) return false;
    swiper.loopFix();
    // eslint-disable-next-line
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments[2];

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate;


  if (params.loop) {
    if (animating) return false;
    swiper.loopFix();
    // eslint-disable-next-line
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  var translate = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var normalizedSlidesGrid = slidesGrid.map(function (val) {
    return normalize(val);
  });

  var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  var prevIndex = void 0;
  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments[2];

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments[2];

  var swiper = this;
  var index$$1 = swiper.activeIndex;
  var snapIndex = Math.floor(index$$1 / swiper.params.slidesPerGroup);

  if (snapIndex < swiper.snapGrid.length - 1) {
    var _translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (_translate - currentSnap > (nextSnap - currentSnap) / 2) {
      index$$1 = swiper.params.slidesPerGroup;
    }
  }

  return swiper.slideTo(index$$1, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;


  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex = void 0;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt((0, _dom.$)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + params.slideDuplicateClass + ')').eq(0).index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + params.slideDuplicateClass + ')').eq(0).index();

      Utils.nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};

function loopCreate() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  // Remove duplicated slides

  $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass).remove();

  var slides = $wrapperEl.children('.' + params.slideClass);

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = (0, _dom.$)(_ssrWindow.document.createElement('div')).addClass(params.slideClass + ' ' + params.slideBlankClass);
        $wrapperEl.append(blankNode);
      }
      slides = $wrapperEl.children('.' + params.slideClass);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;

  swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
  swiper.loopedSlides += params.loopAdditionalSlides;
  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (index$$1, el) {
    var slide = (0, _dom.$)(el);
    if (index$$1 < swiper.loopedSlides) appendSlides.push(el);
    if (index$$1 < slides.length && index$$1 >= slides.length - swiper.loopedSlides) prependSlides.push(el);
    slide.attr('data-swiper-slide-index', index$$1);
  });
  for (var _i3 = 0; _i3 < appendSlides.length; _i3 += 1) {
    $wrapperEl.append((0, _dom.$)(appendSlides[_i3].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
  for (var _i4 = prependSlides.length - 1; _i4 >= 0; _i4 -= 1) {
    $wrapperEl.prepend((0, _dom.$)(prependSlides[_i4].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix() {
  var swiper = this;
  var params = swiper.params,
      activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;

  var newIndex = void 0;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;

  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate();

  // Fix For Negative Oversliding
  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2 || activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
}

function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;

  $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};

function setGrabCursor(moving) {
  var swiper = this;
  if (Support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked) return;
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor() {
  var swiper = this;
  if (Support.touch || swiper.params.watchOverflow && swiper.isLocked) return;
  swiper.el.style.cursor = '';
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};

function appendSlide(slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;

  if (params.loop) {
    swiper.loopDestroy();
  }
  if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
}

function prependSlide(slides) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;


  if (params.loop) {
    swiper.loopDestroy();
  }
  var newActiveIndex = activeIndex + 1;
  if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }
    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide(index$$1, slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;

  var activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children('.' + params.slideClass);
  }
  var baseLength = swiper.slides.length;
  if (index$$1 <= 0) {
    swiper.prependSlide(slides);
    return;
  } else if (index$$1 >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }
  var newActiveIndex = activeIndexBuffer > index$$1 ? activeIndexBuffer + 1 : activeIndexBuffer;

  var slidesBuffer = [];
  for (var i = baseLength - 1; i >= index$$1; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
    for (var _i5 = 0; _i5 < slides.length; _i5 += 1) {
      if (slides[_i5]) $wrapperEl.append(slides[_i5]);
    }
    newActiveIndex = activeIndexBuffer > index$$1 ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i6 = 0; _i6 < slidesBuffer.length; _i6 += 1) {
    $wrapperEl.append(slidesBuffer[_i6]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide(slidesIndexes) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;


  var activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children('.' + params.slideClass);
  }
  var newActiveIndex = activeIndexBuffer;
  var indexToRemove = void 0;

  if ((typeof slidesIndexes === 'undefined' ? 'undefined' : _typeof(slidesIndexes)) === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }
    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides() {
  var swiper = this;

  var slidesIndexes = [];
  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }
  swiper.removeSlide(slidesIndexes);
}

var manipulation = {
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
};

var Device = function Device() {
  var ua = _ssrWindow.window.navigator.userAgent;

  var device = {
    ios: false,
    android: false,
    androidChrome: false,
    desktop: false,
    windows: false,
    iphone: false,
    ipod: false,
    ipad: false,
    cordova: _ssrWindow.window.cordova || _ssrWindow.window.phonegap,
    phonegap: _ssrWindow.window.cordova || _ssrWindow.window.phonegap
  };

  var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);

  // Windows
  if (windows) {
    device.os = 'windows';
    device.osVersion = windows[2];
    device.windows = true;
  }
  // Android
  if (android && !windows) {
    device.os = 'android';
    device.osVersion = android[2];
    device.android = true;
    device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  }
  // iOS
  if (iphone && !ipod) {
    device.osVersion = iphone[2].replace(/_/g, '.');
    device.iphone = true;
  }
  if (ipad) {
    device.osVersion = ipad[2].replace(/_/g, '.');
    device.ipad = true;
  }
  if (ipod) {
    device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
    device.iphone = true;
  }
  // iOS 8+ changed UA
  if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
    if (device.osVersion.split('.')[0] === '10') {
      device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
    }
  }

  // Desktop
  device.desktop = !(device.os || device.android || device.webView);

  // Webview
  device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

  // Minimal UI
  if (device.os && device.os === 'ios') {
    var osVersionArr = device.osVersion.split('.');
    var metaViewport = _ssrWindow.document.querySelector('meta[name="viewport"]');
    device.minimalUi = !device.webView && (ipod || iphone) && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
  }

  // Pixel Ratio
  device.pixelRatio = _ssrWindow.window.devicePixelRatio || 1;

  // Export object
  return device;
}();

function onTouchStart(event) {
  var swiper = this;
  var data$$1 = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches;

  if (swiper.animating && params.preventIntercationOnTransition) {
    return;
  }
  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  data$$1.isTouchEvent = e.type === 'touchstart';
  if (!data$$1.isTouchEvent && 'which' in e && e.which === 3) return;
  if (data$$1.isTouched && data$$1.isMoved) return;
  if (params.noSwiping && (0, _dom.$)(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : '.' + params.noSwipingClass)[0]) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!(0, _dom.$)(e).closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY;

  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

  if (Device.ios && !Device.cordova && params.iOSEdgeSwipeDetection && (startX <= params.iOSEdgeSwipeThreshold || startX >= _ssrWindow.window.screen.width - params.iOSEdgeSwipeThreshold)) {
    return;
  }

  Utils.extend(data$$1, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });

  touches.startX = startX;
  touches.startY = startY;
  data$$1.touchStartTime = Utils.now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data$$1.allowThresholdMove = false;
  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ((0, _dom.$)(e.target).is(data$$1.formElements)) preventDefault = false;
    if (_ssrWindow.document.activeElement && (0, _dom.$)(_ssrWindow.document.activeElement).is(data$$1.formElements) && _ssrWindow.document.activeElement !== e.target) {
      _ssrWindow.document.activeElement.blur();
    }
    if (preventDefault && swiper.allowTouchMove) {
      e.preventDefault();
    }
  }
  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  var swiper = this;
  var data$$1 = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate;

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (!data$$1.isTouched) {
    if (data$$1.startMoving && data$$1.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  if (data$$1.isTouchEvent && e.type === 'mousemove') return;
  var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;
    if (data$$1.isTouched) {
      Utils.extend(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data$$1.touchStartTime = Utils.now();
    }
    return;
  }
  if (data$$1.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data$$1.isTouched = false;
        data$$1.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (data$$1.isTouchEvent && _ssrWindow.document.activeElement) {
    if (e.target === _ssrWindow.document.activeElement && (0, _dom.$)(e.target).is(data$$1.formElements)) {
      data$$1.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data$$1.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  if (e.targetTouches && e.targetTouches.length > 1) return;

  touches.currentX = pageX;
  touches.currentY = pageY;

  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;

  if (typeof data$$1.isScrolling === 'undefined') {
    var touchAngle = void 0;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data$$1.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data$$1.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data$$1.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data$$1.startMoving = true;
    }
  }
  if (data$$1.isScrolling) {
    data$$1.isTouched = false;
    return;
  }
  if (!data$$1.startMoving) {
    return;
  }
  swiper.allowClick = false;
  e.preventDefault();
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data$$1.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }
    data$$1.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }
    data$$1.allowMomentumBounce = false;
    // Grab Cursor
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  swiper.emit('sliderMove', e);
  data$$1.isMoved = true;

  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;

  diff *= params.touchRatio;
  if (rtl) diff = -diff;

  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data$$1.currentTranslate = diff + data$$1.startTranslate;

  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0 && data$$1.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data$$1.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data$$1.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data$$1.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data$$1.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data$$1.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }

  // Directions locks
  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data$$1.currentTranslate < data$$1.startTranslate) {
    data$$1.currentTranslate = data$$1.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data$$1.currentTranslate > data$$1.startTranslate) {
    data$$1.currentTranslate = data$$1.startTranslate;
  }

  // Threshold
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data$$1.allowThresholdMove) {
      if (!data$$1.allowThresholdMove) {
        data$$1.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data$$1.currentTranslate = data$$1.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data$$1.currentTranslate = data$$1.startTranslate;
      return;
    }
  }

  if (!params.followFinger) return;

  // Update active index in free mode
  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode) {
    // Velocity
    if (data$$1.velocities.length === 0) {
      data$$1.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data$$1.touchStartTime
      });
    }
    data$$1.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: Utils.now()
    });
  }
  // Update progress
  swiper.updateProgress(data$$1.currentTranslate);
  // Update translate
  swiper.setTranslate(data$$1.currentTranslate);
}

function onTouchEnd(event) {
  var swiper = this;
  var data$$1 = swiper.touchEventsData;

  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid;

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (data$$1.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data$$1.allowTouchCallbacks = false;
  if (!data$$1.isTouched) {
    if (data$$1.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data$$1.isMoved = false;
    data$$1.startMoving = false;
    return;
  }
  // Return Grab Cursor
  if (params.grabCursor && data$$1.isMoved && data$$1.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }

  // Time diff
  var touchEndTime = Utils.now();
  var timeDiff = touchEndTime - data$$1.touchStartTime;

  // Tap, doubleTap, Click
  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap', e);
    if (timeDiff < 300 && touchEndTime - data$$1.lastClickTime > 300) {
      if (data$$1.clickTimeout) clearTimeout(data$$1.clickTimeout);
      data$$1.clickTimeout = Utils.nextTick(function () {
        if (!swiper || swiper.destroyed) return;
        swiper.emit('click', e);
      }, 300);
    }
    if (timeDiff < 300 && touchEndTime - data$$1.lastClickTime < 300) {
      if (data$$1.clickTimeout) clearTimeout(data$$1.clickTimeout);
      swiper.emit('doubleTap', e);
    }
  }

  data$$1.lastClickTime = Utils.now();
  Utils.nextTick(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data$$1.isTouched || !data$$1.isMoved || !swiper.swipeDirection || touches.diff === 0 || data$$1.currentTranslate === data$$1.startTranslate) {
    data$$1.isTouched = false;
    data$$1.isMoved = false;
    data$$1.startMoving = false;
    return;
  }
  data$$1.isTouched = false;
  data$$1.isMoved = false;
  data$$1.startMoving = false;

  var currentPos = void 0;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data$$1.currentTranslate;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    } else if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }
      return;
    }

    if (params.freeModeMomentum) {
      if (data$$1.velocities.length > 1) {
        var lastMoveEvent = data$$1.velocities.pop();
        var velocityEvent = data$$1.velocities.pop();

        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;
        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        }
        // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.
        if (time > 150 || Utils.now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }
      swiper.velocity *= params.freeModeMomentumVelocityRatio;

      data$$1.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;

      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;

      var doBounce = false;
      var afterBouncePosition = void 0;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix = void 0;
      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }
          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data$$1.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }
          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data$$1.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        var nextSlide = void 0;
        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }
        newPosition = -newPosition;
      }
      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      }
      // Fix duration
      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data$$1.allowMomentumBounce) return;
          swiper.emit('momentumBounce');

          swiper.setTransition(params.speed);
          swiper.setTranslate(afterBouncePosition);
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    return;
  }

  // Find current slide
  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];
  for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
    if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
        stopIndex = i;
        groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  // Find current slide size
  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + params.slidesPerGroup);else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + params.slidesPerGroup);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      swiper.slideTo(stopIndex + params.slidesPerGroup);
    }
    if (swiper.swipeDirection === 'prev') {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  var swiper = this;

  var params = swiper.params,
      el = swiper.el;


  if (el && el.offsetWidth === 0) return;

  // Breakpoints
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }

  // Save locks
  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid;

  // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;

  swiper.updateSize();
  swiper.updateSlides();

  if (params.freeMode) {
    var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
    swiper.setTranslate(newTranslate);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
  } else {
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  // Return locks after resize
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  var swiper = this;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function attachEvents() {
  var swiper = this;
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl;


  {
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
  var capture = !!params.nested;

  // Touch Events
  {
    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
      _ssrWindow.document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
      _ssrWindow.document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
        target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
        target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
      }
      if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
        target.addEventListener('mousedown', swiper.onTouchStart, false);
        _ssrWindow.document.addEventListener('mousemove', swiper.onTouchMove, capture);
        _ssrWindow.document.addEventListener('mouseup', swiper.onTouchEnd, false);
      }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
      target.addEventListener('click', swiper.onClick, true);
    }
  }

  // Resize handler
  swiper.on(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
}

function detachEvents() {
  var swiper = this;

  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl;


  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
  var capture = !!params.nested;

  // Touch Events
  {
    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
      _ssrWindow.document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      _ssrWindow.document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
        target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
      }
      if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
        target.removeEventListener('mousedown', swiper.onTouchStart, false);
        _ssrWindow.document.removeEventListener('mousemove', swiper.onTouchMove, capture);
        _ssrWindow.document.removeEventListener('mouseup', swiper.onTouchEnd, false);
      }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
      target.removeEventListener('click', swiper.onClick, true);
    }
  }

  // Resize handler
  swiper.off(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
}

var events = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === undefined ? 0 : _swiper$loopedSlides,
      params = swiper.params;

  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
  // Set breakpoint for window width and update parameters
  var breakpoint = swiper.getBreakpoint(breakpoints);
  if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
    var breakPointsParams = breakpoint in breakpoints ? breakpoints[breakpoint] : swiper.originalParams;
    var needsReLoop = params.loop && breakPointsParams.slidesPerView !== params.slidesPerView;

    Utils.extend(swiper.params, breakPointsParams);

    Utils.extend(swiper, {
      allowTouchMove: swiper.params.allowTouchMove,
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev
    });

    swiper.currentBreakpoint = breakpoint;

    if (needsReLoop && initialized) {
      swiper.loopDestroy();
      swiper.loopCreate();
      swiper.updateSlides();
      swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakPointsParams);
  }
}

function getBreakpoint(breakpoints) {
  // Get breakpoint for window width
  if (!breakpoints) return undefined;
  var breakpoint = false;
  var points = [];
  Object.keys(breakpoints).forEach(function (point) {
    points.push(point);
  });
  points.sort(function (a, b) {
    return parseInt(a, 10) - parseInt(b, 10);
  });
  for (var i = 0; i < points.length; i += 1) {
    var point = points[i];
    if (point >= _ssrWindow.window.innerWidth && !breakpoint) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}

var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

var Browser = function Browser() {
  function isSafari() {
    var ua = _ssrWindow.window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }
  return {
    isIE: !!_ssrWindow.window.navigator.userAgent.match(/Trident/g) || !!_ssrWindow.window.navigator.userAgent.match(/MSIE/g),
    isSafari: isSafari(),
    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(_ssrWindow.window.navigator.userAgent)
  };
}();

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el;

  var suffixes = [];

  suffixes.push(params.direction);

  if (params.freeMode) {
    suffixes.push('free-mode');
  }
  if (!Support.flexbox) {
    suffixes.push('no-flexbox');
  }
  if (params.autoHeight) {
    suffixes.push('autoheight');
  }
  if (rtl) {
    suffixes.push('rtl');
  }
  if (params.slidesPerColumn > 1) {
    suffixes.push('multirow');
  }
  if (Device.android) {
    suffixes.push('android');
  }
  if (Device.ios) {
    suffixes.push('ios');
  }
  // WP8 Touch Events Fix
  if (Browser.isIE && (Support.pointerEvents || Support.prefixedPointerEvents)) {
    suffixes.push('wp8-' + params.direction);
  }

  suffixes.forEach(function (suffix) {
    classNames.push(params.containerModifierClass + suffix);
  });

  $el.addClass(classNames.join(' '));
}

function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;


  $el.removeClass(classNames.join(' '));
}

var classes = { addClasses: addClasses, removeClasses: removeClasses };

function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var image = void 0;
  function onReady() {
    if (callback) callback();
  }
  if (!imageEl.complete || !checkForComplete) {
    if (src) {
      image = new _ssrWindow.window.Image();
      image.onload = onReady;
      image.onerror = onReady;
      if (sizes) {
        image.sizes = sizes;
      }
      if (srcset) {
        image.srcset = srcset;
      }
      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');
  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }
  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

var images = {
  loadImage: loadImage,
  preloadImages: preloadImages
};

function checkOverflow() {
  var swiper = this;
  var wasLocked = swiper.isLocked;

  swiper.isLocked = swiper.snapGrid.length === 1;
  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked;

  // events
  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    swiper.navigation.update();
  }
}

var checkOverflow$1 = { checkOverflow: checkOverflow };

var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  //
  preventIntercationOnTransition: false,

  // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
  iOSEdgeSwipeDetection: false,
  iOSEdgeSwipeThreshold: 20,

  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,

  // Autoheight
  autoHeight: false,

  // Set wrapper width
  setWrapperSize: false,

  // Virtual Translate
  virtualTranslate: false,

  // Effects
  effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,

  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  centeredSlides: false,
  slidesOffsetBefore: 0, // in px
  slidesOffsetAfter: 0, // in px
  normalizeSlideIndex: true,

  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,

  // Round length
  roundLengths: false,

  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: true,
  touchReleaseOnEdges: false,

  // Unique Navigation Elements
  uniqueNavElements: true,

  // Resistance
  resistance: true,
  resistanceRatio: 0.85,

  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,

  // Cursor
  grabCursor: false,

  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,

  // Images
  preloadImages: true,
  updateOnImagesReady: true,

  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,

  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null, // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,

  // Passive Listeners
  passiveListeners: true,

  // NS
  containerModifierClass: 'swiper-container-', // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',

  // Callbacks
  runCallbacksOnInit: true
};

var prototypes = {
  update: update,
  translate: translate,
  transition: transition$1,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  manipulation: manipulation,
  events: events,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes,
  images: images
};

var extendedDefaults = {};

var Swiper = function (_SwiperClass) {
  _inherits(Swiper, _SwiperClass);

  function Swiper() {
    var _ret3;

    _classCallCheck(this, Swiper);

    var el = void 0;
    var params = void 0;

    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }
    if (!params) params = {};

    params = Utils.extend({}, params);
    if (el && !params.el) params.el = el;

    var _this = _possibleConstructorReturn(this, (Swiper.__proto__ || Object.getPrototypeOf(Swiper)).call(this, params));

    Object.keys(prototypes).forEach(function (prototypeGroup) {
      Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
        if (!Swiper.prototype[protoMethod]) {
          Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
        }
      });
    });

    // Swiper Instance
    var swiper = _this;
    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }
    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];
      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if ((typeof moduleParams === 'undefined' ? 'undefined' : _typeof(moduleParams)) !== 'object') return;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;
        if (params[moduleParamName] === true) {
          params[moduleParamName] = { enabled: true };
        }
        if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }
        if (!params[moduleParamName]) params[moduleParamName] = { enabled: false };
      }
    });

    // Extend defaults with modules params
    var swiperParams = Utils.extend({}, defaults);
    swiper.useModulesParams(swiperParams);

    // Extend defaults with passed params
    swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = Utils.extend({}, swiper.params);
    swiper.passedParams = Utils.extend({}, params);

    // Save Dom lib
    swiper.$ = _dom.$;

    // Find el
    var $el = (0, _dom.$)(swiper.params.el);
    el = $el[0];

    if (!el) {
      var _ret;

      return _ret = undefined, _possibleConstructorReturn(_this, _ret);
    }

    if ($el.length > 1) {
      var _ret2;

      var swipers = [];
      $el.each(function (index$$1, containerEl) {
        var newParams = Utils.extend({}, params, { el: containerEl });
        swipers.push(new Swiper(newParams));
      });
      return _ret2 = swipers, _possibleConstructorReturn(_this, _ret2);
    }

    el.swiper = swiper;
    $el.data('swiper', swiper);

    // Find Wrapper
    var $wrapperEl = $el.children('.' + swiper.params.wrapperClass);

    // Extend Swiper
    Utils.extend(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],

      // Classes
      classNames: [],

      // Slides
      slides: (0, _dom.$)(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box',

      // Indexes
      activeIndex: 0,
      realIndex: 0,

      //
      isBeginning: true,
      isEnd: false,

      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,

      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,

      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];
        if (Support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        } else if (Support.prefixedPointerEvents) {
          desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
        }
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        formElements: 'input, select, option, textarea, button, video',
        // Last click time
        lastClickTime: Utils.now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },

      // Clicks
      allowClick: true,

      // Touches
      allowTouchMove: swiper.params.allowTouchMove,

      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },

      // Images
      imagesToLoad: [],
      imagesLoaded: 0

    });

    // Install Modules
    swiper.useModules();

    // Init
    if (swiper.params.init) {
      swiper.init();
    }

    // Return app instance
    return _ret3 = swiper, _possibleConstructorReturn(_this, _ret3);
  }

  _createClass(Swiper, [{
    key: 'slidesPerViewDynamic',
    value: function slidesPerViewDynamic() {
      var swiper = this;
      var params = swiper.params,
          slides = swiper.slides,
          slidesGrid = swiper.slidesGrid,
          swiperSize = swiper.size,
          activeIndex = swiper.activeIndex;

      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop = void 0;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
        for (var _i7 = activeIndex - 1; _i7 >= 0; _i7 -= 1) {
          if (slides[_i7] && !breakLoop) {
            slideSize += slides[_i7].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        for (var _i8 = activeIndex + 1; _i8 < slides.length; _i8 += 1) {
          if (slidesGrid[_i8] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    }
  }, {
    key: 'update',
    value: function update() {
      var swiper = this;
      if (!swiper || swiper.destroyed) return;
      var snapGrid = swiper.snapGrid,
          params = swiper.params;
      // Breakpoints

      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated = void 0;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    }
  }, {
    key: 'init',
    value: function init() {
      var swiper = this;
      if (swiper.initialized) return;

      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }

      // Slide To Initial Slide
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      }

      // Attach events
      swiper.attachEvents();

      // Init Flag
      swiper.initialized = true;

      // Emit
      swiper.emit('init');
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var deleteInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var cleanStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var swiper = this;
      var params = swiper.params,
          $el = swiper.$el,
          $wrapperEl = swiper.$wrapperEl,
          slides = swiper.slides;


      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index').removeAttr('data-swiper-column').removeAttr('data-swiper-row');
        }
      }

      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }
      swiper.destroyed = true;

      return null;
    }
  }], [{
    key: 'extendDefaults',
    value: function extendDefaults(newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    }
  }, {
    key: 'extendedDefaults',
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: 'defaults',
    get: function get() {
      return defaults;
    }
  }, {
    key: 'Class',
    get: function get() {
      return SwiperClass;
    }
  }, {
    key: '$',
    get: function get() {
      return _dom.$;
    }
  }]);

  return Swiper;
}(SwiperClass);

var Device$1 = {
  name: 'device',
  proto: {
    device: Device
  },
  static: {
    device: Device
  }
};

var Support$1 = {
  name: 'support',
  proto: {
    support: Support
  },
  static: {
    support: Support
  }
};

var Browser$1 = {
  name: 'browser',
  proto: {
    browser: Browser
  },
  static: {
    browser: Browser
  }
};

var Resize = {
  name: 'resize',
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      resize: {
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        }
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      // Emit resize
      _ssrWindow.window.addEventListener('resize', swiper.resize.resizeHandler);

      // Emit orientationchange
      _ssrWindow.window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy() {
      var swiper = this;
      _ssrWindow.window.removeEventListener('resize', swiper.resize.resizeHandler);
      _ssrWindow.window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    }
  }
};

var Observer = {
  func: _ssrWindow.window.MutationObserver || _ssrWindow.window.WebkitMutationObserver,
  attach: function attach(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var swiper = this;

    var ObserverFunc = Observer.func;
    var observer = new ObserverFunc(function (mutations) {
      mutations.forEach(function (mutation) {
        swiper.emit('observerUpdate', mutation);
      });
    });

    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });

    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!Support.observer || !swiper.params.observer) return;
    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();
      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    }
    // Observe container
    swiper.observer.attach(swiper.$el[0], { childList: false });

    // Observe wrapper
    swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  }
};

var Observer$1 = {
  name: 'observer',
  params: {
    observer: false,
    observeParents: false
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      observer: {
        init: Observer.init.bind(swiper),
        attach: Observer.attach.bind(swiper),
        destroy: Observer.destroy.bind(swiper),
        observers: []
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      swiper.observer.init();
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.destroy();
    }
  }
};

var Virtual = {
  update: function update(force) {
    var swiper = this;
    var _swiper$params = swiper.params,
        slidesPerView = _swiper$params.slidesPerView,
        slidesPerGroup = _swiper$params.slidesPerGroup,
        centeredSlides = _swiper$params.centeredSlides;
    var _swiper$virtual = swiper.virtual,
        previousFrom = _swiper$virtual.from,
        previousTo = _swiper$virtual.to,
        slides = _swiper$virtual.slides,
        previousSlidesGrid = _swiper$virtual.slidesGrid,
        renderSlide = _swiper$virtual.renderSlide,
        previousOffset = _swiper$virtual.offset;

    swiper.updateActiveIndex();
    var activeIndex = swiper.activeIndex || 0;

    var offsetProp = void 0;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';

    var slidesAfter = void 0;
    var slidesBefore = void 0;
    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1);
      slidesBefore = slidesPerGroup;
    }
    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    var offset$$1 = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

    Utils.extend(swiper.virtual, {
      from: from,
      to: to,
      offset: offset$$1,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset$$1 !== previousOffset) {
        swiper.slides.css(offsetProp, offset$$1 + 'px');
      }
      swiper.updateProgress();
      return;
    }
    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset: offset$$1,
        from: from,
        to: to,
        slides: function getSlides() {
          var slidesToRender = [];
          for (var i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }
          return slidesToRender;
        }()
      });
      onRendered();
      return;
    }
    var prependIndexes = [];
    var appendIndexes = [];
    if (force) {
      swiper.$wrapperEl.find('.' + swiper.params.slideClass).remove();
    } else {
      for (var i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find('.' + swiper.params.slideClass + '[data-swiper-slide-index="' + i + '"]').remove();
        }
      }
    }
    for (var _i9 = 0; _i9 < slides.length; _i9 += 1) {
      if (_i9 >= from && _i9 <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(_i9);
        } else {
          if (_i9 > previousTo) appendIndexes.push(_i9);
          if (_i9 < previousFrom) prependIndexes.push(_i9);
        }
      }
    }
    appendIndexes.forEach(function (index$$1) {
      swiper.$wrapperEl.append(renderSlide(slides[index$$1], index$$1));
    });
    prependIndexes.sort(function (a, b) {
      return a < b;
    }).forEach(function (index$$1) {
      swiper.$wrapperEl.prepend(renderSlide(slides[index$$1], index$$1));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset$$1 + 'px');
    onRendered();
  },
  renderSlide: function renderSlide(slide, index$$1) {
    var swiper = this;
    var params = swiper.params.virtual;
    if (params.cache && swiper.virtual.cache[index$$1]) {
      return swiper.virtual.cache[index$$1];
    }
    var $slideEl = params.renderSlide ? (0, _dom.$)(params.renderSlide.call(swiper, slide, index$$1)) : (0, _dom.$)('<div class="' + swiper.params.slideClass + '" data-swiper-slide-index="' + index$$1 + '">' + slide + '</div>');
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index$$1);
    if (params.cache) swiper.virtual.cache[index$$1] = $slideEl;
    return $slideEl;
  },
  appendSlide: function appendSlide(slide) {
    var swiper = this;
    swiper.virtual.slides.push(slide);
    swiper.virtual.update(true);
  },
  prependSlide: function prependSlide(slide) {
    var swiper = this;
    swiper.virtual.slides.unshift(slide);
    if (swiper.params.virtual.cache) {
      var cache = swiper.virtual.cache;
      var newCache = {};
      Object.keys(cache).forEach(function (cachedIndex) {
        newCache[cachedIndex + 1] = cache[cachedIndex];
      });
      swiper.virtual.cache = newCache;
    }
    swiper.virtual.update(true);
    swiper.slideNext(0);
  }
};

var Virtual$1 = {
  name: 'virtual',
  params: {
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      virtual: {
        update: Virtual.update.bind(swiper),
        appendSlide: Virtual.appendSlide.bind(swiper),
        prependSlide: Virtual.prependSlide.bind(swiper),
        renderSlide: Virtual.renderSlide.bind(swiper),
        slides: swiper.params.virtual.slides,
        cache: {}
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (!swiper.params.virtual.enabled) return;
      swiper.classNames.push(swiper.params.containerModifierClass + 'virtual');
      var overwriteParams = {
        watchSlidesProgress: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);

      swiper.virtual.update();
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.virtual.enabled) return;
      swiper.virtual.update();
    }
  }
};

var Keyboard = {
  handle: function handle(event) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;

    var e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix
    var kc = e.keyCode || e.charCode;
    // Directions locks
    if (!swiper.allowSlideNext && (swiper.isHorizontal() && kc === 39 || swiper.isVertical() && kc === 40)) {
      return false;
    }
    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && kc === 37 || swiper.isVertical() && kc === 38)) {
      return false;
    }
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }
    if (_ssrWindow.document.activeElement && _ssrWindow.document.activeElement.nodeName && (_ssrWindow.document.activeElement.nodeName.toLowerCase() === 'input' || _ssrWindow.document.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }
    if (swiper.params.keyboard.onlyInViewport && (kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
      var inView = false;
      // Check that swiper should be inside of visible area of window
      if (swiper.$el.parents('.' + swiper.params.slideClass).length > 0 && swiper.$el.parents('.' + swiper.params.slideActiveClass).length === 0) {
        return undefined;
      }
      var windowWidth = _ssrWindow.window.innerWidth;
      var windowHeight = _ssrWindow.window.innerHeight;
      var swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];
      for (var i = 0; i < swiperCoord.length; i += 1) {
        var point = swiperCoord[i];
        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          inView = true;
        }
      }
      if (!inView) return undefined;
    }
    if (swiper.isHorizontal()) {
      if (kc === 37 || kc === 39) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }
      if (kc === 39 && !rtl || kc === 37 && rtl) swiper.slideNext();
      if (kc === 37 && !rtl || kc === 39 && rtl) swiper.slidePrev();
    } else {
      if (kc === 38 || kc === 40) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }
      if (kc === 40) swiper.slideNext();
      if (kc === 38) swiper.slidePrev();
    }
    swiper.emit('keyPress', kc);
    return undefined;
  },
  enable: function enable() {
    var swiper = this;
    if (swiper.keyboard.enabled) return;
    (0, _dom.$)(_ssrWindow.document).on('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = true;
  },
  disable: function disable() {
    var swiper = this;
    if (!swiper.keyboard.enabled) return;
    (0, _dom.$)(_ssrWindow.document).off('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = false;
  }
};

var Keyboard$1 = {
  name: 'keyboard',
  params: {
    keyboard: {
      enabled: false,
      onlyInViewport: true
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      keyboard: {
        enabled: false,
        enable: Keyboard.enable.bind(swiper),
        disable: Keyboard.disable.bind(swiper),
        handle: Keyboard.handle.bind(swiper)
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.keyboard.enabled) {
        swiper.keyboard.enable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.keyboard.enabled) {
        swiper.keyboard.disable();
      }
    }
  }
};

function isEventSupported() {
  var eventName = 'onwheel';
  var isSupported = eventName in _ssrWindow.document;

  if (!isSupported) {
    var element = _ssrWindow.document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && _ssrWindow.document.implementation && _ssrWindow.document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  _ssrWindow.document.implementation.hasFeature('', '') !== true) {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = _ssrWindow.document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}
var Mousewheel = {
  lastScrollTime: Utils.now(),
  event: function getEvent() {
    if (_ssrWindow.window.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
    return isEventSupported() ? 'wheel' : 'mousewheel';
  }(),
  normalize: function normalize(e) {
    // Reasonable defaults
    var PIXEL_STEP = 10;
    var LINE_HEIGHT = 40;
    var PAGE_HEIGHT = 800;

    var sX = 0;
    var sY = 0; // spinX, spinY
    var pX = 0;
    var pY = 0; // pixelX, pixelY

    // Legacy
    if ('detail' in e) {
      sY = e.detail;
    }
    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }
    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }
    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    }

    // side scrolling on FF with DOMMouseScroll
    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }
    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    }

    // Fall-back if spin cannot be determined
    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }
    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  },
  handleMouseEnter: function handleMouseEnter() {
    var swiper = this;
    swiper.mouseEntered = true;
  },
  handleMouseLeave: function handleMouseLeave() {
    var swiper = this;
    swiper.mouseEntered = false;
  },
  handle: function handle(event) {
    var e = event;
    var swiper = this;
    var params = swiper.params.mousewheel;

    if (!swiper.mouseEntered && !params.releaseOnEdges) return true;

    if (e.originalEvent) e = e.originalEvent; // jquery fix
    var delta = 0;
    var rtlFactor = swiper.rtlTranslate ? -1 : 1;

    var data$$1 = Mousewheel.normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data$$1.pixelX) > Math.abs(data$$1.pixelY)) delta = data$$1.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data$$1.pixelY) > Math.abs(data$$1.pixelX)) delta = data$$1.pixelY;else return true;
    } else {
      delta = Math.abs(data$$1.pixelX) > Math.abs(data$$1.pixelY) ? -data$$1.pixelX * rtlFactor : -data$$1.pixelY;
    }

    if (delta === 0) return true;

    if (params.invert) delta = -delta;

    if (!swiper.params.freeMode) {
      if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
        if (delta < 0) {
          if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
            swiper.slideNext();
            swiper.emit('scroll', e);
          } else if (params.releaseOnEdges) return true;
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
          swiper.slidePrev();
          swiper.emit('scroll', e);
        } else if (params.releaseOnEdges) return true;
      }
      swiper.mousewheel.lastScrollTime = new _ssrWindow.window.Date().getTime();
    } else {
      // Freemode or scrollContainer:
      if (swiper.params.loop) {
        swiper.loopFix();
      }
      var position = swiper.getTranslate() + delta * params.sensitivity;
      var wasBeginning = swiper.isBeginning;
      var wasEnd = swiper.isEnd;

      if (position >= swiper.minTranslate()) position = swiper.minTranslate();
      if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();

      swiper.setTransition(0);
      swiper.setTranslate(position);
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
        swiper.updateSlidesClasses();
      }

      if (swiper.params.freeModeSticky) {
        clearTimeout(swiper.mousewheel.timeout);
        swiper.mousewheel.timeout = Utils.nextTick(function () {
          swiper.slideToClosest();
        }, 300);
      }
      // Emit event
      swiper.emit('scroll', e);

      // Stop autoplay
      if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
      // Return page scroll on edge positions
      if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
    }

    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  },
  enable: function enable() {
    var swiper = this;
    if (!Mousewheel.event) return false;
    if (swiper.mousewheel.enabled) return false;
    var target = swiper.$el;
    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = (0, _dom.$)(swiper.params.mousewheel.eventsTarged);
    }
    target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
    target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
    target.on(Mousewheel.event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = true;
    return true;
  },
  disable: function disable() {
    var swiper = this;
    if (!Mousewheel.event) return false;
    if (!swiper.mousewheel.enabled) return false;
    var target = swiper.$el;
    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = (0, _dom.$)(swiper.params.mousewheel.eventsTarged);
    }
    target.off(Mousewheel.event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = false;
    return true;
  }
};

var Mousewheel$1 = {
  name: 'mousewheel',
  params: {
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarged: 'container'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      mousewheel: {
        enabled: false,
        enable: Mousewheel.enable.bind(swiper),
        disable: Mousewheel.disable.bind(swiper),
        handle: Mousewheel.handle.bind(swiper),
        handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
        handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
        lastScrollTime: Utils.now()
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
    }
  }
};

var Navigation = {
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;

    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;


    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        $prevEl.addClass(params.disabledClass);
      } else {
        $prevEl.removeClass(params.disabledClass);
      }
      $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        $nextEl.addClass(params.disabledClass);
      } else {
        $nextEl.removeClass(params.disabledClass);
      }
      $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    if (!(params.nextEl || params.prevEl)) return;

    var $nextEl = void 0;
    var $prevEl = void 0;
    if (params.nextEl) {
      $nextEl = (0, _dom.$)(params.nextEl);
      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }
    if (params.prevEl) {
      $prevEl = (0, _dom.$)(params.prevEl);
      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', function (e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop) return;
        swiper.slideNext();
      });
    }
    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', function (e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop) return;
        swiper.slidePrev();
      });
    }

    Utils.extend(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click');
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }
    if ($prevEl && $prevEl.length) {
      $prevEl.off('click');
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};

var Navigation$1 = {
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,

      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      navigation: {
        init: Navigation.init.bind(swiper),
        update: Navigation.update.bind(swiper),
        destroy: Navigation.destroy.bind(swiper)
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge() {
      var swiper = this;
      swiper.navigation.update();
    },
    fromEdge: function fromEdge() {
      var swiper = this;
      swiper.navigation.update();
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.navigation.destroy();
    },
    click: function click(e) {
      var swiper = this;
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if (swiper.params.navigation.hideOnClick && !(0, _dom.$)(e.target).is($prevEl) && !(0, _dom.$)(e.target).is($nextEl)) {
        if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
      }
    }
  }
};

var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    // Current/Total
    var current = void 0;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }
      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    }
    // Types
    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex = void 0;
      var lastIndex = void 0;
      var midIndex = void 0;
      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + 'px');
        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }
        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.removeClass(params.bulletActiveClass + ' ' + params.bulletActiveClass + '-next ' + params.bulletActiveClass + '-next-next ' + params.bulletActiveClass + '-prev ' + params.bulletActiveClass + '-prev-prev ' + params.bulletActiveClass + '-main');
      if ($el.length > 1) {
        bullets.each(function (index$$1, bullet) {
          var $bullet = (0, _dom.$)(bullet);
          var bulletIndex = $bullet.index();
          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + '-main');
            }
            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + '-prev').prev().addClass(params.bulletActiveClass + '-prev-prev');
            }
            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + '-next').next().addClass(params.bulletActiveClass + '-next-next');
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        $bullet.addClass(params.bulletActiveClass);
        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);
          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + '-main');
          }
          $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + '-prev').prev().addClass(params.bulletActiveClass + '-prev-prev');
          $lastDisplayedBullet.next().addClass(params.bulletActiveClass + '-next').next().addClass(params.bulletActiveClass + '-next-next');
        }
      }
      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + 'px');
      }
    }
    if (params.type === 'fraction') {
      $el.find('.' + params.currentClass).text(params.formatFractionCurrent(current + 1));
      $el.find('.' + params.totalClass).text(params.formatFractionTotal(total));
    }
    if (params.type === 'progressbar') {
      var progressbarDirection = void 0;
      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }
      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;
      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }
      $el.find('.' + params.progressbarFillClass).transform('translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')').transition(swiper.params.speed);
    }
    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', swiper, $el[0]);
    } else {
      swiper.emit('paginationUpdate', swiper, $el[0]);
    }
    $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

    var $el = swiper.pagination.$el;
    var paginationHTML = '';
    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += '<' + params.bulletElement + ' class="' + params.bulletClass + '"></' + params.bulletElement + '>';
        }
      }
      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find('.' + params.bulletClass);
    }
    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = '<span class="' + params.currentClass + '"></span>' + ' / ' + ('<span class="' + params.totalClass + '"></span>');
      }
      $el.html(paginationHTML);
    }
    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = '<span class="' + params.progressbarFillClass + '"></span>';
      }
      $el.html(paginationHTML);
    }
    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el) return;

    var $el = (0, _dom.$)(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && swiper.$el.find(params.el).length === 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass('' + params.modifierClass + params.type + '-dynamic');
      swiper.pagination.dynamicBulletIndex = 0;
      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }
    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', '.' + params.bulletClass, function onClick(e) {
        e.preventDefault();
        var index$$1 = (0, _dom.$)(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index$$1 += swiper.loopedSlides;
        swiper.slideTo(index$$1);
      });
    }

    Utils.extend(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;

    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
    if (params.clickable) {
      $el.off('click', '.' + params.bulletClass);
    }
  }
};

var Pagination$1 = {
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-', // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable', // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      pagination: {
        init: Pagination.init.bind(swiper),
        render: Pagination.render.bind(swiper),
        update: Pagination.update.bind(swiper),
        destroy: Pagination.destroy.bind(swiper),
        dynamicBulletIndex: 0
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange() {
      var swiper = this;
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange() {
      var swiper = this;
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange() {
      var swiper = this;
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange() {
      var swiper = this;
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.pagination.destroy();
    },
    click: function click(e) {
      var swiper = this;
      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !(0, _dom.$)(e.target).hasClass(swiper.params.pagination.bulletClass)) {
        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
};

var Scrollbar = {
  setTranslate: function setTranslate() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate,
        progress = swiper.progress;
    var dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;

    var params = swiper.params.scrollbar;

    var newSize = dragSize;
    var newPos = (trackSize - dragSize) * progress;
    if (rtl) {
      newPos = -newPos;
      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }
    if (swiper.isHorizontal()) {
      if (Support.transforms3d) {
        $dragEl.transform('translate3d(' + newPos + 'px, 0, 0)');
      } else {
        $dragEl.transform('translateX(' + newPos + 'px)');
      }
      $dragEl[0].style.width = newSize + 'px';
    } else {
      if (Support.transforms3d) {
        $dragEl.transform('translate3d(0px, ' + newPos + 'px, 0)');
      } else {
        $dragEl.transform('translateY(' + newPos + 'px)');
      }
      $dragEl[0].style.height = newSize + 'px';
    }
    if (params.hide) {
      clearTimeout(swiper.scrollbar.timeout);
      $el[0].style.opacity = 1;
      swiper.scrollbar.timeout = setTimeout(function () {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  },
  updateSize: function updateSize() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;

    var scrollbar = swiper.scrollbar;
    var $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;


    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

    var divider = swiper.size / swiper.virtualSize;
    var moveDivider = divider * (trackSize / swiper.size);
    var dragSize = void 0;
    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = dragSize + 'px';
    } else {
      $dragEl[0].style.height = dragSize + 'px';
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }
    if (swiper.params.scrollbarHide) {
      $el[0].style.opacity = 0;
    }
    Utils.extend(scrollbar, {
      trackSize: trackSize,
      divider: divider,
      moveDivider: moveDivider,
      dragSize: dragSize
    });
    scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
  },
  setDragPosition: function setDragPosition(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate;
    var $el = scrollbar.$el,
        dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize;


    var pointerPosition = void 0;
    if (swiper.isHorizontal()) {
      pointerPosition = e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX || e.clientX;
    } else {
      pointerPosition = e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY || e.clientY;
    }
    var positionRatio = void 0;
    positionRatio = (pointerPosition - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - dragSize / 2) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;

    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  },
  onDragStart: function onDragStart(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;

    swiper.scrollbar.isTouched = true;
    e.preventDefault();
    e.stopPropagation();

    $wrapperEl.transition(100);
    $dragEl.transition(100);
    scrollbar.setDragPosition(e);

    clearTimeout(swiper.scrollbar.dragTimeout);

    $el.transition(0);
    if (params.hide) {
      $el.css('opacity', 1);
    }
    swiper.emit('scrollbarDragStart', e);
  },
  onDragMove: function onDragMove(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;


    if (!swiper.scrollbar.isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    scrollbar.setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    swiper.emit('scrollbarDragMove', e);
  },
  onDragEnd: function onDragEnd(e) {
    var swiper = this;

    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar;
    var $el = scrollbar.$el;


    if (!swiper.scrollbar.isTouched) return;
    swiper.scrollbar.isTouched = false;
    if (params.hide) {
      clearTimeout(swiper.scrollbar.dragTimeout);
      swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }
    swiper.emit('scrollbarDragEnd', e);
    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  },
  enableDraggable: function enableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        touchEvents = swiper.touchEvents,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params;

    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = Support.passiveListener && params.passiveListener ? { passive: false, capture: false } : false;
    var passiveListener = Support.passiveListener && params.passiveListener ? { passive: true, capture: false } : false;
    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      _ssrWindow.document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      _ssrWindow.document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      if (Support.touch) {
        target.addEventListener(touchEvents.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEvents.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEvents.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
      if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
        target.addEventListener('mousedown', swiper.scrollbar.onDragStart, activeListener);
        _ssrWindow.document.addEventListener('mousemove', swiper.scrollbar.onDragMove, activeListener);
        _ssrWindow.document.addEventListener('mouseup', swiper.scrollbar.onDragEnd, passiveListener);
      }
    }
  },
  disableDraggable: function disableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        touchEvents = swiper.touchEvents,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params;

    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = Support.passiveListener && params.passiveListener ? { passive: false, capture: false } : false;
    var passiveListener = Support.passiveListener && params.passiveListener ? { passive: true, capture: false } : false;
    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      _ssrWindow.document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      _ssrWindow.document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      if (Support.touch) {
        target.removeEventListener(touchEvents.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEvents.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEvents.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
      if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
        target.removeEventListener('mousedown', swiper.scrollbar.onDragStart, activeListener);
        _ssrWindow.document.removeEventListener('mousemove', swiper.scrollbar.onDragMove, activeListener);
        _ssrWindow.document.removeEventListener('mouseup', swiper.scrollbar.onDragEnd, passiveListener);
      }
    }
  },
  init: function init() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        $swiperEl = swiper.$el;

    var params = swiper.params.scrollbar;

    var $el = (0, _dom.$)(params.el);
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    var $dragEl = $el.find('.' + swiper.params.scrollbar.dragClass);
    if ($dragEl.length === 0) {
      $dragEl = (0, _dom.$)('<div class="' + swiper.params.scrollbar.dragClass + '"></div>');
      $el.append($dragEl);
    }

    Utils.extend(scrollbar, {
      $el: $el,
      el: $el[0],
      $dragEl: $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      scrollbar.enableDraggable();
    }
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.scrollbar.disableDraggable();
  }
};

var Scrollbar$1 = {
  name: 'scrollbar',
  params: {
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      scrollbar: {
        init: Scrollbar.init.bind(swiper),
        destroy: Scrollbar.destroy.bind(swiper),
        updateSize: Scrollbar.updateSize.bind(swiper),
        setTranslate: Scrollbar.setTranslate.bind(swiper),
        setTransition: Scrollbar.setTransition.bind(swiper),
        enableDraggable: Scrollbar.enableDraggable.bind(swiper),
        disableDraggable: Scrollbar.disableDraggable.bind(swiper),
        setDragPosition: Scrollbar.setDragPosition.bind(swiper),
        onDragStart: Scrollbar.onDragStart.bind(swiper),
        onDragMove: Scrollbar.onDragMove.bind(swiper),
        onDragEnd: Scrollbar.onDragEnd.bind(swiper),
        isTouched: false,
        timeout: null,
        dragTimeout: null
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      swiper.scrollbar.init();
      swiper.scrollbar.updateSize();
      swiper.scrollbar.setTranslate();
    },
    update: function update() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    resize: function resize() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      swiper.scrollbar.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.scrollbar.setTransition(duration);
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.destroy();
    }
  }
};

var Parallax = {
  setTransform: function setTransform(el, progress) {
    var swiper = this;
    var rtl = swiper.rtl;


    var $el = (0, _dom.$)(el);
    var rtlFactor = rtl ? -1 : 1;

    var p = $el.attr('data-swiper-parallax') || '0';
    var x = $el.attr('data-swiper-parallax-x');
    var y = $el.attr('data-swiper-parallax-y');
    var scale = $el.attr('data-swiper-parallax-scale');
    var opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if (x.indexOf('%') >= 0) {
      x = parseInt(x, 10) * progress * rtlFactor + '%';
    } else {
      x = x * progress * rtlFactor + 'px';
    }
    if (y.indexOf('%') >= 0) {
      y = parseInt(y, 10) * progress + '%';
    } else {
      y = y * progress + 'px';
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      $el[0].style.opacity = currentOpacity;
    }
    if (typeof scale === 'undefined' || scale === null) {
      $el.transform('translate3d(' + x + ', ' + y + ', 0px)');
    } else {
      var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      $el.transform('translate3d(' + x + ', ' + y + ', 0px) scale(' + currentScale + ')');
    }
  },
  setTranslate: function setTranslate() {
    var swiper = this;
    var $el = swiper.$el,
        slides = swiper.slides,
        progress = swiper.progress,
        snapGrid = swiper.snapGrid;

    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function (index$$1, el) {
      swiper.parallax.setTransform(el, progress);
    });
    slides.each(function (slideIndex, slideEl) {
      var slideProgress = slideEl.progress;
      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }
      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      (0, _dom.$)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function (index$$1, el) {
        swiper.parallax.setTransform(el, slideProgress);
      });
    });
  },
  setTransition: function setTransition() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;

    var swiper = this;
    var $el = swiper.$el;

    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function (index$$1, parallaxEl) {
      var $parallaxEl = (0, _dom.$)(parallaxEl);
      var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      $parallaxEl.transition(parallaxDuration);
    });
  }
};

var Parallax$1 = {
  name: 'parallax',
  params: {
    parallax: {
      enabled: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      parallax: {
        setTransform: Parallax.setTransform.bind(swiper),
        setTranslate: Parallax.setTranslate.bind(swiper),
        setTransition: Parallax.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.params.watchSlidesProgress = true;
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.parallax) return;
      swiper.parallax.setTranslate();
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.parallax) return;
      swiper.parallax.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.parallax) return;
      swiper.parallax.setTransition(duration);
    }
  }
};

var Zoom = {
  // Calc Scale From Multi-touches
  getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    var x1 = e.targetTouches[0].pageX;
    var y1 = e.targetTouches[0].pageY;
    var x2 = e.targetTouches[1].pageX;
    var y2 = e.targetTouches[1].pageY;
    var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    return distance;
  },

  // Events
  onGestureStart: function onGestureStart(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    zoom.fakeGestureTouched = false;
    zoom.fakeGestureMoved = false;
    if (!Support.gestures) {
      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
        return;
      }
      zoom.fakeGestureTouched = true;
      gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
    }
    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = (0, _dom.$)(e.target).closest('.swiper-slide');
      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
      gesture.$imageWrapEl = gesture.$imageEl.parent('.' + params.containerClass);
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }
    gesture.$imageEl.transition(0);
    swiper.zoom.isScaling = true;
  },
  onGestureChange: function onGestureChange(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (!Support.gestures) {
      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
        return;
      }
      zoom.fakeGestureMoved = true;
      gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (Support.gestures) {
      swiper.zoom.scale = e.scale * zoom.currentScale;
    } else {
      zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
    }
    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
    }
    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
    }
    gesture.$imageEl.transform('translate3d(0,0,0) scale(' + zoom.scale + ')');
  },
  onGestureEnd: function onGestureEnd(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (!Support.gestures) {
      if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
        return;
      }
      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android) {
        return;
      }
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform('translate3d(0,0,0) scale(' + zoom.scale + ')');
    zoom.currentScale = zoom.scale;
    zoom.isScaling = false;
    if (zoom.scale === 1) gesture.$slideEl = undefined;
  },
  onTouchStart: function onTouchStart(e) {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image;

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (image.isTouched) return;
    if (Device.android) e.preventDefault();
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  },
  onTouchMove: function onTouchMove(e) {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image,
        velocity = zoom.velocity;

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) return;

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);
      if (swiper.rtl) {
        image.startX = -image.startX;
        image.startY = -image.startY;
      }
    }
    // Define if we need image drag
    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;

    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;

    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;

    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !zoom.isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        return;
      } else if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        return;
      }
    }
    e.preventDefault();
    e.stopPropagation();

    image.isMoved = true;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
    }
    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
    }

    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
    }
    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
    }

    // Velocity
    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();

    gesture.$imageWrapEl.transform('translate3d(' + image.currentX + 'px, ' + image.currentY + 'px,0)');
  },
  onTouchEnd: function onTouchEnd() {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image,
        velocity = zoom.velocity;

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }
    image.isTouched = false;
    image.isMoved = false;
    var momentumDurationX = 300;
    var momentumDurationY = 300;
    var momentumDistanceX = velocity.x * momentumDurationX;
    var newPositionX = image.currentX + momentumDistanceX;
    var momentumDistanceY = velocity.y * momentumDurationY;
    var newPositionY = image.currentY + momentumDistanceY;

    // Fix duration
    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

    image.currentX = newPositionX;
    image.currentY = newPositionY;

    // Define if we need image drag
    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

    gesture.$imageWrapEl.transition(momentumDuration).transform('translate3d(' + image.currentX + 'px, ' + image.currentY + 'px,0)');
  },
  onTransitionEnd: function onTransitionEnd() {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      gesture.$imageWrapEl.transform('translate3d(0,0,0)');
      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;

      zoom.scale = 1;
      zoom.currentScale = 1;
    }
  },

  // Toggle Zoom
  toggle: function toggle(e) {
    var swiper = this;
    var zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoom.out();
    } else {
      // Zoom In
      zoom.in(e);
    }
  },
  in: function _in(e) {
    var swiper = this;

    var zoom = swiper.zoom;
    var params = swiper.params.zoom;
    var gesture = zoom.gesture,
        image = zoom.image;


    if (!gesture.$slideEl) {
      gesture.$slideEl = swiper.clickedSlide ? (0, _dom.$)(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
      gesture.$imageWrapEl = gesture.$imageEl.parent('.' + params.containerClass);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    gesture.$slideEl.addClass('' + params.zoomedSlideClass);

    var touchX = void 0;
    var touchY = void 0;
    var offsetX = void 0;
    var offsetY = void 0;
    var diffX = void 0;
    var diffY = void 0;
    var translateX = void 0;
    var translateY = void 0;
    var imageWidth = void 0;
    var imageHeight = void 0;
    var scaledWidth = void 0;
    var scaledHeight = void 0;
    var translateMinX = void 0;
    var translateMinY = void 0;
    var translateMaxX = void 0;
    var translateMaxY = void 0;
    var slideWidth = void 0;
    var slideHeight = void 0;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left;
      offsetY = gesture.$slideEl.offset().top;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;

      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;

      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;

      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }
      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }
      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }
    gesture.$imageWrapEl.transition(300).transform('translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(' + zoom.scale + ')');
  },
  out: function out() {
    var swiper = this;

    var zoom = swiper.zoom;
    var params = swiper.params.zoom;
    var gesture = zoom.gesture;


    if (!gesture.$slideEl) {
      gesture.$slideEl = swiper.clickedSlide ? (0, _dom.$)(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
      gesture.$imageWrapEl = gesture.$imageEl.parent('.' + params.containerClass);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    zoom.scale = 1;
    zoom.currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass('' + params.zoomedSlideClass);
    gesture.$slideEl = undefined;
  },

  // Attach/Detach Events
  enable: function enable() {
    var swiper = this;
    var zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;

    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

    // Scale image
    if (Support.gestures) {
      swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
    }

    // Move image
    swiper.$wrapperEl.on(swiper.touchEvents.move, '.' + swiper.params.zoom.containerClass, zoom.onTouchMove);
  },
  disable: function disable() {
    var swiper = this;
    var zoom = swiper.zoom;
    if (!zoom.enabled) return;

    swiper.zoom.enabled = false;

    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

    // Scale image
    if (Support.gestures) {
      swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
    }

    // Move image
    swiper.$wrapperEl.off(swiper.touchEvents.move, '.' + swiper.params.zoom.containerClass, zoom.onTouchMove);
  }
};

var Zoom$1 = {
  name: 'zoom',
  params: {
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  },
  create: function create() {
    var swiper = this;
    var zoom = {
      enabled: false,
      scale: 1,
      currentScale: 1,
      isScaling: false,
      gesture: {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
      },
      image: {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
      },
      velocity: {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
      }
    };
    'onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out'.split(' ').forEach(function (methodName) {
      zoom[methodName] = Zoom[methodName].bind(swiper);
    });
    Utils.extend(swiper, {
      zoom: zoom
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.zoom.enabled) {
        swiper.zoom.enable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.zoom.disable();
    },
    touchStart: function touchStart(e) {
      var swiper = this;
      if (!swiper.zoom.enabled) return;
      swiper.zoom.onTouchStart(e);
    },
    touchEnd: function touchEnd(e) {
      var swiper = this;
      if (!swiper.zoom.enabled) return;
      swiper.zoom.onTouchEnd(e);
    },
    doubleTap: function doubleTap(e) {
      var swiper = this;
      if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
        swiper.zoom.toggle(e);
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
        swiper.zoom.onTransitionEnd();
      }
    }
  }
};

var Lazy = {
  loadInSlide: function loadInSlide(index$$1) {
    var loadInDuplicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var swiper = this;
    var params = swiper.params.lazy;
    if (typeof index$$1 === 'undefined') return;
    if (swiper.slides.length === 0) return;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

    var $slideEl = isVirtual ? swiper.$wrapperEl.children('.' + swiper.params.slideClass + '[data-swiper-slide-index="' + index$$1 + '"]') : swiper.slides.eq(index$$1);

    var $images = $slideEl.find('.' + params.elementClass + ':not(.' + params.loadedClass + '):not(.' + params.loadingClass + ')');
    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images = $images.add($slideEl[0]);
    }
    if ($images.length === 0) return;

    $images.each(function (imageIndex, imageEl) {
      var $imageEl = (0, _dom.$)(imageEl);
      $imageEl.addClass(params.loadingClass);

      var background = $imageEl.attr('data-background');
      var src = $imageEl.attr('data-src');
      var srcset = $imageEl.attr('data-srcset');
      var sizes = $imageEl.attr('data-sizes');

      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
        if (background) {
          $imageEl.css('background-image', 'url("' + background + '")');
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }
          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }
          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find('.' + params.preloaderClass).remove();
        if (swiper.params.loop && loadInDuplicate) {
          var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            var originalSlide = swiper.$wrapperEl.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + swiper.params.slideDuplicateClass + ')');
            swiper.lazy.loadInSlide(originalSlide.index(), false);
          } else {
            var duplicatedSlide = swiper.$wrapperEl.children('.' + swiper.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
            swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
          }
        }
        swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
      });

      swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  },
  load: function load() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
        swiperParams = swiper.params,
        slides = swiper.slides,
        activeIndex = swiper.activeIndex;

    var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    var params = swiperParams.lazy;

    var slidesPerView = swiperParams.slidesPerView;
    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index$$1) {
      if (isVirtual) {
        if ($wrapperEl.children('.' + swiperParams.slideClass + '[data-swiper-slide-index="' + index$$1 + '"]').length) {
          return true;
        }
      } else if (slides[index$$1]) return true;
      return false;
    }
    function slideIndex(slideEl) {
      if (isVirtual) {
        return (0, _dom.$)(slideEl).attr('data-swiper-slide-index');
      }
      return (0, _dom.$)(slideEl).index();
    }

    if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
    if (swiper.params.watchSlidesVisibility) {
      $wrapperEl.children('.' + swiperParams.slideVisibleClass).each(function (elIndex, slideEl) {
        var index$$1 = isVirtual ? (0, _dom.$)(slideEl).attr('data-swiper-slide-index') : (0, _dom.$)(slideEl).index();
        swiper.lazy.loadInSlide(index$$1);
      });
    } else if (slidesPerView > 1) {
      for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) swiper.lazy.loadInSlide(i);
      }
    } else {
      swiper.lazy.loadInSlide(activeIndex);
    }
    if (params.loadPrevNext) {
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        var amount = params.loadPrevNextAmount;
        var spv = slidesPerView;
        var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
        // Next Slides
        for (var _i10 = activeIndex + slidesPerView; _i10 < maxIndex; _i10 += 1) {
          if (slideExist(_i10)) swiper.lazy.loadInSlide(_i10);
        }
        // Prev Slides
        for (var _i11 = minIndex; _i11 < activeIndex; _i11 += 1) {
          if (slideExist(_i11)) swiper.lazy.loadInSlide(_i11);
        }
      } else {
        var nextSlide = $wrapperEl.children('.' + swiperParams.slideNextClass);
        if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));

        var prevSlide = $wrapperEl.children('.' + swiperParams.slidePrevClass);
        if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
      }
    }
  }
};

var Lazy$1 = {
  name: 'lazy',
  params: {
    lazy: {
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,

      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      lazy: {
        initialImageLoaded: false,
        load: Lazy.load.bind(swiper),
        loadInSlide: Lazy.loadInSlide.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
        swiper.params.preloadImages = false;
      }
    },
    init: function init() {
      var swiper = this;
      if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
        swiper.lazy.load();
      }
    },
    scroll: function scroll() {
      var swiper = this;
      if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
        swiper.lazy.load();
      }
    },
    resize: function resize() {
      var swiper = this;
      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    scrollbarDragMove: function scrollbarDragMove() {
      var swiper = this;
      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    transitionStart: function transitionStart() {
      var swiper = this;
      if (swiper.params.lazy.enabled) {
        if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
          swiper.lazy.load();
        }
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
        swiper.lazy.load();
      }
    }
  }
};

/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

var Controller = {
  LinearSpline: function LinearSpline(x, y) {
    var binarySearch = function search() {
      var maxIndex = void 0;
      var minIndex = void 0;
      var guess = void 0;
      return function (array, val) {
        minIndex = -1;
        maxIndex = array.length;
        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;
          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }
        return maxIndex;
      };
    }();
    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1;
    // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.
    var i1 = void 0;
    var i3 = void 0;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0;

      // Get the indexes of x1 and x3 (the array indexes before and after given x2):
      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1;

      // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };
    return this;
  },
  // xxx: for now i will just save one spline function to to
  getInterpolateFunction: function getInterpolateFunction(c) {
    var swiper = this;
    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  },
  setTranslate: function setTranslate(_setTranslate, byController) {
    var swiper = this;
    var controlled = swiper.controller.control;
    var multiplier = void 0;
    var controlledTranslate = void 0;
    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
      if (swiper.params.controller.by === 'slide') {
        swiper.controller.getInterpolateFunction(c);
        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out
        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }
      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }
    if (Array.isArray(controlled)) {
      for (var i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  },
  setTransition: function setTransition(duration, byController) {
    var swiper = this;
    var controlled = swiper.controller.control;
    var i = void 0;
    function setControlledTransition(c) {
      c.setTransition(duration, swiper);
      if (duration !== 0) {
        c.transitionStart();
        c.$wrapperEl.transitionEnd(function () {
          if (!controlled) return;
          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }
          c.transitionEnd();
        });
      }
    }
    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }
};
var Controller$1 = {
  name: 'controller',
  params: {
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      controller: {
        control: swiper.params.controller.control,
        getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
        setTranslate: Controller.setTranslate.bind(swiper),
        setTransition: Controller.setTransition.bind(swiper)
      }
    });
  },

  on: {
    update: function update() {
      var swiper = this;
      if (!swiper.controller.control) return;
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    resize: function resize() {
      var swiper = this;
      if (!swiper.controller.control) return;
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      if (!swiper.controller.control) return;
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    setTranslate: function setTranslate(translate, byController) {
      var swiper = this;
      if (!swiper.controller.control) return;
      swiper.controller.setTranslate(translate, byController);
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      if (!swiper.controller.control) return;
      swiper.controller.setTransition(duration, byController);
    }
  }
};

var a11y = {
  makeElFocusable: function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
    return $el;
  },
  addElRole: function addElRole($el, role) {
    $el.attr('role', role);
    return $el;
  },
  addElLabel: function addElLabel($el, label) {
    $el.attr('aria-label', label);
    return $el;
  },
  disableEl: function disableEl($el) {
    $el.attr('aria-disabled', true);
    return $el;
  },
  enableEl: function enableEl($el) {
    $el.attr('aria-disabled', false);
    return $el;
  },
  onEnterKey: function onEnterKey(e) {
    var swiper = this;
    var params = swiper.params.a11y;
    if (e.keyCode !== 13) return;
    var $targetEl = (0, _dom.$)(e.target);
    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }
      if (swiper.isEnd) {
        swiper.a11y.notify(params.lastSlideMessage);
      } else {
        swiper.a11y.notify(params.nextSlideMessage);
      }
    }
    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }
      if (swiper.isBeginning) {
        swiper.a11y.notify(params.firstSlideMessage);
      } else {
        swiper.a11y.notify(params.prevSlideMessage);
      }
    }
    if (swiper.pagination && $targetEl.is('.' + swiper.params.pagination.bulletClass)) {
      $targetEl[0].click();
    }
  },
  notify: function notify(message) {
    var swiper = this;
    var notification = swiper.a11y.liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  },
  updateNavigation: function updateNavigation() {
    var swiper = this;

    if (swiper.params.loop) return;
    var _swiper$navigation4 = swiper.navigation,
        $nextEl = _swiper$navigation4.$nextEl,
        $prevEl = _swiper$navigation4.$prevEl;


    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        swiper.a11y.disableEl($prevEl);
      } else {
        swiper.a11y.enableEl($prevEl);
      }
    }
    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        swiper.a11y.disableEl($nextEl);
      } else {
        swiper.a11y.enableEl($nextEl);
      }
    }
  },
  updatePagination: function updatePagination() {
    var swiper = this;
    var params = swiper.params.a11y;
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
        var $bulletEl = (0, _dom.$)(bulletEl);
        swiper.a11y.makeElFocusable($bulletEl);
        swiper.a11y.addElRole($bulletEl, 'button');
        swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
      });
    }
  },
  init: function init() {
    var swiper = this;

    swiper.$el.append(swiper.a11y.liveRegion);

    // Navigation
    var params = swiper.params.a11y;
    var $nextEl = void 0;
    var $prevEl = void 0;
    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }
    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }
    if ($nextEl) {
      swiper.a11y.makeElFocusable($nextEl);
      swiper.a11y.addElRole($nextEl, 'button');
      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
      $nextEl.on('keydown', swiper.a11y.onEnterKey);
    }
    if ($prevEl) {
      swiper.a11y.makeElFocusable($prevEl);
      swiper.a11y.addElRole($prevEl, 'button');
      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
      $prevEl.on('keydown', swiper.a11y.onEnterKey);
    }

    // Pagination
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.on('keydown', '.' + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();

    var $nextEl = void 0;
    var $prevEl = void 0;
    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }
    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }
    if ($nextEl) {
      $nextEl.off('keydown', swiper.a11y.onEnterKey);
    }
    if ($prevEl) {
      $prevEl.off('keydown', swiper.a11y.onEnterKey);
    }

    // Pagination
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.off('keydown', '.' + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
    }
  }
};
var A11y = {
  name: 'a11y',
  params: {
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      a11y: {
        liveRegion: (0, _dom.$)('<span class="' + swiper.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
      }
    });
    Object.keys(a11y).forEach(function (methodName) {
      swiper.a11y[methodName] = a11y[methodName].bind(swiper);
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.init();
      swiper.a11y.updateNavigation();
    },
    toEdge: function toEdge() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    fromEdge: function fromEdge() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    paginationUpdate: function paginationUpdate() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updatePagination();
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.destroy();
    }
  }
};

var History = {
  init: function init() {
    var swiper = this;
    if (!swiper.params.history) return;
    if (!_ssrWindow.window.history || !_ssrWindow.window.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }
    var history = swiper.history;
    history.initialized = true;
    history.paths = History.getPathValues();
    if (!history.paths.key && !history.paths.value) return;
    history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
    if (!swiper.params.history.replaceState) {
      _ssrWindow.window.addEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (!swiper.params.history.replaceState) {
      _ssrWindow.window.removeEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  setHistoryPopState: function setHistoryPopState() {
    var swiper = this;
    swiper.history.paths = History.getPathValues();
    swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
  },
  getPathValues: function getPathValues() {
    var pathArray = _ssrWindow.window.location.pathname.slice(1).split('/').filter(function (part) {
      return part !== '';
    });
    var total = pathArray.length;
    var key = pathArray[total - 2];
    var value = pathArray[total - 1];
    return { key: key, value: value };
  },
  setHistory: function setHistory(key, index$$1) {
    var swiper = this;
    if (!swiper.history.initialized || !swiper.params.history.enabled) return;
    var slide = swiper.slides.eq(index$$1);
    var value = History.slugify(slide.attr('data-history'));
    if (!_ssrWindow.window.location.pathname.includes(key)) {
      value = key + '/' + value;
    }
    var currentState = _ssrWindow.window.history.state;
    if (currentState && currentState.value === value) {
      return;
    }
    if (swiper.params.history.replaceState) {
      _ssrWindow.window.history.replaceState({ value: value }, null, value);
    } else {
      _ssrWindow.window.history.pushState({ value: value }, null, value);
    }
  },
  slugify: function slugify(text$$1) {
    return text$$1.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  },
  scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
    var swiper = this;
    if (value) {
      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var _slide3 = swiper.slides.eq(i);
        var slideHistory = History.slugify(_slide3.attr('data-history'));
        if (slideHistory === value && !_slide3.hasClass(swiper.params.slideDuplicateClass)) {
          var index$$1 = _slide3.index();
          swiper.slideTo(index$$1, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  }
};

var History$1 = {
  name: 'history',
  params: {
    history: {
      enabled: false,
      replaceState: false,
      key: 'slides'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      history: {
        init: History.init.bind(swiper),
        setHistory: History.setHistory.bind(swiper),
        setHistoryPopState: History.setHistoryPopState.bind(swiper),
        scrollToSlide: History.scrollToSlide.bind(swiper),
        destroy: History.destroy.bind(swiper)
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.history.enabled) {
        swiper.history.init();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.history.enabled) {
        swiper.history.destroy();
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.history.initialized) {
        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
      }
    }
  }
};

var HashNavigation = {
  onHashCange: function onHashCange() {
    var swiper = this;
    var newHash = _ssrWindow.document.location.hash.replace('#', '');
    var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
    if (newHash !== activeSlideHash) {
      swiper.slideTo(swiper.$wrapperEl.children('.' + swiper.params.slideClass + '[data-hash="' + newHash + '"]').index());
    }
  },
  setHash: function setHash() {
    var swiper = this;
    if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
    if (swiper.params.hashNavigation.replaceState && _ssrWindow.window.history && _ssrWindow.window.history.replaceState) {
      _ssrWindow.window.history.replaceState(null, null, '#' + swiper.slides.eq(swiper.activeIndex).attr('data-hash') || '');
    } else {
      var _slide4 = swiper.slides.eq(swiper.activeIndex);
      var hash = _slide4.attr('data-hash') || _slide4.attr('data-history');
      _ssrWindow.document.location.hash = hash || '';
    }
  },
  init: function init() {
    var swiper = this;
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    swiper.hashNavigation.initialized = true;
    var hash = _ssrWindow.document.location.hash.replace('#', '');
    if (hash) {
      var speed = 0;
      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var _slide5 = swiper.slides.eq(i);
        var slideHash = _slide5.attr('data-hash') || _slide5.attr('data-history');
        if (slideHash === hash && !_slide5.hasClass(swiper.params.slideDuplicateClass)) {
          var index$$1 = _slide5.index();
          swiper.slideTo(index$$1, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }
    if (swiper.params.hashNavigation.watchState) {
      (0, _dom.$)(_ssrWindow.window).on('hashchange', swiper.hashNavigation.onHashCange);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.params.hashNavigation.watchState) {
      (0, _dom.$)(_ssrWindow.window).off('hashchange', swiper.hashNavigation.onHashCange);
    }
  }
};
var HashNavigation$1 = {
  name: 'hash-navigation',
  params: {
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      hashNavigation: {
        initialized: false,
        init: HashNavigation.init.bind(swiper),
        destroy: HashNavigation.destroy.bind(swiper),
        setHash: HashNavigation.setHash.bind(swiper),
        onHashCange: HashNavigation.onHashCange.bind(swiper)
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.init();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.destroy();
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.hashNavigation.initialized) {
        swiper.hashNavigation.setHash();
      }
    }
  }
};

/* eslint no-underscore-dangle: "off" */

var Autoplay = {
  run: function run() {
    var swiper = this;
    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    var delay = swiper.params.autoplay.delay;
    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }
    swiper.autoplay.timeout = Utils.nextTick(function () {
      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isBeginning) {
          swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.isEnd) {
        swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        swiper.slideTo(0, swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else {
        swiper.autoplay.stop();
      }
    }, delay);
  },
  start: function start() {
    var swiper = this;
    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    swiper.emit('autoplayStart');
    swiper.autoplay.run();
    return true;
  },
  stop: function stop() {
    var swiper = this;
    if (!swiper.autoplay.running) return false;
    if (typeof swiper.autoplay.timeout === 'undefined') return false;

    if (swiper.autoplay.timeout) {
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = undefined;
    }
    swiper.autoplay.running = false;
    swiper.emit('autoplayStop');
    return true;
  },
  pause: function pause(speed) {
    var swiper = this;
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.paused = true;
    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      swiper.autoplay.run();
    } else {
      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
    }
  }
};

var Autoplay$1 = {
  name: 'autoplay',
  params: {
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      autoplay: {
        running: false,
        paused: false,
        run: Autoplay.run.bind(swiper),
        start: Autoplay.start.bind(swiper),
        stop: Autoplay.stop.bind(swiper),
        pause: Autoplay.pause.bind(swiper),
        onTransitionEnd: function onTransitionEnd(e) {
          if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
          swiper.autoplay.paused = false;
          if (!swiper.autoplay.running) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.run();
          }
        }
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
      }
    },
    beforeTransitionStart: function beforeTransitionStart(speed, internal) {
      var swiper = this;
      if (swiper.autoplay.running) {
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.pause(speed);
        } else {
          swiper.autoplay.stop();
        }
      }
    },
    sliderFirstMove: function sliderFirstMove() {
      var swiper = this;
      if (swiper.autoplay.running) {
        if (swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.pause();
        }
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    }
  }
};

var Fade = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = swiper.slides.eq(i);
      var offset$$1 = $slideEl[0].swiperSlideOffset;
      var tx = -offset$$1;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      var ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }
      var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      $slideEl.css({
        opacity: slideOpacity
      }).transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl;

    slides.transition(duration);
    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      slides.transitionEnd(function () {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};

var EffectFade = {
  name: 'effect-fade',
  params: {
    fadeEffect: {
      crossFade: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      fadeEffect: {
        setTranslate: Fade.setTranslate.bind(swiper),
        setTransition: Fade.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.classNames.push(swiper.params.containerModifierClass + 'fade');
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTransition(duration);
    }
  }
};

var Cube = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides,
        swiperWidth = swiper.width,
        swiperHeight = swiper.height,
        rtl = swiper.rtlTranslate,
        swiperSize = swiper.size;

    var params = swiper.params.cubeEffect;
    var isHorizontal = swiper.isHorizontal();
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var wrapperRotate = 0;
    var $cubeShadowEl = void 0;
    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = (0, _dom.$)('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }
        $cubeShadowEl.css({ height: swiperWidth + 'px' });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');
        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = (0, _dom.$)('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }
    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideIndex = i;
      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }
      var slideAngle = slideIndex * 90;
      var round = Math.floor(slideAngle / 360);
      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }
      var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      var tx = 0;
      var ty = 0;
      var tz = 0;
      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }
      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      var transform$$1 = 'rotateX(' + (isHorizontal ? 0 : -slideAngle) + 'deg) rotateY(' + (isHorizontal ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }
      $slideEl.transform(transform$$1);
      if (params.slideShadows) {
        // Set shadows
        var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
          shadowBefore = (0, _dom.$)('<div class="swiper-slide-shadow-' + (isHorizontal ? 'left' : 'top') + '"></div>');
          $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
          shadowAfter = (0, _dom.$)('<div class="swiper-slide-shadow-' + (isHorizontal ? 'right' : 'bottom') + '"></div>');
          $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }
    }
    $wrapperEl.css({
      '-webkit-transform-origin': '50% 50% -' + swiperSize / 2 + 'px',
      '-moz-transform-origin': '50% 50% -' + swiperSize / 2 + 'px',
      '-ms-transform-origin': '50% 50% -' + swiperSize / 2 + 'px',
      'transform-origin': '50% 50% -' + swiperSize / 2 + 'px'
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform('translate3d(0px, ' + (swiperWidth / 2 + params.shadowOffset) + 'px, ' + -swiperWidth / 2 + 'px) rotateX(90deg) rotateZ(0deg) scale(' + params.shadowScale + ')');
      } else {
        var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        var scale1 = params.shadowScale;
        var scale2 = params.shadowScale / multiplier;
        var offset$$1 = params.shadowOffset;
        $cubeShadowEl.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (swiperHeight / 2 + offset$$1) + 'px, ' + -swiperHeight / 2 / scale2 + 'px) rotateX(-90deg)');
      }
    }
    var zFactor = Browser.isSafari || Browser.isUiWebView ? -swiperSize / 2 : 0;
    $wrapperEl.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (swiper.isHorizontal() ? 0 : wrapperRotate) + 'deg) rotateY(' + (swiper.isHorizontal() ? -wrapperRotate : 0) + 'deg)');
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var $el = swiper.$el,
        slides = swiper.slides;

    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  }
};

var EffectCube = {
  name: 'effect-cube',
  params: {
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      cubeEffect: {
        setTranslate: Cube.setTranslate.bind(swiper),
        setTransition: Cube.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.classNames.push(swiper.params.containerModifierClass + 'cube');
      swiper.classNames.push(swiper.params.containerModifierClass + '3d');
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        resistanceRatio: 0,
        spaceBetween: 0,
        centeredSlides: false,
        virtualTranslate: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.cubeEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.cubeEffect.setTransition(duration);
    }
  }
};

var Flip = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides,
        rtl = swiper.rtlTranslate;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var progress = $slideEl[0].progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }
      var offset$$1 = $slideEl[0].swiperSlideOffset;
      var rotate = -180 * progress;
      var rotateY = rotate;
      var rotateX = 0;
      var tx = -offset$$1;
      var ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (swiper.params.flipEffect.slideShadows) {
        // Set shadows
        var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
          shadowBefore = (0, _dom.$)('<div class="swiper-slide-shadow-' + (swiper.isHorizontal() ? 'left' : 'top') + '"></div>');
          $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
          shadowAfter = (0, _dom.$)('<div class="swiper-slide-shadow-' + (swiper.isHorizontal() ? 'right' : 'bottom') + '"></div>');
          $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }
      $slideEl.transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        activeIndex = swiper.activeIndex,
        $wrapperEl = swiper.$wrapperEl;

    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      // eslint-disable-next-line
      slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};

var EffectFlip = {
  name: 'effect-flip',
  params: {
    flipEffect: {
      slideShadows: true,
      limitRotation: true
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      flipEffect: {
        setTranslate: Flip.setTranslate.bind(swiper),
        setTransition: Flip.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.classNames.push(swiper.params.containerModifierClass + 'flip');
      swiper.classNames.push(swiper.params.containerModifierClass + '3d');
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.flipEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.flipEffect.setTransition(duration);
    }
  }
};

var Coverflow = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var swiperWidth = swiper.width,
        swiperHeight = swiper.height,
        slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl,
        slidesSizesGrid = swiper.slidesSizesGrid;

    var params = swiper.params.coverflowEffect;
    var isHorizontal = swiper.isHorizontal();
    var transform$$1 = swiper.translate;
    var center = isHorizontal ? -transform$$1 + swiperWidth / 2 : -transform$$1 + swiperHeight / 2;
    var rotate = isHorizontal ? params.rotate : -params.rotate;
    var translate = params.depth;
    // Each slide offset from center
    for (var i = 0, length = slides.length; i < length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideSize = slidesSizesGrid[i];
      var slideOffset = $slideEl[0].swiperSlideOffset;
      var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;

      var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
      // var rotateZ = 0
      var translateZ = -translate * Math.abs(offsetMultiplier);

      var translateY = isHorizontal ? 0 : params.stretch * offsetMultiplier;
      var translateX = isHorizontal ? params.stretch * offsetMultiplier : 0;

      // Fix for ultra small values
      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;

      var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';

      $slideEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
      if (params.slideShadows) {
        // Set shadows
        var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = (0, _dom.$)('<div class="swiper-slide-shadow-' + (isHorizontal ? 'left' : 'top') + '"></div>');
          $slideEl.append($shadowBeforeEl);
        }
        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = (0, _dom.$)('<div class="swiper-slide-shadow-' + (isHorizontal ? 'right' : 'bottom') + '"></div>');
          $slideEl.append($shadowAfterEl);
        }
        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }

    // Set correct perspective for IE10
    if (Support.pointerEvents || Support.prefixedPointerEvents) {
      var ws = $wrapperEl[0].style;
      ws.perspectiveOrigin = center + 'px 50%';
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  }
};

var EffectCoverflow = {
  name: 'effect-coverflow',
  params: {
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      coverflowEffect: {
        setTranslate: Coverflow.setTranslate.bind(swiper),
        setTransition: Coverflow.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') return;

      swiper.classNames.push(swiper.params.containerModifierClass + 'coverflow');
      swiper.classNames.push(swiper.params.containerModifierClass + '3d');

      swiper.params.watchSlidesProgress = true;
      swiper.originalParams.watchSlidesProgress = true;
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') return;
      swiper.coverflowEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') return;
      swiper.coverflowEffect.setTransition(duration);
    }
  }
};

// Swiper Class

var components = [Device$1, Support$1, Browser$1, Resize, Observer$1, Virtual$1, Keyboard$1, Mousewheel$1, Navigation$1, Pagination$1, Scrollbar$1, Parallax$1, Zoom$1, Lazy$1, Controller$1, A11y, History$1, HashNavigation$1, Autoplay$1, EffectFade, EffectCube, EffectFlip, EffectCoverflow];

if (typeof Swiper.use === 'undefined') {
  Swiper.use = Swiper.Class.use;
  Swiper.installModule = Swiper.Class.installModule;
}

Swiper.use(components);

exports.default = Swiper;

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scroll = exports.resize = exports.touchmove = exports.touchend = exports.touchstart = exports.mouseover = exports.mouseout = exports.mouseleave = exports.mouseenter = exports.mouseup = exports.mousemove = exports.mousedown = exports.change = exports.submit = exports.keypress = exports.keydown = exports.keyup = exports.focusout = exports.focusin = exports.focus = exports.blur = exports.click = exports.stop = exports.animate = exports.scrollLeft = exports.scrollTop = exports.scrollTo = exports.empty = exports.add = exports.detach = exports.remove = exports.children = exports.find = exports.closest = exports.parents = exports.parent = exports.siblings = exports.prevAll = exports.prev = exports.nextAll = exports.next = exports.insertAfter = exports.insertBefore = exports.prependTo = exports.prepend = exports.appendTo = exports.append = exports.eq = exports.index = exports.indexOf = exports.is = exports.text = exports.html = exports.map = exports.filter = exports.forEach = exports.each = exports.toArray = exports.css = exports.styles = exports.show = exports.hide = exports.offset = exports.outerHeight = exports.height = exports.outerWidth = exports.width = exports.animationEnd = exports.transitionEnd = exports.trigger = exports.once = exports.off = exports.on = exports.transition = exports.transform = exports.val = exports.dataset = exports.removeData = exports.data = exports.prop = exports.removeAttr = exports.attr = exports.toggleClass = exports.hasClass = exports.removeClass = exports.addClass = exports.$ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ssrWindow = __webpack_require__(144);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Dom7 2.0.6
                                                                                                                                                           * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
                                                                                                                                                           * http://framework7.io/docs/dom.html
                                                                                                                                                           *
                                                                                                                                                           * Copyright 2018, Vladimir Kharlampidi
                                                                                                                                                           * The iDangero.us
                                                                                                                                                           * http://www.idangero.us/
                                                                                                                                                           *
                                                                                                                                                           * Licensed under MIT
                                                                                                                                                           *
                                                                                                                                                           * Released on: May 27, 2018
                                                                                                                                                           */


var Dom7 = function Dom7(arr) {
  _classCallCheck(this, Dom7);

  var self = this;
  // Create array-like object
  for (var i = 0; i < arr.length; i += 1) {
    self[i] = arr[i];
  }
  self.length = arr.length;
  // Return collection with methods
  return this;
};

function $(selector, context) {
  var arr = [];
  var i = 0;
  if (selector && !context) {
    if (selector instanceof Dom7) {
      return selector;
    }
  }
  if (selector) {
    // String
    if (typeof selector === 'string') {
      var els = void 0;
      var tempParent = void 0;
      var _html = selector.trim();
      if (_html.indexOf('<') >= 0 && _html.indexOf('>') >= 0) {
        var toCreate = 'div';
        if (_html.indexOf('<li') === 0) toCreate = 'ul';
        if (_html.indexOf('<tr') === 0) toCreate = 'tbody';
        if (_html.indexOf('<td') === 0 || _html.indexOf('<th') === 0) toCreate = 'tr';
        if (_html.indexOf('<tbody') === 0) toCreate = 'table';
        if (_html.indexOf('<option') === 0) toCreate = 'select';
        tempParent = _ssrWindow.document.createElement(toCreate);
        tempParent.innerHTML = _html;
        for (i = 0; i < tempParent.childNodes.length; i += 1) {
          arr.push(tempParent.childNodes[i]);
        }
      } else {
        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
          // Pure ID selector
          els = [_ssrWindow.document.getElementById(selector.trim().split('#')[1])];
        } else {
          // Other selectors
          els = (context || _ssrWindow.document).querySelectorAll(selector.trim());
        }
        for (i = 0; i < els.length; i += 1) {
          if (els[i]) arr.push(els[i]);
        }
      }
    } else if (selector.nodeType || selector === _ssrWindow.window || selector === _ssrWindow.document) {
      // Node/element
      arr.push(selector);
    } else if (selector.length > 0 && selector[0].nodeType) {
      // Array of elements or instance of Dom
      for (i = 0; i < selector.length; i += 1) {
        arr.push(selector[i]);
      }
    }
  }
  return new Dom7(arr);
}

$.fn = Dom7.prototype;
$.Class = Dom7;
$.Dom7 = Dom7;

function unique(arr) {
  var uniqueArray = [];
  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }
  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, function (match, group1) {
    return group1.toUpperCase();
  });
}

function requestAnimationFrame(callback) {
  if (_ssrWindow.window.requestAnimationFrame) return _ssrWindow.window.requestAnimationFrame(callback);else if (_ssrWindow.window.webkitRequestAnimationFrame) return _ssrWindow.window.webkitRequestAnimationFrame(callback);
  return _ssrWindow.window.setTimeout(callback, 1000 / 60);
}
function cancelAnimationFrame(id) {
  if (_ssrWindow.window.cancelAnimationFrame) return _ssrWindow.window.cancelAnimationFrame(id);else if (_ssrWindow.window.webkitCancelAnimationFrame) return _ssrWindow.window.webkitCancelAnimationFrame(id);
  return _ssrWindow.window.clearTimeout(id);
}

// Classes and attributes
function addClass(className) {
  if (typeof className === 'undefined') {
    return this;
  }
  var classes = className.split(' ');
  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this[j].classList !== 'undefined') this[j].classList.add(classes[i]);
    }
  }
  return this;
}
function removeClass(className) {
  var classes = className.split(' ');
  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this[j].classList !== 'undefined') this[j].classList.remove(classes[i]);
    }
  }
  return this;
}
function hasClass(className) {
  if (!this[0]) return false;
  return this[0].classList.contains(className);
}
function toggleClass(className) {
  var classes = className.split(' ');
  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this[j].classList !== 'undefined') this[j].classList.toggle(classes[i]);
    }
  }
  return this;
}
function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  }

  // Set attrs
  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      // eslint-disable-next-line
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }
  return this;
}
// eslint-disable-next-line
function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }
  return this;
}
// eslint-disable-next-line
function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (var i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        // eslint-disable-next-line
        for (var propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }
    return this;
  }
}
function data(key, value) {
  var el = void 0;
  if (typeof value === 'undefined') {
    el = this[0];
    // Get value
    if (el) {
      if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
        return el.dom7ElementDataStorage[key];
      }

      var dataKey = el.getAttribute('data-' + key);
      if (dataKey) {
        return dataKey;
      }
      return undefined;
    }
    return undefined;
  }

  // Set value
  for (var i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }
  return this;
}
function removeData(key) {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}
function dataset() {
  var el = this[0];
  if (!el) return undefined;
  var dataset = {}; // eslint-disable-line
  if (el.dataset) {
    // eslint-disable-next-line
    for (var dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (var i = 0; i < el.attributes.length; i += 1) {
      // eslint-disable-next-line
      var _attr = el.attributes[i];
      if (_attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
      }
    }
  }
  // eslint-disable-next-line
  for (var key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }
  return dataset;
}
function val(value) {
  var dom = this;
  if (typeof value === 'undefined') {
    if (dom[0]) {
      if (dom[0].multiple && dom[0].nodeName.toLowerCase() === 'select') {
        var values = [];
        for (var i = 0; i < dom[0].selectedOptions.length; i += 1) {
          values.push(dom[0].selectedOptions[i].value);
        }
        return values;
      }
      return dom[0].value;
    }
    return undefined;
  }

  for (var _i = 0; _i < dom.length; _i += 1) {
    var el = dom[_i];
    if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
      for (var j = 0; j < el.options.length; j += 1) {
        el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
      }
    } else {
      el.value = value;
    }
  }
  return dom;
}
// Transforms
// eslint-disable-next-line
function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    var elStyle = this[i].style;
    elStyle.webkitTransform = transform;
    elStyle.transform = transform;
  }
  return this;
}
function transition(duration) {
  if (typeof duration !== 'string') {
    duration = duration + 'ms'; // eslint-disable-line
  }
  for (var i = 0; i < this.length; i += 1) {
    var elStyle = this[i].style;
    elStyle.webkitTransitionDuration = duration;
    elStyle.transitionDuration = duration;
  }
  return this;
}
// Events
function on() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];

    targetSelector = undefined;
  }
  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line
      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }
  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    listener.apply(this, eventData);
  }
  var events = eventType.split(' ');
  var j = void 0;
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];
        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }
  return this;
}
function off() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];

    targetSelector = undefined;
  }
  if (!capture) capture = false;

  var events = eventType.split(' ');
  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];
    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;
      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }
      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];
          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }
  return this;
}
function once() {
  var dom = this;

  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var eventName = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventName = args[0];
    listener = args[1];
    capture = args[2];

    targetSelector = undefined;
  }
  function proxy() {
    for (var _len4 = arguments.length, eventArgs = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      eventArgs[_key4] = arguments[_key4];
    }

    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, proxy, capture);
  }
  return dom.on(eventName, targetSelector, proxy, capture);
}
function trigger() {
  for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var events = args[0].split(' ');
  var eventData = args[1];
  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];
    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var evt = void 0;
      try {
        evt = new _ssrWindow.window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
      } catch (e) {
        evt = _ssrWindow.document.createEvent('Event');
        evt.initEvent(event, true, true);
        evt.detail = eventData;
      }
      // eslint-disable-next-line
      el.dom7EventData = args.filter(function (data, dataIndex) {
        return dataIndex > 0;
      });
      el.dispatchEvent(evt);
      el.dom7EventData = [];
      delete el.dom7EventData;
    }
  }
  return this;
}
function transitionEnd(callback) {
  var events = ['webkitTransitionEnd', 'transitionend'];
  var dom = this;
  var i = void 0;
  function fireCallBack(e) {
    /* jshint validthis:true */
    if (e.target !== this) return;
    callback.call(this, e);
    for (i = 0; i < events.length; i += 1) {
      dom.off(events[i], fireCallBack);
    }
  }
  if (callback) {
    for (i = 0; i < events.length; i += 1) {
      dom.on(events[i], fireCallBack);
    }
  }
  return this;
}
function animationEnd(callback) {
  var events = ['webkitAnimationEnd', 'animationend'];
  var dom = this;
  var i = void 0;
  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    for (i = 0; i < events.length; i += 1) {
      dom.off(events[i], fireCallBack);
    }
  }
  if (callback) {
    for (i = 0; i < events.length; i += 1) {
      dom.on(events[i], fireCallBack);
    }
  }
  return this;
}
// Sizing/Styles
function width() {
  if (this[0] === _ssrWindow.window) {
    return _ssrWindow.window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}
function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      var _styles = this.styles();
      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function height() {
  if (this[0] === _ssrWindow.window) {
    return _ssrWindow.window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}
function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      var _styles2 = this.styles();
      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function offset() {
  if (this.length > 0) {
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = _ssrWindow.document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var _scrollTop = el === _ssrWindow.window ? _ssrWindow.window.scrollY : el.scrollTop;
    var _scrollLeft = el === _ssrWindow.window ? _ssrWindow.window.scrollX : el.scrollLeft;
    return {
      top: box.top + _scrollTop - clientTop,
      left: box.left + _scrollLeft - clientLeft
    };
  }

  return null;
}
function hide() {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }
  return this;
}
function show() {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (el.style.display === 'none') {
      el.style.display = '';
    }
    if (_ssrWindow.window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }
  return this;
}
function styles() {
  if (this[0]) return _ssrWindow.window.getComputedStyle(this[0], null);
  return {};
}
function css(props, value) {
  var i = void 0;
  if (arguments.length === 1) {
    if (typeof props === 'string') {
      if (this[0]) return _ssrWindow.window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      for (i = 0; i < this.length; i += 1) {
        // eslint-disable-next-line
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }
      return this;
    }
  }
  if (arguments.length === 2 && typeof props === 'string') {
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }
    return this;
  }
  return this;
}

// Dom manipulation
function toArray() {
  var arr = [];
  for (var i = 0; i < this.length; i += 1) {
    arr.push(this[i]);
  }
  return arr;
}
// Iterate over the collection passing elements to `callback`
function each(callback) {
  // Don't bother continuing without a callback
  if (!callback) return this;
  // Iterate over the current collection
  for (var i = 0; i < this.length; i += 1) {
    // If the callback returns false
    if (callback.call(this[i], i, this[i]) === false) {
      // End the loop early
      return this;
    }
  }
  // Return `this` to allow chained DOM operations
  return this;
}
function forEach(callback) {
  // Don't bother continuing without a callback
  if (!callback) return this;
  // Iterate over the current collection
  for (var i = 0; i < this.length; i += 1) {
    // If the callback returns false
    if (callback.call(this[i], this[i], i) === false) {
      // End the loop early
      return this;
    }
  }
  // Return `this` to allow chained DOM operations
  return this;
}
function filter(callback) {
  var matchedItems = [];
  var dom = this;
  for (var i = 0; i < dom.length; i += 1) {
    if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
  }
  return new Dom7(matchedItems);
}
function map(callback) {
  var modifiedItems = [];
  var dom = this;
  for (var i = 0; i < dom.length; i += 1) {
    modifiedItems.push(callback.call(dom[i], i, dom[i]));
  }
  return new Dom7(modifiedItems);
}
// eslint-disable-next-line
function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : undefined;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }
  return this;
}
// eslint-disable-next-line
function text(text) {
  if (typeof text === 'undefined') {
    if (this[0]) {
      return this[0].textContent.trim();
    }
    return null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }
  return this;
}
function is(selector) {
  var el = this[0];
  var compareWith = void 0;
  var i = void 0;
  if (!el || typeof selector === 'undefined') return false;
  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);else if (el.msMatchesSelector) return el.msMatchesSelector(selector);

    compareWith = $(selector);
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }
    return false;
  } else if (selector === _ssrWindow.document) return el === _ssrWindow.document;else if (selector === _ssrWindow.window) return el === _ssrWindow.window;

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }
    return false;
  }
  return false;
}
function indexOf(el) {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i] === el) return i;
  }
  return -1;
}
function index() {
  var child = this[0];
  var i = void 0;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
// eslint-disable-next-line
function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;
  var returnIndex = void 0;
  if (index > length - 1) {
    return new Dom7([]);
  }
  if (index < 0) {
    returnIndex = length + index;
    if (returnIndex < 0) return new Dom7([]);
    return new Dom7([this[returnIndex]]);
  }
  return new Dom7([this[index]]);
}
function append() {
  var newChild = void 0;

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = arguments.length <= k ? undefined : arguments[k];
    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = _ssrWindow.document.createElement('div');
        tempDiv.innerHTML = newChild;
        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}
// eslint-disable-next-line
function appendTo(parent) {
  $(parent).append(this);
  return this;
}
function prepend(newChild) {
  var i = void 0;
  var j = void 0;
  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = _ssrWindow.document.createElement('div');
      tempDiv.innerHTML = newChild;
      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }
  return this;
}
// eslint-disable-next-line
function prependTo(parent) {
  $(parent).prepend(this);
  return this;
}
function insertBefore(selector) {
  var before = $(selector);
  for (var i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (var j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}
function insertAfter(selector) {
  var after = $(selector);
  for (var i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (var j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}
function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return new Dom7([this[0].nextElementSibling]);
      }
      return new Dom7([]);
    }

    if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
    return new Dom7([]);
  }
  return new Dom7([]);
}
function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return new Dom7([]);
  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);
    el = _next;
  }
  return new Dom7(nextEls);
}
function prev(selector) {
  if (this.length > 0) {
    var el = this[0];
    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return new Dom7([el.previousElementSibling]);
      }
      return new Dom7([]);
    }

    if (el.previousElementSibling) return new Dom7([el.previousElementSibling]);
    return new Dom7([]);
  }
  return new Dom7([]);
}
function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return new Dom7([]);
  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);
    el = _prev;
  }
  return new Dom7(prevEls);
}
function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
  var parents = []; // eslint-disable-line
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }
  return $(unique(parents));
}
function parents(selector) {
  var parents = []; // eslint-disable-line
  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line
    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }
      _parent = _parent.parentNode;
    }
  }
  return $(unique(parents));
}
function closest(selector) {
  var closest = this; // eslint-disable-line
  if (typeof selector === 'undefined') {
    return new Dom7([]);
  }
  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }
  return closest;
}
function find(selector) {
  var foundElements = [];
  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);
    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }
  return new Dom7(foundElements);
}
function children(selector) {
  var children = []; // eslint-disable-line
  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].childNodes;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector) {
        if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
      } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }
  return new Dom7(unique(children));
}
function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }
  return this;
}
function detach() {
  return this.remove();
}
function add() {
  var dom = this;
  var i = void 0;
  var j = void 0;

  for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  for (i = 0; i < args.length; i += 1) {
    var toAdd = $(args[i]);
    for (j = 0; j < toAdd.length; j += 1) {
      dom[dom.length] = toAdd[j];
      dom.length += 1;
    }
  }
  return dom;
}
function empty() {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (el.nodeType === 1) {
      for (var j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }
      el.textContent = '';
    }
  }
  return this;
}

function scrollTo() {
  for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }

  var left = args[0],
      top = args[1],
      duration = args[2],
      easing = args[3],
      callback = args[4];

  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    left = args[0];
    top = args[1];
    duration = args[2];
    callback = args[3];
    easing = args[4];
  }
  if (typeof easing === 'undefined') easing = 'swing';

  return this.each(function animate() {
    var el = this;
    var currentTop = void 0;
    var currentLeft = void 0;
    var maxTop = void 0;
    var maxLeft = void 0;
    var newTop = void 0;
    var newLeft = void 0;
    var scrollTop = void 0; // eslint-disable-line
    var scrollLeft = void 0; // eslint-disable-line
    var animateTop = top > 0 || top === 0;
    var animateLeft = left > 0 || left === 0;
    if (typeof easing === 'undefined') {
      easing = 'swing';
    }
    if (animateTop) {
      currentTop = el.scrollTop;
      if (!duration) {
        el.scrollTop = top;
      }
    }
    if (animateLeft) {
      currentLeft = el.scrollLeft;
      if (!duration) {
        el.scrollLeft = left;
      }
    }
    if (!duration) return;
    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }
    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }
    var startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;
    function render() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getTime();

      if (startTime === null) {
        startTime = time;
      }
      var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
      var done = void 0;
      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }
      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }
      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }
      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }
      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      requestAnimationFrame(render);
    }
    requestAnimationFrame(render);
  });
}
// scrollTop(top, duration, easing, callback) {
function scrollTop() {
  for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    args[_key8] = arguments[_key8];
  }

  var top = args[0],
      duration = args[1],
      easing = args[2],
      callback = args[3];

  if (args.length === 3 && typeof easing === 'function') {
    top = args[0];
    duration = args[1];
    callback = args[2];
    easing = args[3];
  }
  var dom = this;
  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }
  return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft() {
  for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  var left = args[0],
      duration = args[1],
      easing = args[2],
      callback = args[3];

  if (args.length === 3 && typeof easing === 'function') {
    left = args[0];
    duration = args[1];
    callback = args[2];
    easing = args[3];
  }
  var dom = this;
  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }
  return dom.scrollTo(left, undefined, duration, easing, callback);
}

function animate(initialProps, initialParams) {
  var els = this;
  var a = {
    props: _extends({}, initialProps),
    params: _extends({
      duration: 300,
      easing: 'swing' // or 'linear'
      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */
    }, initialParams),

    elements: els,
    animating: false,
    que: [],

    easingProgress: function easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - Math.cos(progress * Math.PI) / 2;
      }
      if (typeof easing === 'function') {
        return easing(progress);
      }
      return progress;
    },
    stop: function stop() {
      if (a.frameId) {
        cancelAnimationFrame(a.frameId);
      }
      a.animating = false;
      a.elements.each(function (index, el) {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },
    done: function done(complete) {
      a.animating = false;
      a.elements.each(function (index, el) {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);
      if (a.que.length > 0) {
        var que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },
    animate: function animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }
      var elements = [];

      // Define & Cache Initials & Units
      a.elements.each(function (index, el) {
        var initialFullValue = void 0;
        var initialValue = void 0;
        var unit = void 0;
        var finalValue = void 0;
        var finalFullValue = void 0;

        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;

        elements[index] = {
          container: el
        };
        Object.keys(props).forEach(function (prop) {
          initialFullValue = _ssrWindow.window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue: initialFullValue,
            initialValue: initialValue,
            unit: unit,
            finalValue: finalValue,
            finalFullValue: finalFullValue,
            currentValue: initialValue
          };
        });
      });

      var startTime = null;
      var time = void 0;
      var elementsDone = 0;
      var propsDone = 0;
      var done = void 0;
      var began = false;

      a.animating = true;

      function render() {
        time = new Date().getTime();
        var progress = void 0;
        var easeProgress = void 0;
        // let el;
        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }
        if (startTime === null) {
          startTime = time;
        }
        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
        }

        elements.forEach(function (element) {
          var el = element;
          if (done || el.done) return;
          Object.keys(props).forEach(function (prop) {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            var _el$prop = el[prop],
                initialValue = _el$prop.initialValue,
                finalValue = _el$prop.finalValue,
                unit = _el$prop.unit;

            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
            var currentValue = el[prop].currentValue;

            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;
              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }
              if (elementsDone === elements.length) {
                done = true;
              }
            }
            if (done) {
              a.done(params.complete);
              return;
            }
            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return;
        // Then call
        a.frameId = requestAnimationFrame(render);
      }
      a.frameId = requestAnimationFrame(render);
      return a;
    }
  };

  if (a.elements.length === 0) {
    return els;
  }

  var animateInstance = void 0;
  for (var i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }
  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  var els = this;
  for (var i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

var noTrigger = 'resize scroll'.split(' ');
function eventShortcut(name) {
  for (var _len10 = arguments.length, args = Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
    args[_key10 - 1] = arguments[_key10];
  }

  if (typeof args[0] === 'undefined') {
    for (var i = 0; i < this.length; i += 1) {
      if (noTrigger.indexOf(name) < 0) {
        if (name in this[i]) this[i][name]();else {
          $(this[i]).trigger(name);
        }
      }
    }
    return this;
  }
  return this.on.apply(this, [name].concat(args));
}

function click() {
  for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    args[_key11] = arguments[_key11];
  }

  return eventShortcut.bind(this).apply(undefined, ['click'].concat(args));
}
function blur() {
  for (var _len12 = arguments.length, args = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    args[_key12] = arguments[_key12];
  }

  return eventShortcut.bind(this).apply(undefined, ['blur'].concat(args));
}
function focus() {
  for (var _len13 = arguments.length, args = Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
    args[_key13] = arguments[_key13];
  }

  return eventShortcut.bind(this).apply(undefined, ['focus'].concat(args));
}
function focusin() {
  for (var _len14 = arguments.length, args = Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
    args[_key14] = arguments[_key14];
  }

  return eventShortcut.bind(this).apply(undefined, ['focusin'].concat(args));
}
function focusout() {
  for (var _len15 = arguments.length, args = Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
    args[_key15] = arguments[_key15];
  }

  return eventShortcut.bind(this).apply(undefined, ['focusout'].concat(args));
}
function keyup() {
  for (var _len16 = arguments.length, args = Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
    args[_key16] = arguments[_key16];
  }

  return eventShortcut.bind(this).apply(undefined, ['keyup'].concat(args));
}
function keydown() {
  for (var _len17 = arguments.length, args = Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
    args[_key17] = arguments[_key17];
  }

  return eventShortcut.bind(this).apply(undefined, ['keydown'].concat(args));
}
function keypress() {
  for (var _len18 = arguments.length, args = Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
    args[_key18] = arguments[_key18];
  }

  return eventShortcut.bind(this).apply(undefined, ['keypress'].concat(args));
}
function submit() {
  for (var _len19 = arguments.length, args = Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
    args[_key19] = arguments[_key19];
  }

  return eventShortcut.bind(this).apply(undefined, ['submit'].concat(args));
}
function change() {
  for (var _len20 = arguments.length, args = Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
    args[_key20] = arguments[_key20];
  }

  return eventShortcut.bind(this).apply(undefined, ['change'].concat(args));
}
function mousedown() {
  for (var _len21 = arguments.length, args = Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
    args[_key21] = arguments[_key21];
  }

  return eventShortcut.bind(this).apply(undefined, ['mousedown'].concat(args));
}
function mousemove() {
  for (var _len22 = arguments.length, args = Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
    args[_key22] = arguments[_key22];
  }

  return eventShortcut.bind(this).apply(undefined, ['mousemove'].concat(args));
}
function mouseup() {
  for (var _len23 = arguments.length, args = Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
    args[_key23] = arguments[_key23];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseup'].concat(args));
}
function mouseenter() {
  for (var _len24 = arguments.length, args = Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
    args[_key24] = arguments[_key24];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseenter'].concat(args));
}
function mouseleave() {
  for (var _len25 = arguments.length, args = Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
    args[_key25] = arguments[_key25];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseleave'].concat(args));
}
function mouseout() {
  for (var _len26 = arguments.length, args = Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
    args[_key26] = arguments[_key26];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseout'].concat(args));
}
function mouseover() {
  for (var _len27 = arguments.length, args = Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
    args[_key27] = arguments[_key27];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseover'].concat(args));
}
function touchstart() {
  for (var _len28 = arguments.length, args = Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
    args[_key28] = arguments[_key28];
  }

  return eventShortcut.bind(this).apply(undefined, ['touchstart'].concat(args));
}
function touchend() {
  for (var _len29 = arguments.length, args = Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
    args[_key29] = arguments[_key29];
  }

  return eventShortcut.bind(this).apply(undefined, ['touchend'].concat(args));
}
function touchmove() {
  for (var _len30 = arguments.length, args = Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
    args[_key30] = arguments[_key30];
  }

  return eventShortcut.bind(this).apply(undefined, ['touchmove'].concat(args));
}
function resize() {
  for (var _len31 = arguments.length, args = Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
    args[_key31] = arguments[_key31];
  }

  return eventShortcut.bind(this).apply(undefined, ['resize'].concat(args));
}
function scroll() {
  for (var _len32 = arguments.length, args = Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {
    args[_key32] = arguments[_key32];
  }

  return eventShortcut.bind(this).apply(undefined, ['scroll'].concat(args));
}

exports.$ = $;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.hasClass = hasClass;
exports.toggleClass = toggleClass;
exports.attr = attr;
exports.removeAttr = removeAttr;
exports.prop = prop;
exports.data = data;
exports.removeData = removeData;
exports.dataset = dataset;
exports.val = val;
exports.transform = transform;
exports.transition = transition;
exports.on = on;
exports.off = off;
exports.once = once;
exports.trigger = trigger;
exports.transitionEnd = transitionEnd;
exports.animationEnd = animationEnd;
exports.width = width;
exports.outerWidth = outerWidth;
exports.height = height;
exports.outerHeight = outerHeight;
exports.offset = offset;
exports.hide = hide;
exports.show = show;
exports.styles = styles;
exports.css = css;
exports.toArray = toArray;
exports.each = each;
exports.forEach = forEach;
exports.filter = filter;
exports.map = map;
exports.html = html;
exports.text = text;
exports.is = is;
exports.indexOf = indexOf;
exports.index = index;
exports.eq = eq;
exports.append = append;
exports.appendTo = appendTo;
exports.prepend = prepend;
exports.prependTo = prependTo;
exports.insertBefore = insertBefore;
exports.insertAfter = insertAfter;
exports.next = next;
exports.nextAll = nextAll;
exports.prev = prev;
exports.prevAll = prevAll;
exports.siblings = siblings;
exports.parent = parent;
exports.parents = parents;
exports.closest = closest;
exports.find = find;
exports.children = children;
exports.remove = remove;
exports.detach = detach;
exports.add = add;
exports.empty = empty;
exports.scrollTo = scrollTo;
exports.scrollTop = scrollTop;
exports.scrollLeft = scrollLeft;
exports.animate = animate;
exports.stop = stop;
exports.click = click;
exports.blur = blur;
exports.focus = focus;
exports.focusin = focusin;
exports.focusout = focusout;
exports.keyup = keyup;
exports.keydown = keydown;
exports.keypress = keypress;
exports.submit = submit;
exports.change = change;
exports.mousedown = mousedown;
exports.mousemove = mousemove;
exports.mouseup = mouseup;
exports.mouseenter = mouseenter;
exports.mouseleave = mouseleave;
exports.mouseout = mouseout;
exports.mouseover = mouseover;
exports.touchstart = touchstart;
exports.touchend = touchend;
exports.touchmove = touchmove;
exports.resize = resize;
exports.scroll = scroll;

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

var _componentsv = __webpack_require__(142);

var _consts = __webpack_require__(2);

var _purchase = __webpack_require__(50);

var _purchase2 = _interopRequireDefault(_purchase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var api = {
	checklogin: _consts.ONECLOUD_API_HOST + '/user/checklogin',
	getconfig: _consts.ONECLOUD_API_HOST + '/opensale/getconfig',
	commit: _consts.ONECLOUD_API_HOST + '/opensale/commit'
};

var STATUS_NOTBEGIN = 0; // 活动未开始
var STATUS_BUYING = 1; // 抢购中
var STATUS_END = 2; // 抢购结束
var GET_CONFIG_LOOP_TIMES = 0;

/* 开放售卖原价【CN、HK版】、满减活动【CN版】*/

var OpensalePurchaseV2 = function (_Component) {
	_inherits(OpensalePurchaseV2, _Component);

	function OpensalePurchaseV2(props) {
		_classCallCheck(this, OpensalePurchaseV2);

		var _this = _possibleConstructorReturn(this, (OpensalePurchaseV2.__proto__ || Object.getPrototypeOf(OpensalePurchaseV2)).call(this, props));

		_this.getConfig = function () {
			if ((0, _utils.getCookie)('lang') !== 'cn') return;

			var doneCb = function doneCb(res) {
				var success = function success(data) {

					//test
					//data = {mj_status: 1, seckill_status:0,seckill_stime:'2018-05-10 10:00:00',seckill_end_time:'2018-05-10 10:44:36'}

					var mj_status = data.mj_status;

					_this.setState({
						hasDiscount: mj_status === 1 ? true : false
					});
				};
				_this.responeHandler({ res: res, success: success });
			};
			var failCb = function failCb(res) {
				if (GET_CONFIG_LOOP_TIMES == 1) {
					_this.showPopHandler((0, _purchase2.default)('notifi_yongdu'));
				} else {
					GET_CONFIG_LOOP_TIMES++;
					setTimeout(_this.getConfig, 2000);
				}
			};
			(0, _utils.postPromise)(api.getconfig).done(doneCb).fail(failCb);
		};

		_this.showPopHandler = function (msg, url, btn) {
			_this.setState({
				popShow: true,
				popMsg: msg,
				popJump: url || '',
				popBtn: btn || (0, _purchase2.default)('ok')
			});
		};

		_this.commonFailCb = function () {
			_this.showPopHandler((0, _purchase2.default)('notifi_yongdu'));
		};

		_this.closeLoginRemind = function () {
			_this.setState({
				loginRemindShow: false
			});
		};

		_this.switchColor = function (color) {
			_this.setState({ color: color });
		};

		_this.popClose = function () {
			_this.setState({ popShow: false });
		};

		_this.updateDiskData = function (data) {
			_this.setState(data);
		};

		_this.submit = function (e) {
			var _postData;

			e.preventDefault();
			_this.setState({ loadingTime: true });
			var doneCb = function doneCb(res) {
				var resCode = res.iRet;
				if (resCode == 0) {
					var jumpUrl = (0, _utils.createUrl)('html/order', { type: 'opensale', orderid: res.data.order_id });
					window.setTimeout(function () {
						window.location.href = jumpUrl;
					}, 0);
				} else {
					_this.setState({ loadingTime: false });
					_this.commonErrorHandler(resCode, res.sMsg);
				}
			};
			var diskChecked = _this.state.diskChecked;

			var postData = (_postData = {}, _defineProperty(_postData, _this.state.color + '_num', 1), _defineProperty(_postData, 'hd_num', diskChecked ? 1 : 0), _defineProperty(_postData, 'sub_type', _this.state.hasDiscount ? 1 : 0), _postData);

			var failCb = function failCb() {
				_this.setState({ loadingTime: false });
				_this.commonFailCb();
			};
			(0, _utils.postPromise)(api.commit, postData).done(doneCb).fail(_this.failCb);
			(0, _utils.stat)('purchase', 'opensale');
		};

		_this.config = {
			price: 599,
			discount: 119,
			diskPrice: 585,
			diskCount: 50
		};
		_this.lang = (0, _utils.getLang)();
		_this.state = {
			hasLogin: false,
			loginRemindShow: true,
			hasDiscount: false,

			color: 'black',
			colorConfig: [{ color: 'black', text: (0, _purchase2.default)('color_black'), has: 1 }, { color: 'blue', text: (0, _purchase2.default)('color_blue'), has: 1 }, { color: 'orange', text: (0, _purchase2.default)('color_orange'), has: _this.lang === 'cn' ? 1 : 0 }],
			popShow: false,
			popMsg: '',
			popJump: '',
			popBtn: (0, _purchase2.default)('ok'),
			loadingTime: false,
			diskChecked: false
		};
		return _this;
	}

	_createClass(OpensalePurchaseV2, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.setHtmlBg();
			this.getConfig();
			this.checkLogin();
			this.swipeColorPic();
		}
	}, {
		key: 'setHtmlBg',
		value: function setHtmlBg() {
			$('html').addClass('whitebg');
		}
	}, {
		key: 'checkLogin',
		value: function checkLogin() {
			var _this2 = this;

			if (window.siteHasLogined) {
				this.setState({
					hasLogin: true
				});
			} else {
				var doneCb = function doneCb(res) {
					+res.iRet === 0 && _this2.setState({ hasLogin: true });
				};
				(0, _utils.postPromise)(api.checklogin).done(doneCb);
			}
		}
	}, {
		key: 'commonErrorHandler',
		value: function commonErrorHandler(resCode, sMsg) {
			var statusList = {
				'30004': (0, _purchase2.default)('rtncode_30004'),
				'30006': (0, _purchase2.default)('rtncode_30006'),
				'30008': (0, _purchase2.default)('rtncode_30008'),
				'30009': (0, _purchase2.default)('rtncode_30009'),
				'40000': (0, _purchase2.default)('rtncode_40000'),
				'30003': (0, _purchase2.default)('rtncode_30003'),
				'30106': (0, _purchase2.default)('rtncode_30106'),
				'-2': (0, _purchase2.default)('rtncode__2'),
				'-2004': (0, _purchase2.default)('rtncode__2004'),
				'-2000': (0, _purchase2.default)('rtncode__2000'),
				'-1003': (0, _purchase2.default)('rtncode__1003'),
				'-5': (0, _purchase2.default)('rtncode__5'),

				"41006": (0, _purchase2.default)('rtncode_41006'),
				"41007": (0, _purchase2.default)('rtncode_41007_2'),
				"41009": (0, _purchase2.default)('rtncode_41009'),
				"41012": (0, _purchase2.default)('rtncode_41012'),
				"41013": (0, _purchase2.default)('rtncode_41013'),
				"41014": (0, _purchase2.default)('rtncode_41014'),
				'41016': (0, _purchase2.default)('rtncode_41016'),
				'41018': (0, _purchase2.default)('rtncode_41018'),
				"41022": (0, _purchase2.default)('rtncode_41022')
			};
			var sellOutList = {
				'30005': (0, _purchase2.default)('rtncode_30005'),
				'30016': (0, _purchase2.default)('rtncode_30016'),
				'30025': (0, _purchase2.default)('rtncode_30025'),
				'30026': (0, _purchase2.default)('rtncode_30026')
			};

			if (resCode == -501) {
				var url = window.location.href;
				(0, _componentsv.jumpToLogin)();
			} else if (resCode == 30007) {
				this.showPopHandler((0, _purchase2.default)('rtncode_30007'), (0, _utils.createUrl)('html/usercenter'), (0, _purchase2.default)('check_order'));
			} else if (resCode == 30303) {
				this.showPopHandler((0, _purchase2.default)('rtncode_30303'));
				this.getConfig();
			} else if (sellOutList[resCode]) {
				if (resCode == 30005) {
					this.showPopHandler(sellOutList[resCode]);
				} else {
					this.showPopHandler(sellOutList[resCode], '', (0, _purchase2.default)('tips_continue'));
					//this.getColorList()
				}
			} else if (statusList[resCode]) {
				this.showPopHandler(statusList[resCode]);
			} else if (resCode !== 0) {
				// CN
				this.showPopHandler(sMsg);
			}
			// if (callback&&typeof callback=="function"){
			// 	callback(resCode,res)
			// }
		}
	}, {
		key: 'responeHandler',
		value: function responeHandler(_ref) {
			var res = _ref.res,
			    success = _ref.success;

			var resCode = res.iRet;
			this.commonErrorHandler(resCode, res.sMsg);

			if (resCode == 0) {
				if (res.data) {
					success(res.data);
				} else {
					success();
				}
			}
		}
	}, {
		key: 'swipeColorPic',
		value: function swipeColorPic() {
			var galleryTop = new Swiper('.gallery-top', {
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				}
			});
			var galleryThumbs = new Swiper('.gallery-thumbs', {
				centeredSlides: true,
				slidesPerView: 5,
				touchRatio: 0.2,
				slideToClickedSlide: true
			});
			galleryTop.controller.control = galleryThumbs;
			galleryThumbs.controller.control = galleryTop;
		}
	}, {
		key: 'render',
		value: function render() {
			var _state = this.state,
			    hasLogin = _state.hasLogin,
			    loginRemindShow = _state.loginRemindShow,
			    color = _state.color,
			    status = _state.status,
			    popShow = _state.popShow,
			    popBtn = _state.popBtn,
			    popMsg = _state.popMsg,
			    popJump = _state.popJump,
			    currTime = _state.currTime,
			    buyTime = _state.buyTime,
			    loadingTime = _state.loadingTime,
			    hasDiscount = _state.hasDiscount,
			    diskChecked = _state.diskChecked;


			var loginRemindDom = _react2.default.createElement(
				'div',
				{ className: 'np-buylogin' },
				_react2.default.createElement(
					'div',
					{ className: 'np-main' },
					_react2.default.createElement(
						'p',
						null,
						(0, _purchase2.default)('login_remind'),
						_react2.default.createElement(
							'a',
							{ href: 'javascript:;', onClick: _componentsv.jumpToLogin },
							(0, _purchase2.default)('login_now')
						),
						_react2.default.createElement('i', { className: 'i-close', title: (0, _purchase2.default)('close'), onClick: this.closeLoginRemind })
					)
				)
			);

			var _config = this.config,
			    price = _config.price,
			    discount = _config.discount,
			    diskPrice = _config.diskPrice,
			    diskCount = _config.diskCount;

			var onecloudMony = hasDiscount ? price - discount : price;
			var diskMoney = diskChecked ? diskPrice - diskCount : 0;
			var totalPrice = onecloudMony + diskMoney;

			return _react2.default.createElement(
				'div',
				null,
				!hasLogin && loginRemindShow && loginRemindDom,
				popShow && _react2.default.createElement(_componentsv.TipPop, { btnTxt: popBtn, msg: popMsg, jump: popJump, onClose: this.popClose }),
				_react2.default.createElement(
					'div',
					{ className: 'np-main' },
					_react2.default.createElement(
						'div',
						{ className: 'np-buy-box' },
						_react2.default.createElement(_componentsv.ColorPic, { currColor: color, hasSoldout: false }),
						_react2.default.createElement(
							'div',
							{ className: 'np-buy-main' },
							hasDiscount ? (0, _purchase2.default)('mj_price_title') : _react2.default.createElement(
								'div',
								{ className: 'np-buy-text' },
								_react2.default.createElement(
									'h2',
									null,
									(0, _purchase2.default)('banner_title')
								),
								(0, _purchase2.default)('sub_title'),
								(0, _purchase2.default)('price_official_v2')
							),
							_react2.default.createElement(_componentsv.ColorSelector, { colorConfig: this.state.colorConfig, currColor: color, onChange: this.switchColor }),
							this.lang === 'cn' && _react2.default.createElement(TotalPrice, { price: totalPrice }),
							_react2.default.createElement(
								'div',
								{ className: 'np-buy-btn' },
								_react2.default.createElement(SubmitBtnRender, {
									loadingTime: loadingTime,
									onclick: this.submit,
									disabled: false })
							),
							(0, _purchase2.default)('goods_tip')
						)
					)
				)
			);
		}
	}]);

	return OpensalePurchaseV2;
}(_react.Component);

exports.default = OpensalePurchaseV2;


var SubmitBtnRender = function SubmitBtnRender(_ref2) {
	var loadingTime = _ref2.loadingTime,
	    onclick = _ref2.onclick,
	    disabled = _ref2.disabled;

	return disabled ? _react2.default.createElement(
		'a',
		{ href: 'javascript:;', className: 'btn-np btn-np-disable' },
		(0, _purchase2.default)('buy_now')
	) : _react2.default.createElement(
		'a',
		{ href: 'javascript:;', className: 'btn-np', onClick: onclick },
		(0, _purchase2.default)('buy_now'),
		loadingTime ? _react2.default.createElement('i', { className: 'i-oc-loading' }) : null
	);
};

var TotalPrice = function TotalPrice(_ref3) {
	var price = _ref3.price;

	return _react2.default.createElement(
		'div',
		{ className: 'np-buy-sum' },
		_react2.default.createElement(
			'p',
			null,
			'\u5408\u8BA1\uFF1A',
			_react2.default.createElement(
				'em',
				null,
				price
			),
			'\u5143'
		)
	);
};

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function stringToBytes(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function bytesToString(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function stringToBytes(str) {
      for (var bytes = [], i = 0; i < str.length; i++) {
        bytes.push(str.charCodeAt(i) & 0xFF);
      }return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function bytesToString(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++) {
        str.push(String.fromCharCode(bytes[i]));
      }return str.join('');
    }
  }
};

module.exports = charenc;

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    login_now: '立即登录 →',
    err_tryagain: '验证码服务器繁忙，请稍后重试(S)',
    input_phone: '请输入手机号码',
    phone_error: '手机号输入错误',
    input_imgcode: '请输入图形验证码',
    imgcode_error: '图形验证码输入错误',
    input_msg: '请输入短信验证码',
    msg_error: '短信验证码输入错误',
    checking: '校验中...',
    msg_sent: '短信验证码已发送',
    imgcode_tips: "图形验证码",
    get_phone_verify: '获取手机验证码',
    get_imgcode: '获取验证码',
    get_imgcode_after: '秒后重新获取',
    phone_verify: '手机短信验证码',
    login_by_phone: '手机验证登录',
    please_select: '请选择',
    cn: '中国(内地)',
    hk: '中国(香港)',
    logout: '退出'
};

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    login_now: '立即登入 →',
    err_tryagain: '驗證碼服務器繁忙，請稍後重試(S)',
    input_phone: '請輸入手機號碼',
    phone_error: '手機號輸入錯誤',
    input_imgcode: '請輸入圖形驗證碼',
    imgcode_error: '圖形驗證碼輸入錯誤',
    input_msg: '請輸入手機簡訊驗證碼',
    msg_error: '短信驗證碼輸入錯誤',
    checking: '校驗中...',
    msg_sent: '短信驗證碼已發送',
    imgcode_tips: "圖形驗證碼",
    get_phone_verify: '獲取手機驗證碼',
    get_imgcode: '獲取驗證碼',
    get_imgcode_after: '秒後重新獲取',
    phone_verify: '手機短信驗證碼',
    login_by_phone: '手機驗證登錄',
    please_select: '請選擇',
    cn: '中國(內地)',
    hk: '中國(香港)',
    logout: '登出'
};

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _common = __webpack_require__(9);

var _common2 = _interopRequireDefault(_common);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VALID_LANG = ['cn', 'hk'];

var Lang = function () {
    function Lang(langData) {
        _classCallCheck(this, Lang);

        this.data = langData;
        this.language = this._getLanguage();
        this.currData = this._getCurrData();
    }

    // cookie,lang属性判断语言
    // _getLanguage(){
    //     let browserLang = getCookie('lang') || 'cn'
    //     let lang = VALID_LANG.indexOf(browserLang) == -1 ? VALID_LANG[0] : browserLang
    //     console.log(lang)
    //     return lang
    // }

    //根据url来判断语言


    _createClass(Lang, [{
        key: '_getLanguage',
        value: function _getLanguage() {
            var browserLang = (0, _utils.getLang)(); //menu.js里定义的变量
            var lang = VALID_LANG.indexOf(browserLang) == -1 ? VALID_LANG[0] : browserLang;
            // console.log('18lang: '+lang);
            return lang;
        }
    }, {
        key: '_getCurrData',
        value: function _getCurrData() {
            var localLang = this.data[this.language] || {};
            var commonLang = _common2.default[this.language] || {};
            return _extends({}, commonLang, localLang);
        }
    }, {
        key: 'getText',
        value: function getText(key) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var text = this.currData[key] || '';
            if (typeof text == 'string' || typeof text == 'number') {
                for (var i in params) {
                    text = text.replace(':' + i, params[i]);
                }
            }
            return text;
        }
    }]);

    return Lang;
}();

module.exports = Lang;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Lang = __webpack_require__(5);

var _Lang2 = _interopRequireDefault(_Lang);

var _cn = __webpack_require__(271);

var _cn2 = _interopRequireDefault(_cn);

var _hk = __webpack_require__(272);

var _hk2 = _interopRequireDefault(_hk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var langIns = new _Lang2.default({ cn: _cn2.default, hk: _hk2.default });
module.exports = function lang(key, params) {
	return langIns.getText(key, params);
};

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var crypt = __webpack_require__(84),
      utf8 = __webpack_require__(42).utf8,
      isBuffer = __webpack_require__(85),
      bin = __webpack_require__(42).bin,


  // The core
  md5 = function md5(message, options) {
    // Convert to byte array
    if (message.constructor == String) {
      if (options && options.encoding === 'binary') message = bin.stringToBytes(message);else message = utf8.stringToBytes(message);
    } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);else if (!Array.isArray(message)) message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a = 1732584193,
        b = -271733879,
        c = -1732584194,
        d = 271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << l % 32;
    m[(l + 64 >>> 9 << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i + 0], 7, -680876936);
      d = FF(d, a, b, c, m[i + 1], 12, -389564586);
      c = FF(c, d, a, b, m[i + 2], 17, 606105819);
      b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i + 4], 7, -176418897);
      d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
      c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i + 7], 22, -45705983);
      a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
      d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i + 10], 17, -42063);
      b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
      a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
      d = FF(d, a, b, c, m[i + 13], 12, -40341101);
      c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
      b = FF(b, c, d, a, m[i + 15], 22, 1236535329);

      a = GG(a, b, c, d, m[i + 1], 5, -165796510);
      d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
      c = GG(c, d, a, b, m[i + 11], 14, 643717713);
      b = GG(b, c, d, a, m[i + 0], 20, -373897302);
      a = GG(a, b, c, d, m[i + 5], 5, -701558691);
      d = GG(d, a, b, c, m[i + 10], 9, 38016083);
      c = GG(c, d, a, b, m[i + 15], 14, -660478335);
      b = GG(b, c, d, a, m[i + 4], 20, -405537848);
      a = GG(a, b, c, d, m[i + 9], 5, 568446438);
      d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
      c = GG(c, d, a, b, m[i + 3], 14, -187363961);
      b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
      a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
      d = GG(d, a, b, c, m[i + 2], 9, -51403784);
      c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
      b = GG(b, c, d, a, m[i + 12], 20, -1926607734);

      a = HH(a, b, c, d, m[i + 5], 4, -378558);
      d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
      b = HH(b, c, d, a, m[i + 14], 23, -35309556);
      a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
      d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
      c = HH(c, d, a, b, m[i + 7], 16, -155497632);
      b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
      a = HH(a, b, c, d, m[i + 13], 4, 681279174);
      d = HH(d, a, b, c, m[i + 0], 11, -358537222);
      c = HH(c, d, a, b, m[i + 3], 16, -722521979);
      b = HH(b, c, d, a, m[i + 6], 23, 76029189);
      a = HH(a, b, c, d, m[i + 9], 4, -640364487);
      d = HH(d, a, b, c, m[i + 12], 11, -421815835);
      c = HH(c, d, a, b, m[i + 15], 16, 530742520);
      b = HH(b, c, d, a, m[i + 2], 23, -995338651);

      a = II(a, b, c, d, m[i + 0], 6, -198630844);
      d = II(d, a, b, c, m[i + 7], 10, 1126891415);
      c = II(c, d, a, b, m[i + 14], 15, -1416354905);
      b = II(b, c, d, a, m[i + 5], 21, -57434055);
      a = II(a, b, c, d, m[i + 12], 6, 1700485571);
      d = II(d, a, b, c, m[i + 3], 10, -1894986606);
      c = II(c, d, a, b, m[i + 10], 15, -1051523);
      b = II(b, c, d, a, m[i + 1], 21, -2054922799);
      a = II(a, b, c, d, m[i + 8], 6, 1873313359);
      d = II(d, a, b, c, m[i + 15], 10, -30611744);
      c = II(c, d, a, b, m[i + 6], 15, -1560198380);
      b = II(b, c, d, a, m[i + 13], 21, 1309151649);
      a = II(a, b, c, d, m[i + 4], 6, -145523070);
      d = II(d, a, b, c, m[i + 11], 10, -1120210379);
      c = II(c, d, a, b, m[i + 2], 15, 718787259);
      b = II(b, c, d, a, m[i + 9], 21, -343485551);

      a = a + aa >>> 0;
      b = b + bb >>> 0;
      c = c + cc >>> 0;
      d = d + dd >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md5._gg = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md5._hh = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };
  md5._ii = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return (n << s | n >>> 32 - s) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null) throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
  };
})();

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
      crypt = {
    // Bit-wise rotation left
    rotl: function rotl(n, b) {
      return n << b | n >>> 32 - b;
    },

    // Bit-wise rotation right
    rotr: function rotr(n, b) {
      return n << 32 - b | n >>> b;
    },

    // Swap big-endian to little-endian and vice versa
    endian: function endian(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++) {
        n[i] = crypt.endian(n[i]);
      }return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function randomBytes(n) {
      for (var bytes = []; n > 0; n--) {
        bytes.push(Math.floor(Math.random() * 256));
      }return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function bytesToWords(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8) {
        words[b >>> 5] |= bytes[i] << 24 - b % 32;
      }return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function wordsToBytes(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8) {
        bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
      }return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function bytesToHex(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function hexToBytes(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2) {
        bytes.push(parseInt(hex.substr(c, 2), 16));
      }return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function bytesToBase64(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
        for (var j = 0; j < 4; j++) {
          if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));else base64.push('=');
        }
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function base64ToBytes(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};

function isBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
}

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ImgCode = __webpack_require__(89);

var _ImgCode2 = _interopRequireDefault(_ImgCode);

var _SmsCode = __webpack_require__(90);

var _SmsCode2 = _interopRequireDefault(_SmsCode);

var _LoginBtn = __webpack_require__(91);

var _LoginBtn2 = _interopRequireDefault(_LoginBtn);

var _utils = __webpack_require__(1);

var _consts = __webpack_require__(2);

var _login = __webpack_require__(23);

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var api = {
    checklogin: _consts.ONECLOUD_API_HOST + '/user/checklogin',
    login: _consts.ONECLOUD_API_HOST + '/user/login',
    checkImgCode: _consts.ONECLOUD_API_HOST + '/user/smslimitremaining',
    freshImgCode: _consts.ONECLOUD_API_HOST + '/captcha/refresh',
    sendsmscode: _consts.ONECLOUD_API_HOST + '/user/sendsmscode'
};

var SMSCODE_NEED_IMGCODE = -500; // 发送短信验证码受限，需要输入图像验证码

var Login = function (_Component) {
    _inherits(Login, _Component);

    function Login(props) {
        _classCallCheck(this, Login);

        var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));

        var lang = (0, _utils.getLang)();
        var rootSite = '' + (0, _utils.getProtocol)() + location.hostname;

        _this.Timer60s = null;
        _this.TimerReload = null;
        _this.config = {
            loginPage: (0, _utils.createUrl)('html/login'),
            homePage: (0, _utils.createUrl)('site/index'),
            allowJumpSite: [rootSite, 'http://wanke.xunlei.com', 'http://wanke.onethingcloud.com'],
            maxTime: 5,
            reloadIntval: 5000,
            count: 0,
            phoneArea: {
                cn: {
                    name: (0, _login2.default)('cn'),
                    num: '86',
                    phoneLength: 11,
                    reg: /^(13|14|15|16|17|18|19)[\d]{9}$/
                },
                hk: {
                    name: (0, _login2.default)('hk'),
                    num: '852',
                    phoneLength: 8,
                    reg: /^\d{8}$/
                }
            }
        };
        _this.queryParams = {
            isPc: (0, _utils.browser)('pc') ? true : false
        };

        _this.state = {
            lang: lang,
            checkedArea: lang,
            isSelectAreaOn: false,
            phone: '',
            imgCode: '',
            smsCode: '',
            imgCodeSrc: '',
            isImgLoadingOn: false,
            freeImgCodeTimes: 1, // 免图形验证码次数
            showImgCode: false,
            phoneError: '',
            imgCodeError: '',
            smsCodeError: '',
            showErrorMsg: '',
            checkedProtocal: false,
            protocolTip: '请阅读并同意协议',
            protocolMsg: '',
            // codeCheck: '',
            secs: 0,
            pop: null,
            lock: false
        };

        _this.handleFreshImgCode = _this.handleFreshImgCode.bind(_this);
        _this.handleImgCodeChange = _this.handleImgCodeChange.bind(_this);
        _this.handleSendSmsCode = _this.handleSendSmsCode.bind(_this);
        _this.handleSmsCodeChange = _this.handleSmsCodeChange.bind(_this);
        _this.validSmsCode = _this.validSmsCode.bind(_this);
        _this.validImgCode = _this.validImgCode.bind(_this);
        _this.toLogin = _this.toLogin.bind(_this);
        _this.listenLogin = _this.listenLogin.bind(_this);
        _this.toggleCheckProtocol = _this.toggleCheckProtocol.bind(_this);
        return _this;
    }

    _createClass(Login, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // 防止登录后进入登录页，因公用检查顺序在后
            this.checkLoginIfLoginPage();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this.Timer60s);
            clearInterval(this.TimerReload);
        }
    }, {
        key: 'handleSendSmsCode',
        value: function handleSendSmsCode() {
            var _this2 = this;

            var _state = this.state,
                freeImgCodeTimes = _state.freeImgCodeTimes,
                showImgCode = _state.showImgCode,
                lock = _state.lock;

            if (!this.validPhone() || lock) {
                return;
            }
            if (!freeImgCodeTimes && !showImgCode) {
                this.setState({
                    showImgCode: true
                }, function () {
                    _this2.loadImgCode();
                });
                return;
            }
            if (!freeImgCodeTimes && !this.validImgCode()) return;

            var _state2 = this.state,
                phone = _state2.phone,
                imgCode = _state2.imgCode,
                checkedArea = _state2.checkedArea;
            // const codeCheck = showImgCode ? t('checking') : ''

            this.setState({
                lock: true,
                // codeCheck,
                smsCode: '',
                imgCodeError: '',
                smsCodeError: ''
            });
            var data = {
                phone: phone,
                phone_area: this.config.phoneArea[checkedArea].num,
                type: 0, // 验证码类型(0-短信, 1-语音)
                imgcode: imgCode
            };

            (0, _utils.setCookie)('phone', phone); // 后端用到
            $.ajax({
                type: 'POST',
                url: api.sendsmscode,
                data: data,
                dataType: 'json',
                crossDomain: true,
                xhrFields: { withCredentials: true },
                cache: false,
                ifModified: true,
                success: function success(res) {
                    var code = res.iRet;
                    switch (code) {
                        case 0:
                            _this2.setState({
                                // codeCheck: '',
                                freeImgCodeTimes: res.data.limit_remaining,
                                lock: false
                            });
                            _this2.startTimer60s();
                            return;
                        default:
                            var _showImgCode = _this2.state.showImgCode;

                            if (code !== SMSCODE_NEED_IMGCODE) {
                                _showImgCode ? _this2.showErrorMsg('imgCode', res.sMsg) : _this2.showErrorMsg('smsCode', res.sMsg);
                            }
                            _this2.setState({
                                lock: false,
                                // codeCheck: '',
                                showImgCode: true,
                                freeImgCodeTimes: 0
                            });
                            _this2.loadImgCode();
                    }
                },
                error: function error() {
                    _this2.showErrorMsg('smsCode', (0, _login2.default)('err_tryagain'));
                    _this2.loadImgCode();
                    _this2.setState({ lock: false });
                }
            });
        }
    }, {
        key: 'handlePhoneChange',
        value: function handlePhoneChange(e) {
            var _this3 = this;

            var checkedArea = this.state.checkedArea;

            var val = e.target.value;
            var len = this.config.phoneArea[checkedArea].phoneLength;
            var phoneLen = val.length;
            var phone = phoneLen < len ? val : val.slice(0, len);
            this.setState({
                phone: phone,
                phoneError: ''
            }, function () {
                if (phoneLen === len && _this3.validPhone()) {
                    _this3.checkImgCode();
                    _this3.state.showImgCode && _this3.loadImgCode();
                }
            });
        }
    }, {
        key: 'handleImgCodeChange',
        value: function handleImgCodeChange(e) {
            var val = e.target.value;
            this.setState({
                imgCode: val,
                imgCodeError: ''
                // codeCheck: ''
            });
        }
    }, {
        key: 'handleFreshImgCode',
        value: function handleFreshImgCode() {
            this.setState({
                imgCode: ''
            });
            this.loadImgCode();
        }
    }, {
        key: 'handleSmsCodeChange',
        value: function handleSmsCodeChange(e) {
            this.setState({
                smsCode: e.target.value,
                smsCodeError: ''
            });
        }
    }, {
        key: 'toggleCheckProtocol',
        value: function toggleCheckProtocol() {
            var protocolTip = this.state.protocolTip;

            this.setState(function (prevState) {
                return {
                    checkedProtocal: !prevState.checkedProtocal,
                    protocolMsg: !prevState.checkedProtocal ? '' : protocolTip
                };
            });
        }
    }, {
        key: 'checkLoginIfLoginPage',
        value: function checkLoginIfLoginPage() {
            if (location.href.indexOf(this.config.loginPage) !== -1) {
                this.checkLogin();
            }
        }
    }, {
        key: 'checkLogin',
        value: function checkLogin() {
            var _this4 = this;

            var doneCb = function doneCb(res) {
                +res.iRet === 0 && _this4.loginSuccess(res.data);
            };
            (0, _utils.postPromise)(api.checklogin).done(doneCb);
        }
    }, {
        key: 'toLogin',
        value: function toLogin(e) {
            var _this5 = this;

            e.preventDefault();
            var validPass = true;
            !this.validPhone() && (validPass = false);
            !this.validSmsCode() && (validPass = false);
            this.state.lang === 'cn' && !this.validProtocol() && (validPass = false);
            if (!validPass) return;

            this.setState({ lock: true });
            var _state3 = this.state,
                phone = _state3.phone,
                smsCode = _state3.smsCode,
                checkedArea = _state3.checkedArea;

            var data = {
                phone: phone,
                phone_area: this.config.phoneArea[checkedArea].num,
                vcode: smsCode
            };
            $.ajax({
                type: 'POST',
                url: api.login,
                data: data,
                dataType: 'json',
                crossDomain: true,
                xhrFields: { withCredentials: true },
                cache: false,
                ifModified: true,
                success: function success(res) {
                    _this5.setState({ lock: false });
                    var pageId = PAGE_ID;
                    if (res.iRet === 0) {
                        haboStat({
                            pageid: pageId,
                            action: 'login_result',
                            other: {
                                result: 'succ'
                            }
                        });
                        setTimeout(function () {
                            // 留给上报时间
                            var data = res.data;
                            // this.setSiteCookies(data)
                            // this.setOtherSiteCookies(data)

                            _this5.loginSuccess(data);
                        }, 50);
                    } else {
                        haboStat({
                            pageid: pageId,
                            action: 'login_result',
                            other: {
                                result: 'fail'
                            }
                        });
                        _this5.showErrorMsg('smsCode', res.sMsg);
                    }
                },
                error: function error() {
                    haboStat({
                        pageid: PAGE_ID,
                        action: 'login_result',
                        other: {
                            result: 'fail'
                        }
                    });
                    _this5.showErrorMsg('smsCode', (0, _login2.default)('err_tryagain'));
                    _this5.setState({ lock: false });
                }
            });
        }
    }, {
        key: 'checkImgCode',
        value: function checkImgCode() {
            var _this6 = this;

            var _state4 = this.state,
                phone = _state4.phone,
                checkedArea = _state4.checkedArea;

            var doneCb = function doneCb(res) {
                var success = function success(data) {
                    var freeImgCodeTimes = data.limit_remaining;

                    var showImgCode = freeImgCodeTimes > 0 ? false : true;
                    _this6.setState({
                        freeImgCodeTimes: freeImgCodeTimes,
                        showImgCode: showImgCode
                    }, function () {
                        return showImgCode && _this6.loadImgCode();
                    });
                };
                res.iRet === 0 && success(res.data);
            };
            var data = {
                phone: phone,
                phone_area: this.config.phoneArea[checkedArea].num
            };
            (0, _utils.postPromise)(api.checkImgCode, data).done(doneCb);
        }
    }, {
        key: 'loadImgCode',
        value: function loadImgCode() {
            var _this7 = this;

            if (!this.validPhone(true)) return;

            this.setState({
                isImgLoadingOn: true
            });
            this.getImgCode();
            clearInterval(this.TimerReload);
            this.TimerReload = setInterval(function () {
                if (_this7.config.count < _this7.config.maxTime) {
                    _this7.config.count += 1;
                    _this7.getImgCode();
                } else {
                    clearInterval(_this7.TimerReload);
                    _this7.showErrorMsg('imgCode', (0, _login2.default)('err_tryagain'));
                }
            }, this.config.reloadIntval);
        }
    }, {
        key: 'getImgCode',
        value: function getImgCode() {
            var _this8 = this;

            var doneCb = function doneCb(res) {
                var success = function success(data) {
                    clearInterval(_this8.TimerReload);
                    _this8.config.count = 0;
                    _this8.setState({
                        isImgLoadingOn: false,
                        imgCodeSrc: data.image_base64
                    });
                };
                res.iRet === 0 && success(res.data);
            };
            var data = {
                captcha_len: 4
            };
            (0, _utils.postPromise)(api.freshImgCode, data).done(doneCb);
        }
    }, {
        key: 'startTimer60s',
        value: function startTimer60s() {
            var _this9 = this;

            clearInterval(this.Timer60s);
            this.setState({
                secs: 60
            });
            this.Timer60s = setInterval(function () {
                var secs = _this9.state.secs;
                if (secs > 0) {
                    secs -= 1;
                    _this9.setState({
                        secs: secs
                    });
                } else {
                    clearInterval(_this9.Timer60s);
                    _this9.setState({
                        secs: 0
                    });
                }
            }, 1000);
        }
    }, {
        key: 'validPhone',
        value: function validPhone() {
            var _state5 = this.state,
                checkedArea = _state5.checkedArea,
                phone = _state5.phone;

            var val = $.trim(phone);
            var reg = this.config.phoneArea[checkedArea].reg;

            if (!val) {
                this.showErrorMsg('phone', (0, _login2.default)('input_phone'));
                return false;
            } else if (!reg.test(val)) {
                this.showErrorMsg('phone', (0, _login2.default)('phone_error'));
                return false;
            }
            return true;
        }
    }, {
        key: 'validImgCode',
        value: function validImgCode() {
            var val = $.trim(this.state.imgCode);
            var reg = /^[0-9a-z]{4}$/i;
            if (!val) {
                this.showErrorMsg('imgCode', (0, _login2.default)('input_imgcode'));
                return false;
            } else if (!reg.test(val)) {
                this.showErrorMsg('imgCode', (0, _login2.default)('imgcode_error'));
                return false;
            }
            return true;
        }
    }, {
        key: 'validSmsCode',
        value: function validSmsCode() {
            var val = $.trim(this.state.smsCode);
            if (!val) {
                this.showErrorMsg('smsCode', (0, _login2.default)('input_msg'));
                return false;
            } else if (!/^\d{6}$/.test(val)) {
                this.showErrorMsg('smsCode', (0, _login2.default)('msg_error'));
                return false;
            }
            return true;
        }
    }, {
        key: 'validProtocol',
        value: function validProtocol() {
            var _state6 = this.state,
                checkedProtocal = _state6.checkedProtocal,
                protocolTip = _state6.protocolTip;

            var msg = '';
            var pass = true;
            if (!checkedProtocal) {
                pass = false;
                msg = protocolTip;
            }
            this.setState({
                protocolMsg: msg
            });
            return pass;
        }
    }, {
        key: 'showErrorMsg',
        value: function showErrorMsg(field, msg) {
            this.setState(_defineProperty({}, field + 'Error', msg));
        }
    }, {
        key: 'listenLogin',
        value: function listenLogin(e) {
            if (e.keyCode === 13) {
                this.toLogin(e);
            }
        }
    }, {
        key: 'afterLoginNav',
        value: function afterLoginNav() {
            var hidePhone = keepPhoneEnd4((0, _utils.getCookie)('phone'));
            try {
                isPc ? loginID.html(hidePhone).attr('href', 'javascript:') : loginId.attr('href', 'javascript:').addClass('on');
                if (isBusinessUser) {
                    businessNav.show();
                    personalNav.hide();
                } else {
                    businessNav.hide();
                    personalNav.show();
                }
                afterLoginDom.show();
            } catch (e) {}
        }

        /* setSiteCookies(data) {
            // 后台接口写的cookie在.com下，.cn需要js来写
            if (window.LANG === 'cn') {
                var domain = location.host.replace('wky','')
                setCookie('phone', this.state.phone, 32*60, domain); // 32小时
                setCookie('phonearea', this.config.phoneArea, 32*60, domain)
                setCookie(`csrf_token`, data.csrf_token, 32*60, domain)
            }
        } */

        // setOtherSiteCookies(data) {
        //     if (location.host.substr(-4) == '.com' && !sessionStorage.getItem('cnCookieMaker')) {
        //         sessionStorage.setItem('cnCookieMaker', 1)
        //         location.href = `//www.onethingcloud.cn/cookie/maker.html?redirect=${encodeURIComponent(location.href)}&csrftoken=${data.csrf_token}`
        //     }
        // }

    }, {
        key: 'keepPhoneEnd4',
        value: function keepPhoneEnd4(phone) {
            return phone ? phone.replace(new RegExp('\\d{' + (phone.length - 4) + '}(\\d{4})'), "***$1") : "";
        }
    }, {
        key: 'loginSuccess',
        value: function loginSuccess(data) {
            var loginCallback = this.props.loginCallback;

            if (loginCallback && typeof loginCallback === 'function') {
                // this.setLoginNav(data)
                loginCallback();
            } else {
                this.loginJump();
            }
        }

        // setLoginNav(data) { // 登录弹窗情况用
        //     try {
        //         const { isPc } = this.queryParams
        //         const { entStatus } = data
        //         const isBusinessUser = entStatus === 1 || entStatus === 3 ? true : false
        //         const loginId = $('#loginID')
        //         const businessNav = $('.business_js')
        //         const personalNav = $('.personal_js')
        //         const afterLoginDom = $('.after_login_js')
        //         const hidePhone = this.keepPhoneEnd4(getCookie('phone'))

        //         // cn-nav
        // 		isPc ? loginId.html(hidePhone).attr('href', 'javascript:') : loginId.attr('href', 'javascript:').addClass('on')
        // 		if (isBusinessUser) {
        // 			businessNav.show()
        // 			personalNav.hide()
        // 		} else {
        // 			businessNav.hide()
        // 			personalNav.show()
        // 		}
        //         afterLoginDom.show()
        //         // hk
        //     // $('div.nav_show_js').show()
        //     // $('#loginID').html(t('logout')).attr('href', 'javascript:').addClass('logout_js')
        //     // $('#accountID').html(hidePhone).show()
        // 	} catch(e) {
        //         console.log(e)
        //     }
        // }

    }, {
        key: 'loginJump',
        value: function loginJump() {
            var homePage = this.config.homePage;
            var jumpUrl = decodeURIComponent((0, _utils.getParams)('jumpurl') || homePage);
            location.href = this.checkUrlSafe(jumpUrl) ? jumpUrl : homePage;
        }
    }, {
        key: 'checkUrlSafe',
        value: function checkUrlSafe(url) {
            !Array.prototype.find && this.hackForArrayFind();
            var urlReg = /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
            var pathReg = /^\/([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
            var isAllowSite = this.config.allowJumpSite.find(function (item) {
                var reg = new RegExp('^(' + item + ')(?=\\/|\\?|$)');
                return reg.test(url) ? true : false;
            });
            return urlReg.test(url) && isAllowSite ? true : pathReg.test(url) ? true : false;
        }
    }, {
        key: 'toggleSelectArea',
        value: function toggleSelectArea() {
            this.setState({ isSelectAreaOn: !this.state.isSelectAreaOn });
        }
    }, {
        key: 'selectArea',
        value: function selectArea(area) {
            var _this10 = this;

            this.setState({
                checkedArea: area,
                isSelectAreaOn: false,

                // reset
                phone: '',
                imgCode: '',
                imgCodeSrc: '',
                isImgLoadingOn: false,
                smsCode: '',
                phoneError: '',
                imgCodeError: '',
                smsCodeError: '',
                showErrorMsg: '',
                // codeCheck: '',
                secs: 0,
                pop: null,
                lock: false
            }, function () {
                _this10.loadImgCode();
            });
        }
    }, {
        key: 'getSelectAreaDom',
        value: function getSelectAreaDom(data) {
            var _this11 = this;

            var areaDom = [];

            var _loop = function _loop(i) {
                var item = data[i];
                areaDom.push(_react2.default.createElement(
                    'dd',
                    { key: i, onClick: function onClick(e) {
                            return _this11.selectArea(i, e);
                        } },
                    item.name,
                    _react2.default.createElement(
                        'span',
                        { className: 'oc-abs' },
                        '+',
                        item.num
                    )
                ));
            };

            for (var i in data) {
                _loop(i);
            }
            return areaDom;
        }
    }, {
        key: 'hackForArrayFind',
        value: function hackForArrayFind() {
            Object.defineProperty(Array.prototype, 'find', {
                value: function value(predicate) {
                    if (this == null) {
                        throw new TypeError('"this" is null or not defined');
                    }
                    var o = Object(this);
                    var len = o.length >>> 0;
                    if (typeof predicate !== 'function') {
                        throw new TypeError('predicate must be a function');
                    }
                    var thisArg = arguments[1];
                    var k = 0;
                    var kValue = void 0;
                    while (k < len) {
                        kValue = o[k];
                        if (predicate.call(thisArg, kValue, k, o)) {
                            return kValue;
                        }
                        k++;
                    }
                    return undefined;
                }
            });
        }
    }, {
        key: 'renderPhone',
        value: function renderPhone() {
            var _this12 = this;

            var _state7 = this.state,
                phone = _state7.phone,
                phoneError = _state7.phoneError,
                checkedArea = _state7.checkedArea,
                isSelectAreaOn = _state7.isSelectAreaOn,
                secs = _state7.secs;

            var phoneAreaData = this.config.phoneArea;
            var selectAreaDom = this.getSelectAreaDom(phoneAreaData);

            return _react2.default.createElement(
                'div',
                { className: 'oc-inp' },
                _react2.default.createElement(
                    'div',
                    { className: 'oc-inpbox oc-inpbox-zone' },
                    secs ? _react2.default.createElement('input', { className: 'oc-inptxt', type: 'text', value: phone, disabled: true }) : _react2.default.createElement('input', { className: 'oc-inptxt', type: 'text', value: phone, placeholder: (0, _login2.default)('input_phone'), maxLength: this.config.phoneArea[checkedArea].phoneLength, onChange: function onChange(e) {
                            return _this12.handlePhoneChange(e);
                        }, onBlur: function onBlur() {
                            return _this12.validPhone();
                        } }),
                    _react2.default.createElement(
                        'div',
                        { className: 'oc-zonebox', onClick: function onClick() {
                                return _this12.toggleSelectArea();
                            } },
                        _react2.default.createElement(
                            'p',
                            { className: 'oc-zone-txt' },
                            '+',
                            phoneAreaData[checkedArea].num
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'oc-zone-list', style: { display: isSelectAreaOn ? "" : "none" } },
                        _react2.default.createElement(
                            'dl',
                            null,
                            _react2.default.createElement(
                                'dt',
                                null,
                                (0, _login2.default)('please_select')
                            ),
                            selectAreaDom
                        )
                    )
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'oc-err' },
                    phoneError
                )
            );
        }
    }, {
        key: 'renderProtocol',
        value: function renderProtocol() {
            var _state8 = this.state,
                checkedProtocal = _state8.checkedProtocal,
                protocolMsg = _state8.protocolMsg;

            return _react2.default.createElement(
                'div',
                { className: 'oc-protocol oc-protocol-log' },
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement('input', { type: 'checkbox', checked: checkedProtocal, onClick: this.toggleCheckProtocol }),
                    _react2.default.createElement(
                        'label',
                        { onClick: this.toggleCheckProtocol },
                        '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F '
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: (0, _utils.createUrl)('site/law'), target: '_blank' },
                        '\u7F51\u7AD9\u670D\u52A1\u534F\u8BAE'
                    ),
                    ' \u548C ',
                    _react2.default.createElement(
                        'a',
                        { href: (0, _utils.createUrl)('site/law', { tab: 2 }), target: '_blank' },
                        '\u9690\u79C1\u653F\u7B56'
                    )
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'oc-err' },
                    protocolMsg
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var btnName = this.props.buttonName;
            var _state9 = this.state,
                lock = _state9.lock,
                showImgCode = _state9.showImgCode,
                lang = _state9.lang,
                isImgLoadingOn = _state9.isImgLoadingOn,
                imgCode = _state9.imgCode,
                imgCodeSrc = _state9.imgCodeSrc,
                imgCodeError = _state9.imgCodeError,
                smsCode = _state9.smsCode,
                smsCodeError = _state9.smsCodeError,
                secs = _state9.secs;


            var imgCodeData = {
                isImgLoadingOn: isImgLoadingOn,
                imgCode: imgCode,
                imgCodeSrc: imgCodeSrc,
                imgCodeError: imgCodeError,
                // codeCheck,
                onImgCodeChange: this.handleImgCodeChange,
                onImgCodeBlur: this.validImgCode,
                onImgCodeFresh: this.handleFreshImgCode
            };

            var smsCodeData = {
                smsCode: smsCode, smsCodeError: smsCodeError, secs: secs,
                onSmsCodeChange: this.handleSmsCodeChange,
                onSmsCodeKeyDown: this.listenLogin,
                onSmsCodeBlur: this.validSmsCode,
                onSendSmsCode: this.handleSendSmsCode
            };

            var loginBtnData = {
                lock: lock,
                btnName: btnName,
                onClickLogin: this.toLogin
            };

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    { className: 'oc-log-form' },
                    _react2.default.createElement(
                        'a',
                        { className: 'oc-logo2', href: '#' },
                        (0, _login2.default)('wky')
                    ),
                    _react2.default.createElement(
                        'h3',
                        null,
                        (0, _login2.default)('login_by_phone')
                    ),
                    this.renderPhone(),
                    showImgCode && _react2.default.createElement(_ImgCode2.default, imgCodeData),
                    _react2.default.createElement(_SmsCode2.default, smsCodeData),
                    _react2.default.createElement(_LoginBtn2.default, loginBtnData),
                    lang === 'cn' && this.renderProtocol()
                )
            );
        }
    }]);

    return Login;
}(_react.Component);

exports.default = Login;

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _login = __webpack_require__(23);

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImgCode = function ImgCode(props) {
    var isImgLoadingOn = props.isImgLoadingOn,
        imgCode = props.imgCode,
        imgCodeSrc = props.imgCodeSrc,
        imgCodeError = props.imgCodeError,
        onImgCodeChange = props.onImgCodeChange,
        onImgCodeBlur = props.onImgCodeBlur,
        onImgCodeFresh = props.onImgCodeFresh;

    var codeDom = null;
    if (imgCodeError) {
        codeDom = _react2.default.createElement(
            'p',
            { className: 'oc-err' },
            imgCodeError
        );
    }
    // else if (codeCheck ) {
    //     codeDom = <p className="oc-err oc-err-check">{codeCheck}</p>
    // }

    return _react2.default.createElement(
        'div',
        { className: 'oc-inp' },
        _react2.default.createElement(
            'div',
            { className: 'oc-inpbox oc-inpbox-code' },
            _react2.default.createElement('input', { className: 'oc-inptxt', type: 'text', placeholder: (0, _login2.default)('imgcode_tips'), maxLength: '4', value: imgCode, onChange: function onChange(e) {
                    return onImgCodeChange(e);
                }, onBlur: function onBlur() {
                    return onImgCodeBlur();
                } })
        ),
        codeDom,
        _react2.default.createElement(
            'a',
            { className: 'btn-oc btn-oc-code' },
            !isImgLoadingOn ? imgCodeSrc ? _react2.default.createElement('img', { src: imgCodeSrc, onClick: function onClick() {
                    return onImgCodeFresh();
                } }) : null : _react2.default.createElement(
                'span',
                { className: 'oc-loading-gif' },
                _react2.default.createElement('img', { src: '/images/purchase/loading.gif' })
            )
        )
    );
};

exports.default = ImgCode;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _hk = __webpack_require__(10);

var _hk2 = _interopRequireDefault(_hk);

var _cn = __webpack_require__(11);

var _cn2 = _interopRequireDefault(_cn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
	hk: _hk2.default, cn: _cn2.default
};

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _login = __webpack_require__(23);

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmsCode = function SmsCode(props) {
    var smsCode = props.smsCode,
        smsCodeError = props.smsCodeError,
        secs = props.secs,
        onSmsCodeChange = props.onSmsCodeChange,
        onSmsCodeKeyDown = props.onSmsCodeKeyDown,
        onSmsCodeBlur = props.onSmsCodeBlur,
        onSendSmsCode = props.onSendSmsCode;


    var sendCodeBtn = secs === 0 ? _react2.default.createElement(
        'a',
        { href: 'javascript:', className: 'btn-oc btn-oc-code', onClick: function onClick(e) {
                return onSendSmsCode(e);
            } },
        (0, _login2.default)('get_imgcode')
    ) : _react2.default.createElement(
        'a',
        { href: 'javascript:', className: 'btn-oc btn-oc-code btn-oc-disable' },
        secs,
        (0, _login2.default)('get_imgcode_after')
    );

    return _react2.default.createElement(
        'div',
        { className: 'oc-inp' },
        _react2.default.createElement(
            'div',
            { className: 'oc-inpbox oc-inpbox-code' },
            _react2.default.createElement('input', { className: 'oc-inptxt', type: 'text', value: smsCode, placeholder: (0, _login2.default)('phone_verify'), maxLength: '6', onChange: function onChange(e) {
                    return onSmsCodeChange(e);
                }, onKeyDown: function onKeyDown(e) {
                    return onSmsCodeKeyDown(e);
                }, onBlur: function onBlur() {
                    return onSmsCodeBlur();
                } })
        ),
        _react2.default.createElement(
            'p',
            { className: 'oc-err' },
            smsCodeError
        ),
        sendCodeBtn
    );
};

exports.default = SmsCode;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginBtn = function LoginBtn(props) {
    var lock = props.lock,
        btnName = props.btnName,
        onClickLogin = props.onClickLogin;


    return _react2.default.createElement(
        "div",
        { className: "oc-btnbox" },
        lock ? _react2.default.createElement(
            "a",
            { href: "javascript:", className: "btn-oc btn-oc-disable" },
            btnName
        ) : _react2.default.createElement(
            "a",
            { href: "javascript:", className: "btn-oc", onClick: onClickLogin },
            btnName
        )
    );
};

exports.default = LoginBtn;

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.bindPopupTrigger = bindPopupTrigger;
exports.saleAjax = saleAjax;
exports.checkLogin = checkLogin;
exports.createOrder = createOrder;
exports.jumpToLogin = jumpToLogin;
exports.getPriceConfig = getPriceConfig;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _popupbox = __webpack_require__(98);

var _popupbox2 = _interopRequireDefault(_popupbox);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function bindPopupTrigger(Children) {
	return function (_Component) {
		_inherits(PopupTrigger, _Component);

		function PopupTrigger(props) {
			_classCallCheck(this, PopupTrigger);

			var _this = _possibleConstructorReturn(this, (PopupTrigger.__proto__ || Object.getPrototypeOf(PopupTrigger)).call(this, props));

			_this.state = {
				popData: {
					isOpen: false,
					msg: 'hello',
					jump: '',
					btnTxt: '确定'
				}
			};
			_this.changePopData = _this.changePopData.bind(_this);
			_this.popClose = _this.popClose.bind(_this);
			return _this;
		}

		_createClass(PopupTrigger, [{
			key: 'popClose',
			value: function popClose() {
				var popData = this.state.popData;

				this.setState({
					popData: _extends({}, popData, {
						isOpen: false
					})
				});
			}
		}, {
			key: 'changePopData',
			value: function changePopData(_ref) {
				var msg = _ref.msg,
				    jump = _ref.jump,
				    btnTxt = _ref.btnTxt;

				console.log(msg, jump, btnTxt);
				this.setState({
					popData: {
						isOpen: true,
						msg: msg,
						jump: jump,
						btnTxt: btnTxt
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var popData = this.state.popData;

				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(Children, { changePopData: this.changePopData }),
					_react2.default.createElement(_popupbox2.default, _extends({}, popData, { onClose: this.popClose }))
				);
			}
		}]);

		return PopupTrigger;
	}(_react.Component);
}
function saleAjax(opts) {
	var path = opts.path,
	    type = opts.type,
	    data = opts.data,
	    success = opts.success,
	    error = opts.error,
	    others = _objectWithoutProperties(opts, ['path', 'type', 'data', 'success', 'error']);

	var _data = type.toLowerCase() === 'post' ? _extends({ csrf_token: (0, _utils.getCookie)('csrf_token') }, data) : data;
	$.ajax(_extends({
		url: '//api-content.onethingcloud.com/cn/' + path,
		type: type || 'POST',
		data: _data,
		success: success || function (result) {
			console.log(result);
		},
		error: error || function (err) {
			console.log(err);
		},
		crossDomain: true,
		xhrFields: { withCredentials: true },
		cache: false,
		ifModified: true
	}, others));
}
function checkLogin(success) {
	saleAjax({
		path: 'user/checklogin',
		success: success
	});
}
function createOrder(_ref2) {
	var data = _ref2.data,
	    success = _ref2.success;

	saleAjax({
		path: 'eprocurement/order/create',
		data: data,
		success: success
	});
}
function jumpToLogin() {
	location.href = (0, _utils.createUrl)('html/login') + '?jumpurl=' + encodeURIComponent(location.href);
}
function getPriceConfig(success) {
	saleAjax({
		path: 'eprocurement/order/config',
		type: 'GET',
		success: success
	});
}

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 消息弹窗V2
 * 
 * @export
 * @class TipPop
 * @extends {Component}
 * isOpen - 控制弹窗是否开启
 * msg—— 弹窗主体内容，支持html元素
 * jump—— 如果存在，并为函数，则点击执行自定义函数
 * 		  如果存在，并且为字符串，则点击跳转到自定义链接
 * 		  其他情况，默认确认按钮为关闭弹窗
 * onClose——如果为函数，则为关闭弹窗的回调函数
 * 			如果为false，则不设置确认按钮和关闭按钮
 * btnTxt——按钮文字 
 */
var PopUp = function (_Component) {
	_inherits(PopUp, _Component);

	function PopUp(props) {
		_classCallCheck(this, PopUp);

		var _this = _possibleConstructorReturn(this, (PopUp.__proto__ || Object.getPrototypeOf(PopUp)).call(this, props));

		_this.btnRender = _this.btnRender.bind(_this);
		return _this;
	}

	_createClass(PopUp, [{
		key: 'btnRender',
		value: function btnRender() {
			var _props = this.props,
			    jump = _props.jump,
			    onClose = _props.onClose,
			    btnTxt = _props.btnTxt;

			var jumpType = jump && (typeof jump === 'undefined' ? 'undefined' : _typeof(jump));
			var noBtnRender = function noBtnRender() {
				return _react2.default.createElement('div', { className: 'oc-pop-btnbox' });
			};
			var btnRenderInner = function btnRenderInner() {
				var submitBtn = function submitBtn() {
					if (jumpType == 'function') {
						return _react2.default.createElement(
							'a',
							{ href: 'javascript:;', className: 'btn-oc', onClick: function onClick() {
									jump();onClose();
								} },
							btnTxt
						);
					} else if (jumpType == 'string') {
						return _react2.default.createElement(
							'a',
							{ href: jump, className: 'btn-oc' },
							btnTxt
						);
					} else {
						return _react2.default.createElement(
							'a',
							{ href: 'javascript:;', className: 'btn-oc', onClick: onClose },
							btnTxt
						);
					}
				};
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'oc-pop-btnbox' },
						submitBtn()
					),
					_react2.default.createElement(
						'a',
						{ href: 'javascript:;', className: 'oc-pop-close', onClick: onClose },
						'\u5173\u95ED'
					)
				);
			};
			return onClose ? btnRenderInner() : noBtnRender();
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    isOpen = _props2.isOpen,
			    msg = _props2.msg;

			var dangerousInnerHTML = {
				__html: msg
			};
			return isOpen ? _react2.default.createElement(
				'div',
				{ className: 'oc-pop' },
				_react2.default.createElement(
					'div',
					{ className: 'oc-pop-wp' },
					_react2.default.createElement(
						'div',
						{ className: 'oc-pop-textbox oc-tb' },
						_react2.default.createElement('div', { className: 'oc-pop-text oc-tb-cell',
							dangerouslySetInnerHTML: dangerousInnerHTML })
					),
					this.btnRender()
				)
			) : null;
		}
	}]);

	return PopUp;
}(_react.Component);

exports.default = PopUp;

PopUp.defaultProps = {
	isOpen: false,
	msg: 'hello breeze',
	jump: '',
	onClose: function onClose() {
		return console.log("this is a default func (●'◡'●)ﾉ♥");
	},
	btnTxt: '确定'
};

/***/ })

},[266]);


// WEBPACK FOOTER //
// purchase.dist.js